/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbsencesListParams,
  ClientError,
  ColorDefinitionDto,
  ContactCodeResponse,
  ContactCodeTreeQueue,
  ContactCodeTreeRoot,
  ContactCodeTreeSummary,
  ContactCodeTreesListParams,
  ContactCodesListParams,
  ContactSettingsDto,
  CreateAbsenceRequest,
  CreateCustomPropertiesRequest,
  CreateCustomPropertyRequest,
  CreateOrUpdateContactCodeRequest,
  CreateOrUpdateContactCodeTreeRequest,
  CreateOrUpdateContactSettingsRequest,
  CreateOrUpdateCustomPageRequest,
  CreateOrUpdateGeneralSettingsRequest,
  CreateOrUpdateLoginSettingsRequest,
  CreateOrUpdatePauseReasonRequest,
  CreateOrUpdatePhoneSettingsRequest,
  CreateOrUpdateQueueRequest,
  CreateOrUpdateRecordingSettingsRequest,
  CreateOrUpdateRoleRequest,
  CreateOrUpdateRuleSetRequest,
  CreateOrUpdateSetClipSettingsRequest,
  CreateOrUpdateSkillGroupRequest,
  CreateOrUpdateSkillRequest,
  CreateOrUpdateSubstitutionSettingsRequest,
  CreateOrUpdateTeamRequest,
  CreateTeamQueueResponse,
  CreateTemplateRequest,
  CustomPageDto,
  CustomPagesListParams,
  CustomPagesRelationsTeamsAssignedParams,
  CustomPagesRelationsTeamsAvailableParams,
  CustomPagesRelationsUsersAssignedParams,
  CustomPagesRelationsUsersAvailableParams,
  CustomPropertiesListParams,
  CustomPropertiesRelationsRuleSetsAssignedParams,
  CustomPropertiesRelationsRuleSetsAvailableParams,
  CustomPropertyDetails,
  CustomPropertyDto,
  CustomPropertyRuleSetDto,
  ExtendedUserDto,
  GeneralSettingsDto,
  GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams,
  GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams,
  GetAdminContactCodeTreesContactCodeTreeIdQueuesParams,
  GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams,
  KeycloakGroupMembershipWebhookEvent,
  KeycloakGroupWebhookEvent,
  KeycloakUserWebhookEvent,
  LoginSettingsDto,
  PagedResultOfAbsenceDetails,
  PagedResultOfContactCodeResponse,
  PagedResultOfContactCodeTreeQueue,
  PagedResultOfContactCodeTreeSummary,
  PagedResultOfCustomPageDto,
  PagedResultOfCustomPropertyRuleSetDto,
  PagedResultOfCustomPropertySummary,
  PagedResultOfExtendedUserDto,
  PagedResultOfPauseReasonSummary,
  PagedResultOfPermissionSummary,
  PagedResultOfQueueSummary,
  PagedResultOfRolePermissionDto,
  PagedResultOfRoleSummary,
  PagedResultOfRuleSetSummary,
  PagedResultOfSkillGroupSkillDto,
  PagedResultOfSkillGroupSummary,
  PagedResultOfSkillSummary,
  PagedResultOfTeamCustomPageResponse,
  PagedResultOfTeamPauseReasonResponse,
  PagedResultOfTeamQueueResponse,
  PagedResultOfTeamSkillGroupResponse,
  PagedResultOfTeamSkillResponse,
  PagedResultOfTeamSummary,
  PagedResultOfTeamUserDto,
  PagedResultOfTemplateCustomPageResponse,
  PagedResultOfTemplateQueueResponse,
  PagedResultOfTemplateRoleResponse,
  PagedResultOfTemplateSkillResponse,
  PagedResultOfTemplateSummary,
  PagedResultOfTemplateTeamResponse,
  PagedResultOfUserCustomPageDto,
  PagedResultOfUserDto,
  PagedResultOfUserPauseReasonDto,
  PagedResultOfUserQueueDto,
  PagedResultOfUserRoleDto,
  PagedResultOfUserSkillDto,
  PagedResultOfUserSkillGroupDto,
  PauseReasonDetails,
  PauseReasonDto,
  PauseReasonSummary,
  PauseReasonsListParams,
  PauseReasonsRelationsTeamsAssignedParams,
  PauseReasonsRelationsTeamsAvailableParams,
  PauseReasonsRelationsUsersAssignedParams,
  PauseReasonsRelationsUsersAvailableParams,
  PermissionsListParams,
  PermissionsRelationsRolesAssignedParams,
  PermissionsRelationsRolesAvailableParams,
  PhoneSettingsDto,
  QueueDetails,
  QueueSummary,
  QueuesListParams,
  QueuesRelationsContactCodeTreesAssignedParams,
  QueuesRelationsContactCodeTreesAvailableParams,
  QueuesRelationsTeamsAssignedParams,
  QueuesRelationsTeamsAvailableParams,
  QueuesRelationsUsersAssignedParams,
  QueuesRelationsUsersAvailableParams,
  RecordingSettingsDto,
  RolePermissionDto,
  RoleSummary,
  RolesListParams,
  RolesRelationsPermissionsAssignedParams,
  RolesRelationsPermissionsAvailableParams,
  RolesRelationsUsersAssignedParams,
  RolesRelationsUsersAvailableParams,
  RuleSetSummary,
  RuleSetsListParams,
  RuleSetsRelationsCustomPropertiesAssignedParams,
  RuleSetsRelationsCustomPropertiesAvailableParams,
  SetClipSettingsDto,
  SettingResponse,
  SkillDetails,
  SkillGroupSkillDto,
  SkillGroupSummary,
  SkillGroupsListParams,
  SkillGroupsRelationsSkillsAssignedParams,
  SkillGroupsRelationsSkillsAvailableParams,
  SkillGroupsRelationsTeamsAssignedParams,
  SkillGroupsRelationsTeamsAvailableParams,
  SkillGroupsRelationsUsersAssignedParams,
  SkillGroupsRelationsUsersAvailableParams,
  SkillSummary,
  SkillsListParams,
  SkillsRelationsSkillGroupsAssignedParams,
  SkillsRelationsSkillGroupsAvailableParams,
  SkillsRelationsTeamsAssignedParams,
  SkillsRelationsTeamsAvailableParams,
  SkillsRelationsUsersAssignedParams,
  SkillsRelationsUsersAvailableParams,
  SubstitutionSettingsDto,
  TeamCustomPageResponse,
  TeamDetails,
  TeamPauseReasonResponse,
  TeamQueueResponse,
  TeamSkillGroupResponse,
  TeamSkillResponse,
  TeamSummary,
  TeamUserDto,
  TeamsListParams,
  TeamsRelationsCustomPagesAssignedParams,
  TeamsRelationsCustomPagesAvailableParams,
  TeamsRelationsPauseReasonsAssignedParams,
  TeamsRelationsPauseReasonsAvailableParams,
  TeamsRelationsQueuesAssignedParams,
  TeamsRelationsQueuesAvailableParams,
  TeamsRelationsSkillGroupsAssignedParams,
  TeamsRelationsSkillGroupsAvailableParams,
  TeamsRelationsSkillsAssignedParams,
  TeamsRelationsSkillsAvailableParams,
  TeamsRelationsUsersAssignedParams,
  TeamsRelationsUsersAvailableParams,
  TemplateCustomPageResponse,
  TemplateDetails,
  TemplateQueueResponse,
  TemplateRoleResponse,
  TemplateSkillResponse,
  TemplateSummary,
  TemplateTeamResponse,
  TemplatesListParams,
  TemplatesRelationsCustomPagesAssignedParams,
  TemplatesRelationsCustomPagesAvailableParams,
  TemplatesRelationsQueuesAssignedParams,
  TemplatesRelationsQueuesAvailableParams,
  TemplatesRelationsRolesAssignedParams,
  TemplatesRelationsRolesAvailableParams,
  TemplatesRelationsSkillsAssignedParams,
  TemplatesRelationsSkillsAvailableParams,
  TemplatesRelationsTeamsAssignedParams,
  TemplatesRelationsTeamsAvailableParams,
  UpdateAbsenceRequest,
  UpdateColorDefinitionsRequest,
  UpdateContactCodeTreeQueueRequest,
  UpdateContactCodeTreeWithChildrenRequest,
  UpdateCustomPropertyRequest,
  UpdateTeamQueueRequest,
  UpdateTeamUserRequest,
  UpdateTemplateRequest,
  UpdateUserQueueRequest,
  UpdateUserSkillGroupRequest,
  UpdateUserSkillRequest,
  UserCustomPageDto,
  UserDetails,
  UserGroupSummary,
  UserGroupsClientGetParams,
  UserPauseReasonDto,
  UserPermissionResponse,
  UserQueueDto,
  UserRoleDto,
  UserSkillDto,
  UserSkillGroupDto,
  UsersListParams,
  UsersRelationsCustomPagesAssignedParams,
  UsersRelationsCustomPagesAvailableParams,
  UsersRelationsPauseReasonsAssignedParams,
  UsersRelationsPauseReasonsAvailableParams,
  UsersRelationsQueuesAssignedParams,
  UsersRelationsQueuesAvailableParams,
  UsersRelationsRolesAssignedParams,
  UsersRelationsRolesAvailableParams,
  UsersRelationsSkillGroupsAssignedParams,
  UsersRelationsSkillGroupsAvailableParams,
  UsersRelationsSkillsAssignedParams,
  UsersRelationsSkillsAvailableParams,
  UsersRelationsTeamsAssignedParams,
  UsersRelationsTeamsAvailableParams
} from './.';

import { customInstance } from '../../api/mutator/custom-instance.ts';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiKeycloakWebhookUser = (
    keycloakUserWebhookEvent: KeycloakUserWebhookEvent,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/keycloak/webhook/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: keycloakUserWebhookEvent, signal
    },
      options);
    }




export const getPostApiKeycloakWebhookUserQueryKey = (keycloakUserWebhookEvent?: KeycloakUserWebhookEvent,) => {
    return [
    'POST', `/api/keycloak/webhook/user`, keycloakUserWebhookEvent
    ] as const;
    }


export const getPostApiKeycloakWebhookUserQueryOptions = <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostApiKeycloakWebhookUserQueryKey(keycloakUserWebhookEvent);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>> = ({ signal }) => postApiKeycloakWebhookUser(keycloakUserWebhookEvent, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostApiKeycloakWebhookUserQueryResult = NonNullable<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>>
export type PostApiKeycloakWebhookUserQueryError = unknown


export function usePostApiKeycloakWebhookUser<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(
 keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookUser<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(
 keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookUser<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(
 keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostApiKeycloakWebhookUser<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(
 keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostApiKeycloakWebhookUserQueryOptions(keycloakUserWebhookEvent,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPostApiKeycloakWebhookUserQuery = async <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError = unknown>(
 queryClient: QueryClient, keycloakUserWebhookEvent: KeycloakUserWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPostApiKeycloakWebhookUserQueryOptions(keycloakUserWebhookEvent,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const postApiKeycloakWebhookGroupmembership = (
    keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/keycloak/webhook/groupmembership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: keycloakGroupMembershipWebhookEvent, signal
    },
      options);
    }




export const getPostApiKeycloakWebhookGroupmembershipQueryKey = (keycloakGroupMembershipWebhookEvent?: KeycloakGroupMembershipWebhookEvent,) => {
    return [
    'POST', `/api/keycloak/webhook/groupmembership`, keycloakGroupMembershipWebhookEvent
    ] as const;
    }


export const getPostApiKeycloakWebhookGroupmembershipQueryOptions = <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostApiKeycloakWebhookGroupmembershipQueryKey(keycloakGroupMembershipWebhookEvent);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>> = ({ signal }) => postApiKeycloakWebhookGroupmembership(keycloakGroupMembershipWebhookEvent, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostApiKeycloakWebhookGroupmembershipQueryResult = NonNullable<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>>
export type PostApiKeycloakWebhookGroupmembershipQueryError = unknown


export function usePostApiKeycloakWebhookGroupmembership<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(
 keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookGroupmembership<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(
 keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookGroupmembership<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(
 keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostApiKeycloakWebhookGroupmembership<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(
 keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostApiKeycloakWebhookGroupmembershipQueryOptions(keycloakGroupMembershipWebhookEvent,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPostApiKeycloakWebhookGroupmembershipQuery = async <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError = unknown>(
 queryClient: QueryClient, keycloakGroupMembershipWebhookEvent: KeycloakGroupMembershipWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroupmembership>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPostApiKeycloakWebhookGroupmembershipQueryOptions(keycloakGroupMembershipWebhookEvent,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const postApiKeycloakWebhookGroup = (
    keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/keycloak/webhook/group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: keycloakGroupWebhookEvent, signal
    },
      options);
    }




export const getPostApiKeycloakWebhookGroupQueryKey = (keycloakGroupWebhookEvent?: KeycloakGroupWebhookEvent,) => {
    return [
    'POST', `/api/keycloak/webhook/group`, keycloakGroupWebhookEvent
    ] as const;
    }


export const getPostApiKeycloakWebhookGroupQueryOptions = <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostApiKeycloakWebhookGroupQueryKey(keycloakGroupWebhookEvent);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>> = ({ signal }) => postApiKeycloakWebhookGroup(keycloakGroupWebhookEvent, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostApiKeycloakWebhookGroupQueryResult = NonNullable<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>>
export type PostApiKeycloakWebhookGroupQueryError = unknown


export function usePostApiKeycloakWebhookGroup<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(
 keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookGroup<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(
 keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>,
          TError,
          Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostApiKeycloakWebhookGroup<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(
 keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostApiKeycloakWebhookGroup<TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(
 keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostApiKeycloakWebhookGroupQueryOptions(keycloakGroupWebhookEvent,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPostApiKeycloakWebhookGroupQuery = async <TData = Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError = unknown>(
 queryClient: QueryClient, keycloakGroupWebhookEvent: KeycloakGroupWebhookEvent, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiKeycloakWebhookGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPostApiKeycloakWebhookGroupQueryOptions(keycloakGroupWebhookEvent,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsCustomPagesAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserCustomPageDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsCustomPagesAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams,) => {
    return [
    `/admin/users/${userId}/custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsCustomPagesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsCustomPagesAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>> = ({ signal }) => usersRelationsCustomPagesAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsCustomPagesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>>
export type UsersRelationsCustomPagesAssignedQueryError = unknown


export function useUsersRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsCustomPagesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsCustomPagesAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsCustomPagesAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsCustomPagesAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsCustomPagesAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserCustomPageDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/custompages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsCustomPagesAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/custompages`, numberString
    ] as const;
    }


export const getUsersRelationsCustomPagesAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsCustomPagesAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>> = ({ signal }) => usersRelationsCustomPagesAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsCustomPagesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>>
export type UsersRelationsCustomPagesAssignQueryError = unknown


export function useUsersRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsCustomPagesAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsCustomPagesAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsCustomPagesAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsCustomPagesUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/custompages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsCustomPagesUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/custompages`, numberString
    ] as const;
    }


export const getUsersRelationsCustomPagesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsCustomPagesUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>> = ({ signal }) => usersRelationsCustomPagesUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsCustomPagesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>>
export type UsersRelationsCustomPagesUnassignQueryError = unknown


export function useUsersRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsCustomPagesUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsCustomPagesUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsCustomPagesUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsCustomPagesAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPageDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsCustomPagesAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsCustomPagesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsCustomPagesAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>> = ({ signal }) => usersRelationsCustomPagesAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsCustomPagesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>>
export type UsersRelationsCustomPagesAvailableQueryError = unknown


export function useUsersRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsCustomPagesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsCustomPagesAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsCustomPagesAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsCustomPagesAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsPauseReasonsAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserPauseReasonDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/pausereasons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsPauseReasonsAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams,) => {
    return [
    `/admin/users/${userId}/pausereasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsPauseReasonsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsPauseReasonsAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>> = ({ signal }) => usersRelationsPauseReasonsAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsPauseReasonsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>>
export type UsersRelationsPauseReasonsAssignedQueryError = ClientError


export function useUsersRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsPauseReasonsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsPauseReasonsAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsPauseReasonsAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsPauseReasonsAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsPauseReasonsAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserPauseReasonDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/pausereasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsPauseReasonsAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/pausereasons`, numberString
    ] as const;
    }


export const getUsersRelationsPauseReasonsAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsPauseReasonsAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>> = ({ signal }) => usersRelationsPauseReasonsAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsPauseReasonsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>>
export type UsersRelationsPauseReasonsAssignQueryError = unknown


export function useUsersRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsPauseReasonsAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsPauseReasonsAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsPauseReasonsAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsPauseReasonsUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/pausereasons`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsPauseReasonsUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/pausereasons`, numberString
    ] as const;
    }


export const getUsersRelationsPauseReasonsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsPauseReasonsUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>> = ({ signal }) => usersRelationsPauseReasonsUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsPauseReasonsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>>
export type UsersRelationsPauseReasonsUnassignQueryError = unknown


export function useUsersRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsPauseReasonsUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsPauseReasonsUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsPauseReasonsUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsPauseReasonsAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfPauseReasonSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-pausereasons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsPauseReasonsAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-pausereasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsPauseReasonsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsPauseReasonsAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>> = ({ signal }) => usersRelationsPauseReasonsAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsPauseReasonsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>>
export type UsersRelationsPauseReasonsAvailableQueryError = ClientError


export function useUsersRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsPauseReasonsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsPauseReasonsAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsPauseReasonsAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsPauseReasonsAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsQueuesAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/queues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsQueuesAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/queues`, numberString
    ] as const;
    }


export const getUsersRelationsQueuesAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsQueuesAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>> = ({ signal }) => usersRelationsQueuesAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsQueuesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>>
export type UsersRelationsQueuesAssignQueryError = unknown


export function useUsersRelationsQueuesAssign<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAssign<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAssign<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsQueuesAssign<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsQueuesAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsQueuesAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsQueuesAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsQueuesUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/queues`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsQueuesUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/queues`, numberString
    ] as const;
    }


export const getUsersRelationsQueuesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsQueuesUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>> = ({ signal }) => usersRelationsQueuesUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsQueuesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>>
export type UsersRelationsQueuesUnassignQueryError = unknown


export function useUsersRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsQueuesUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsQueuesUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsQueuesUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsQueuesAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserQueueDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsQueuesAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams,) => {
    return [
    `/admin/users/${userId}/queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsQueuesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsQueuesAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>> = ({ signal }) => usersRelationsQueuesAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsQueuesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>>
export type UsersRelationsQueuesAssignedQueryError = ClientError


export function useUsersRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsQueuesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsQueuesAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsQueuesAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsQueuesAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsQueuesUpdate = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/queues/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserQueueRequest, signal
    },
      options);
    }




export const getUsersRelationsQueuesUpdateQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest?: UpdateUserQueueRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/queues/${mappingId}`, updateUserQueueRequest
    ] as const;
    }


export const getUsersRelationsQueuesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsQueuesUpdateQueryKey(userId,mappingId,updateUserQueueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>> = ({ signal }) => usersRelationsQueuesUpdate(userId,mappingId,updateUserQueueRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsQueuesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>>
export type UsersRelationsQueuesUpdateQueryError = unknown


export function useUsersRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsQueuesUpdateQueryOptions(userId,mappingId,updateUserQueueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsQueuesUpdateQuery = async <TData = Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserQueueRequest: UpdateUserQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsQueuesUpdateQueryOptions(userId,mappingId,updateUserQueueRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsQueuesAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfQueueSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsQueuesAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsQueuesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsQueuesAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>> = ({ signal }) => usersRelationsQueuesAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsQueuesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>>
export type UsersRelationsQueuesAvailableQueryError = unknown


export function useUsersRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsQueuesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsQueuesAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsQueuesAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsQueuesAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsRolesAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserRoleDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsRolesAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams,) => {
    return [
    `/admin/users/${userId}/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsRolesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsRolesAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>> = ({ signal }) => usersRelationsRolesAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsRolesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>>
export type UsersRelationsRolesAssignedQueryError = ClientError


export function useUsersRelationsRolesAssigned<TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsRolesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAssigned<TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAssigned<TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsRolesAssigned<TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsRolesAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsRolesAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsRolesAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsRolesAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserRoleDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsRolesAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/roles`, numberString
    ] as const;
    }


export const getUsersRelationsRolesAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsRolesAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsRolesAssign>>> = ({ signal }) => usersRelationsRolesAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsRolesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsRolesAssign>>>
export type UsersRelationsRolesAssignQueryError = unknown


export function useUsersRelationsRolesAssign<TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAssign<TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAssign<TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsRolesAssign<TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsRolesAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsRolesAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsRolesAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsRolesUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/roles`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsRolesUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/roles`, numberString
    ] as const;
    }


export const getUsersRelationsRolesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsRolesUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>> = ({ signal }) => usersRelationsRolesUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsRolesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>>
export type UsersRelationsRolesUnassignQueryError = unknown


export function useUsersRelationsRolesUnassign<TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesUnassign<TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesUnassign<TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsRolesUnassign<TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsRolesUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsRolesUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsRolesUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsRolesAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRoleSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsRolesAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsRolesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsRolesAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>> = ({ signal }) => usersRelationsRolesAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsRolesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>>
export type UsersRelationsRolesAvailableQueryError = unknown


export function useUsersRelationsRolesAvailable<TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsRolesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAvailable<TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsRolesAvailable<TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsRolesAvailable<TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsRolesAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsRolesAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsRolesAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersList = (
    params?: UsersListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersListQueryKey = (params?: UsersListParams,) => {
    return [
    `/admin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersListQueryOptions = <TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(params?: UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersList>>> = ({ signal }) => usersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersListQueryResult = NonNullable<Awaited<ReturnType<typeof usersList>>>
export type UsersListQueryError = unknown


export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(
 params: undefined |  UsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersList>>,
          TError,
          Awaited<ReturnType<typeof usersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(
 params?: UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersList>>,
          TError,
          Awaited<ReturnType<typeof usersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(
 params?: UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(
 params?: UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersListQuery = async <TData = Awaited<ReturnType<typeof usersList>>, TError = unknown>(
 queryClient: QueryClient, params?: UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersDetail = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserDetails>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}`, method: 'GET', signal
    },
      options);
    }




export const getUsersDetailQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}`
    ] as const;
    }


export const getUsersDetailQueryOptions = <TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersDetailQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersDetail>>> = ({ signal }) => usersDetail(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersDetailQueryResult = NonNullable<Awaited<ReturnType<typeof usersDetail>>>
export type UsersDetailQueryError = unknown


export function useUsersDetail<TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersDetail>>,
          TError,
          Awaited<ReturnType<typeof usersDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersDetail<TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersDetail>>,
          TError,
          Awaited<ReturnType<typeof usersDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersDetail<TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersDetail<TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersDetailQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersDetailQuery = async <TData = Awaited<ReturnType<typeof usersDetail>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersDetailQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillGroupsAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsSkillGroupsAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsSkillGroupsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillGroupsAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>> = ({ signal }) => usersRelationsSkillGroupsAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillGroupsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>>
export type UsersRelationsSkillGroupsAvailableQueryError = unknown


export function useUsersRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsSkillGroupsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillGroupsAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillGroupsAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillGroupsAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillGroupsAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserSkillGroupDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsSkillGroupsAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams,) => {
    return [
    `/admin/users/${userId}/skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsSkillGroupsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillGroupsAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>> = ({ signal }) => usersRelationsSkillGroupsAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillGroupsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>>
export type UsersRelationsSkillGroupsAssignedQueryError = unknown


export function useUsersRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsSkillGroupsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillGroupsAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillGroupsAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillGroupsAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillGroupsAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillGroupDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skillgroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsSkillGroupsAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/skillgroups`, numberString
    ] as const;
    }


export const getUsersRelationsSkillGroupsAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillGroupsAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>> = ({ signal }) => usersRelationsSkillGroupsAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillGroupsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>>
export type UsersRelationsSkillGroupsAssignQueryError = unknown


export function useUsersRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillGroupsAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillGroupsAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillGroupsAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillGroupsUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skillgroups`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsSkillGroupsUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/skillgroups`, numberString
    ] as const;
    }


export const getUsersRelationsSkillGroupsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillGroupsUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>> = ({ signal }) => usersRelationsSkillGroupsUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillGroupsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>>
export type UsersRelationsSkillGroupsUnassignQueryError = unknown


export function useUsersRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillGroupsUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillGroupsUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillGroupsUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillGroupsUpdate = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillGroupDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skillgroups/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserSkillGroupRequest, signal
    },
      options);
    }




export const getUsersRelationsSkillGroupsUpdateQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest?: UpdateUserSkillGroupRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/skillgroups/${mappingId}`, updateUserSkillGroupRequest
    ] as const;
    }


export const getUsersRelationsSkillGroupsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillGroupsUpdateQueryKey(userId,mappingId,updateUserSkillGroupRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>> = ({ signal }) => usersRelationsSkillGroupsUpdate(userId,mappingId,updateUserSkillGroupRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillGroupsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>>
export type UsersRelationsSkillGroupsUpdateQueryError = unknown


export function useUsersRelationsSkillGroupsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillGroupsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillGroupsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillGroupsUpdateQueryOptions(userId,mappingId,updateUserSkillGroupRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillGroupsUpdateQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillGroupsUpdateQueryOptions(userId,mappingId,updateUserSkillGroupRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillsAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsSkillsAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsSkillsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillsAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>> = ({ signal }) => usersRelationsSkillsAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>>
export type UsersRelationsSkillsAvailableQueryError = unknown


export function useUsersRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsSkillsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillsAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillsAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillsAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillsAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserSkillDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsSkillsAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams,) => {
    return [
    `/admin/users/${userId}/skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsSkillsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillsAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>> = ({ signal }) => usersRelationsSkillsAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>>
export type UsersRelationsSkillsAssignedQueryError = ClientError


export function useUsersRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsSkillsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillsAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillsAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillsAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillsAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsSkillsAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/skills`, numberString
    ] as const;
    }


export const getUsersRelationsSkillsAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillsAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>> = ({ signal }) => usersRelationsSkillsAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>>
export type UsersRelationsSkillsAssignQueryError = unknown


export function useUsersRelationsSkillsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillsAssign<TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillsAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillsAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillsAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillsUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skills`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsSkillsUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/skills`, numberString
    ] as const;
    }


export const getUsersRelationsSkillsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillsUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>> = ({ signal }) => usersRelationsSkillsUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>>
export type UsersRelationsSkillsUnassignQueryError = unknown


export function useUsersRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillsUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillsUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillsUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsSkillsUpdate = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/skills/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserSkillRequest, signal
    },
      options);
    }




export const getUsersRelationsSkillsUpdateQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest?: UpdateUserSkillRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/skills/${mappingId}`, updateUserSkillRequest
    ] as const;
    }


export const getUsersRelationsSkillsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsSkillsUpdateQueryKey(userId,mappingId,updateUserSkillRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>> = ({ signal }) => usersRelationsSkillsUpdate(userId,mappingId,updateUserSkillRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsSkillsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>>
export type UsersRelationsSkillsUpdateQueryError = unknown


export function useUsersRelationsSkillsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsSkillsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsSkillsUpdate<TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsSkillsUpdateQueryOptions(userId,mappingId,updateUserSkillRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsSkillsUpdateQuery = async <TData = Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillRequest: UpdateUserSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsSkillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsSkillsUpdateQueryOptions(userId,mappingId,updateUserSkillRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTeamsAssigned = (
    userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamUserDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsTeamsAssignedQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams,) => {
    return [
    `/admin/users/${userId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTeamsAssignedQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>> = ({ signal }) => usersRelationsTeamsAssigned(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>>
export type UsersRelationsTeamsAssignedQueryError = ClientError


export function useUsersRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTeamsAssignedQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTeamsAssignedQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTeamsAssign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto[]>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsTeamsAssignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/users/${userId}/teams`, numberString
    ] as const;
    }


export const getUsersRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTeamsAssignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>> = ({ signal }) => usersRelationsTeamsAssign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>>
export type UsersRelationsTeamsAssignQueryError = unknown


export function useUsersRelationsTeamsAssign<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAssign<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAssign<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTeamsAssign<TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTeamsAssignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTeamsAssignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTeamsUnassign = (
    userId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getUsersRelationsTeamsUnassignQueryKey = (userId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/users/${userId}/teams`, numberString
    ] as const;
    }


export const getUsersRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTeamsUnassignQueryKey(userId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>> = ({ signal }) => usersRelationsTeamsUnassign(userId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>>
export type UsersRelationsTeamsUnassignQueryError = unknown


export function useUsersRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(
 userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTeamsUnassignQueryOptions(userId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTeamsUnassignQueryOptions(userId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTeamsAvailable = (
    userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUsersRelationsTeamsAvailableQueryKey = (userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams,) => {
    return [
    `/admin/users/${userId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTeamsAvailableQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>> = ({ signal }) => usersRelationsTeamsAvailable(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>>
export type UsersRelationsTeamsAvailableQueryError = unknown


export function useUsersRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params: undefined |  UsersRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(
 userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTeamsAvailableQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    params?: UsersRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTeamsAvailableQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTeamsUpdate = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamUserRequest, signal
    },
      options);
    }




export const getUsersRelationsTeamsUpdateQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest?: UpdateTeamUserRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/teams/${mappingId}`, updateTeamUserRequest
    ] as const;
    }


export const getUsersRelationsTeamsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTeamsUpdateQueryKey(userId,mappingId,updateTeamUserRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>> = ({ signal }) => usersRelationsTeamsUpdate(userId,mappingId,updateTeamUserRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTeamsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>>
export type UsersRelationsTeamsUpdateQueryError = unknown


export function useUsersRelationsTeamsUpdate<TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsUpdate<TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTeamsUpdate<TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTeamsUpdate<TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTeamsUpdateQueryOptions(userId,mappingId,updateTeamUserRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTeamsUpdateQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamUserRequest: UpdateTeamUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTeamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTeamsUpdateQueryOptions(userId,mappingId,updateTeamUserRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminUsersUserIdTeamsMappingIdPrimary = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams/${encodeURIComponent(String(mappingId))}/primary`, method: 'PUT', signal
    },
      options);
    }




export const getPutAdminUsersUserIdTeamsMappingIdPrimaryQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,) => {
    return [
    'PUT', `/admin/users/${userId}/teams/${mappingId}/primary`
    ] as const;
    }


export const getPutAdminUsersUserIdTeamsMappingIdPrimaryQueryOptions = <TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminUsersUserIdTeamsMappingIdPrimaryQueryKey(userId,mappingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>> = ({ signal }) => putAdminUsersUserIdTeamsMappingIdPrimary(userId,mappingId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminUsersUserIdTeamsMappingIdPrimaryQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>>
export type PutAdminUsersUserIdTeamsMappingIdPrimaryQueryError = unknown


export function usePutAdminUsersUserIdTeamsMappingIdPrimary<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>,
          TError,
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminUsersUserIdTeamsMappingIdPrimary<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>,
          TError,
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminUsersUserIdTeamsMappingIdPrimary<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminUsersUserIdTeamsMappingIdPrimary<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminUsersUserIdTeamsMappingIdPrimaryQueryOptions(userId,mappingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminUsersUserIdTeamsMappingIdPrimaryQuery = async <TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdPrimary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminUsersUserIdTeamsMappingIdPrimaryQueryOptions(userId,mappingId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminUsersUserIdTeamsMappingIdResponsible = (
    userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/teams/${encodeURIComponent(String(mappingId))}/responsible`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: boolean, signal
    },
      options);
    }




export const getPutAdminUsersUserIdTeamsMappingIdResponsibleQueryKey = (userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean?: boolean,) => {
    return [
    'PUT', `/admin/users/${userId}/teams/${mappingId}/responsible`, boolean
    ] as const;
    }


export const getPutAdminUsersUserIdTeamsMappingIdResponsibleQueryOptions = <TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminUsersUserIdTeamsMappingIdResponsibleQueryKey(userId,mappingId,boolean);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>> = ({ signal }) => putAdminUsersUserIdTeamsMappingIdResponsible(userId,mappingId,boolean, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminUsersUserIdTeamsMappingIdResponsibleQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>>
export type PutAdminUsersUserIdTeamsMappingIdResponsibleQueryError = unknown


export function usePutAdminUsersUserIdTeamsMappingIdResponsible<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>,
          TError,
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminUsersUserIdTeamsMappingIdResponsible<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>,
          TError,
          Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminUsersUserIdTeamsMappingIdResponsible<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminUsersUserIdTeamsMappingIdResponsible<TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(
 userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminUsersUserIdTeamsMappingIdResponsibleQueryOptions(userId,mappingId,boolean,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminUsersUserIdTeamsMappingIdResponsibleQuery = async <TData = Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    boolean: boolean, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminUsersUserIdTeamsMappingIdResponsible>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminUsersUserIdTeamsMappingIdResponsibleQueryOptions(userId,mappingId,boolean,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersRelationsTemplatesUpdate = (
    userId: number | string | undefined | null,
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/templates/${encodeURIComponent(String(templateId))}`, method: 'PUT', signal
    },
      options);
    }




export const getUsersRelationsTemplatesUpdateQueryKey = (userId: number | string | undefined | null,
    templateId: number | string | undefined | null,) => {
    return [
    'PUT', `/admin/users/${userId}/templates/${templateId}`
    ] as const;
    }


export const getUsersRelationsTemplatesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRelationsTemplatesUpdateQueryKey(userId,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>> = ({ signal }) => usersRelationsTemplatesUpdate(userId,templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRelationsTemplatesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>>
export type UsersRelationsTemplatesUpdateQueryError = unknown


export function useUsersRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRelationsTemplatesUpdateQueryOptions(userId,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersRelationsTemplatesUpdateQuery = async <TData = Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersRelationsTemplatesUpdateQueryOptions(userId,templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersClientGetCustompages = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPageDto>(
      {url: `/api/users/custompages`, method: 'GET', signal
    },
      options);
    }




export const getUsersClientGetCustompagesQueryKey = () => {
    return [
    `/api/users/custompages`
    ] as const;
    }


export const getUsersClientGetCustompagesQueryOptions = <TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersClientGetCustompagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersClientGetCustompages>>> = ({ signal }) => usersClientGetCustompages(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersClientGetCustompagesQueryResult = NonNullable<Awaited<ReturnType<typeof usersClientGetCustompages>>>
export type UsersClientGetCustompagesQueryError = unknown


export function useUsersClientGetCustompages<TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersClientGetCustompages>>,
          TError,
          Awaited<ReturnType<typeof usersClientGetCustompages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersClientGetCustompages<TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersClientGetCustompages>>,
          TError,
          Awaited<ReturnType<typeof usersClientGetCustompages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersClientGetCustompages<TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersClientGetCustompages<TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersClientGetCustompagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersClientGetCustompagesQuery = async <TData = Awaited<ReturnType<typeof usersClientGetCustompages>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersClientGetCustompages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersClientGetCustompagesQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsContactLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/contact`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsContactLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/contact`
    ] as const;
    }


export const getUsersSettingsContactLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsContactLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsContactLoad>>> = ({ signal }) => usersSettingsContactLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsContactLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsContactLoad>>>
export type UsersSettingsContactLoadQueryError = unknown


export function useUsersSettingsContactLoad<TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactLoad<TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactLoad<TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsContactLoad<TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsContactLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsContactLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsContactLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsContactUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/contact`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsContactUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest?: CreateOrUpdateContactSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/contact`, createOrUpdateContactSettingsRequest
    ] as const;
    }


export const getUsersSettingsContactUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsContactUpdateQueryKey(userId,createOrUpdateContactSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsContactUpdate>>> = ({ signal }) => usersSettingsContactUpdate(userId,createOrUpdateContactSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsContactUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsContactUpdate>>>
export type UsersSettingsContactUpdateQueryError = unknown


export function useUsersSettingsContactUpdate<TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactUpdate<TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactUpdate<TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsContactUpdate<TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsContactUpdateQueryOptions(userId,createOrUpdateContactSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsContactUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsContactUpdateQueryOptions(userId,createOrUpdateContactSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsContactReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/contact`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsContactResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/contact`
    ] as const;
    }


export const getUsersSettingsContactResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsContactResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsContactReset>>> = ({ signal }) => usersSettingsContactReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsContactResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsContactReset>>>
export type UsersSettingsContactResetQueryError = unknown


export function useUsersSettingsContactReset<TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactReset<TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsContactReset<TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsContactReset<TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsContactResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsContactResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsContactReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsContactResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsGeneralLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/general`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsGeneralLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/general`
    ] as const;
    }


export const getUsersSettingsGeneralLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsGeneralLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>> = ({ signal }) => usersSettingsGeneralLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsGeneralLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>>
export type UsersSettingsGeneralLoadQueryError = unknown


export function useUsersSettingsGeneralLoad<TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralLoad<TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralLoad<TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsGeneralLoad<TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsGeneralLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsGeneralLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsGeneralLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsGeneralUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/general`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateGeneralSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsGeneralUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest?: CreateOrUpdateGeneralSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/general`, createOrUpdateGeneralSettingsRequest
    ] as const;
    }


export const getUsersSettingsGeneralUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsGeneralUpdateQueryKey(userId,createOrUpdateGeneralSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>> = ({ signal }) => usersSettingsGeneralUpdate(userId,createOrUpdateGeneralSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsGeneralUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>>
export type UsersSettingsGeneralUpdateQueryError = unknown


export function useUsersSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsGeneralUpdateQueryOptions(userId,createOrUpdateGeneralSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsGeneralUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsGeneralUpdateQueryOptions(userId,createOrUpdateGeneralSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsGeneralReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/general`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsGeneralResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/general`
    ] as const;
    }


export const getUsersSettingsGeneralResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsGeneralResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsGeneralReset>>> = ({ signal }) => usersSettingsGeneralReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsGeneralResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsGeneralReset>>>
export type UsersSettingsGeneralResetQueryError = unknown


export function useUsersSettingsGeneralReset<TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralReset<TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsGeneralReset<TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsGeneralReset<TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsGeneralResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsGeneralResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsGeneralResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsLoginLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/login`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsLoginLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/login`
    ] as const;
    }


export const getUsersSettingsLoginLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsLoginLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsLoginLoad>>> = ({ signal }) => usersSettingsLoginLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsLoginLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsLoginLoad>>>
export type UsersSettingsLoginLoadQueryError = unknown


export function useUsersSettingsLoginLoad<TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginLoad<TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginLoad<TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsLoginLoad<TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsLoginLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsLoginLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsLoginLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsLoginUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/login`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateLoginSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsLoginUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest?: CreateOrUpdateLoginSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/login`, createOrUpdateLoginSettingsRequest
    ] as const;
    }


export const getUsersSettingsLoginUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsLoginUpdateQueryKey(userId,createOrUpdateLoginSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>> = ({ signal }) => usersSettingsLoginUpdate(userId,createOrUpdateLoginSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsLoginUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>>
export type UsersSettingsLoginUpdateQueryError = unknown


export function useUsersSettingsLoginUpdate<TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginUpdate<TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginUpdate<TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsLoginUpdate<TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsLoginUpdateQueryOptions(userId,createOrUpdateLoginSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsLoginUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsLoginUpdateQueryOptions(userId,createOrUpdateLoginSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsLoginReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/login`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsLoginResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/login`
    ] as const;
    }


export const getUsersSettingsLoginResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsLoginResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsLoginReset>>> = ({ signal }) => usersSettingsLoginReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsLoginResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsLoginReset>>>
export type UsersSettingsLoginResetQueryError = unknown


export function useUsersSettingsLoginReset<TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginReset<TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsLoginReset<TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsLoginReset<TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsLoginResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsLoginResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsLoginResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsPhoneLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/phone`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsPhoneLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/phone`
    ] as const;
    }


export const getUsersSettingsPhoneLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsPhoneLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>> = ({ signal }) => usersSettingsPhoneLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsPhoneLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>>
export type UsersSettingsPhoneLoadQueryError = unknown


export function useUsersSettingsPhoneLoad<TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneLoad<TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneLoad<TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsPhoneLoad<TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsPhoneLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsPhoneLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsPhoneLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsPhoneUpdate = (
    userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/phone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePhoneSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsPhoneUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest?: CreateOrUpdatePhoneSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/phone`, createOrUpdatePhoneSettingsRequest
    ] as const;
    }


export const getUsersSettingsPhoneUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsPhoneUpdateQueryKey(userId,createOrUpdatePhoneSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>> = ({ signal }) => usersSettingsPhoneUpdate(userId,createOrUpdatePhoneSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsPhoneUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>>
export type UsersSettingsPhoneUpdateQueryError = unknown


export function useUsersSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsPhoneUpdateQueryOptions(userId,createOrUpdatePhoneSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsPhoneUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsPhoneUpdateQueryOptions(userId,createOrUpdatePhoneSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsPhoneReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/phone`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsPhoneResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/phone`
    ] as const;
    }


export const getUsersSettingsPhoneResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsPhoneResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsPhoneReset>>> = ({ signal }) => usersSettingsPhoneReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsPhoneResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsPhoneReset>>>
export type UsersSettingsPhoneResetQueryError = unknown


export function useUsersSettingsPhoneReset<TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneReset<TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsPhoneReset<TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsPhoneReset<TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsPhoneResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsPhoneResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsPhoneResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsRecordingLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/recording`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsRecordingLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/recording`
    ] as const;
    }


export const getUsersSettingsRecordingLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsRecordingLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>> = ({ signal }) => usersSettingsRecordingLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsRecordingLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>>
export type UsersSettingsRecordingLoadQueryError = unknown


export function useUsersSettingsRecordingLoad<TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingLoad<TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingLoad<TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsRecordingLoad<TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsRecordingLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsRecordingLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsRecordingLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsRecordingUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/recording`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRecordingSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsRecordingUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest?: CreateOrUpdateRecordingSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/recording`, createOrUpdateRecordingSettingsRequest
    ] as const;
    }


export const getUsersSettingsRecordingUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsRecordingUpdateQueryKey(userId,createOrUpdateRecordingSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>> = ({ signal }) => usersSettingsRecordingUpdate(userId,createOrUpdateRecordingSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsRecordingUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>>
export type UsersSettingsRecordingUpdateQueryError = unknown


export function useUsersSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsRecordingUpdateQueryOptions(userId,createOrUpdateRecordingSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsRecordingUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsRecordingUpdateQueryOptions(userId,createOrUpdateRecordingSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsRecordingReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/recording`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsRecordingResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/recording`
    ] as const;
    }


export const getUsersSettingsRecordingResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsRecordingResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsRecordingReset>>> = ({ signal }) => usersSettingsRecordingReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsRecordingResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsRecordingReset>>>
export type UsersSettingsRecordingResetQueryError = unknown


export function useUsersSettingsRecordingReset<TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingReset<TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsRecordingReset<TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsRecordingReset<TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsRecordingResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsRecordingResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsRecordingResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSetclipLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/setclip`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsSetclipLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/setclip`
    ] as const;
    }


export const getUsersSettingsSetclipLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSetclipLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>> = ({ signal }) => usersSettingsSetclipLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSetclipLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>>
export type UsersSettingsSetclipLoadQueryError = unknown


export function useUsersSettingsSetclipLoad<TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipLoad<TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipLoad<TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSetclipLoad<TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSetclipLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSetclipLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSetclipLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSetclipUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/setclip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSetClipSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsSetclipUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest?: CreateOrUpdateSetClipSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/setclip`, createOrUpdateSetClipSettingsRequest
    ] as const;
    }


export const getUsersSettingsSetclipUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSetclipUpdateQueryKey(userId,createOrUpdateSetClipSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>> = ({ signal }) => usersSettingsSetclipUpdate(userId,createOrUpdateSetClipSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSetclipUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>>
export type UsersSettingsSetclipUpdateQueryError = unknown


export function useUsersSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(
 userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSetclipUpdateQueryOptions(userId,createOrUpdateSetClipSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSetclipUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSetclipUpdateQueryOptions(userId,createOrUpdateSetClipSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSetclipReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/setclip`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsSetclipResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/setclip`
    ] as const;
    }


export const getUsersSettingsSetclipResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSetclipResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSetclipReset>>> = ({ signal }) => usersSettingsSetclipReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSetclipResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSetclipReset>>>
export type UsersSettingsSetclipResetQueryError = unknown


export function useUsersSettingsSetclipReset<TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipReset<TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSetclipReset<TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSetclipReset<TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSetclipResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSetclipResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSetclipResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSubstitutionLoad = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SubstitutionSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/substitution`, method: 'GET', signal
    },
      options);
    }




export const getUsersSettingsSubstitutionLoadQueryKey = (userId: number | string | undefined | null,) => {
    return [
    `/admin/users/${userId}/settings/substitution`
    ] as const;
    }


export const getUsersSettingsSubstitutionLoadQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSubstitutionLoadQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>> = ({ signal }) => usersSettingsSubstitutionLoad(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSubstitutionLoadQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>>
export type UsersSettingsSubstitutionLoadQueryError = unknown


export function useUsersSettingsSubstitutionLoad<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionLoad<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionLoad<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSubstitutionLoad<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSubstitutionLoadQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSubstitutionLoadQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSubstitutionLoadQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSubstitutionUpdate = (
    userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SubstitutionSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/substitution`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSubstitutionSettingsRequest, signal
    },
      options);
    }




export const getUsersSettingsSubstitutionUpdateQueryKey = (userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest?: CreateOrUpdateSubstitutionSettingsRequest,) => {
    return [
    'PUT', `/admin/users/${userId}/settings/substitution`, createOrUpdateSubstitutionSettingsRequest
    ] as const;
    }


export const getUsersSettingsSubstitutionUpdateQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSubstitutionUpdateQueryKey(userId,createOrUpdateSubstitutionSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>> = ({ signal }) => usersSettingsSubstitutionUpdate(userId,createOrUpdateSubstitutionSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSubstitutionUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>>
export type UsersSettingsSubstitutionUpdateQueryError = ClientError


export function useUsersSettingsSubstitutionUpdate<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(
 userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionUpdate<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(
 userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionUpdate<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(
 userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSubstitutionUpdate<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(
 userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSubstitutionUpdateQueryOptions(userId,createOrUpdateSubstitutionSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSubstitutionUpdateQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError = ClientError>(
 queryClient: QueryClient, userId: number | string | undefined | null,
    createOrUpdateSubstitutionSettingsRequest: CreateOrUpdateSubstitutionSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSubstitutionUpdateQueryOptions(userId,createOrUpdateSubstitutionSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const usersSettingsSubstitutionReset = (
    userId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SubstitutionSettingsDto>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/settings/substitution`, method: 'DELETE', signal
    },
      options);
    }




export const getUsersSettingsSubstitutionResetQueryKey = (userId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/users/${userId}/settings/substitution`
    ] as const;
    }


export const getUsersSettingsSubstitutionResetQueryOptions = <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSettingsSubstitutionResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>> = ({ signal }) => usersSettingsSubstitutionReset(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSettingsSubstitutionResetQueryResult = NonNullable<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>>
export type UsersSettingsSubstitutionResetQueryError = unknown


export function useUsersSettingsSubstitutionReset<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(
 userId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionReset<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>,
          TError,
          Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSettingsSubstitutionReset<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSettingsSubstitutionReset<TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(
 userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSettingsSubstitutionResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUsersSettingsSubstitutionResetQuery = async <TData = Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError = unknown>(
 queryClient: QueryClient, userId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSettingsSubstitutionReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUsersSettingsSubstitutionResetQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const userGroupsClientGet = (
    params?: UserGroupsClientGetParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserGroupSummary[]>(
      {url: `/api/usergroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserGroupsClientGetQueryKey = (params?: UserGroupsClientGetParams,) => {
    return [
    `/api/usergroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserGroupsClientGetQueryOptions = <TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(params?: UserGroupsClientGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGroupsClientGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGroupsClientGet>>> = ({ signal }) => userGroupsClientGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserGroupsClientGetQueryResult = NonNullable<Awaited<ReturnType<typeof userGroupsClientGet>>>
export type UserGroupsClientGetQueryError = ClientError


export function useUserGroupsClientGet<TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(
 params: undefined |  UserGroupsClientGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGroupsClientGet>>,
          TError,
          Awaited<ReturnType<typeof userGroupsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGroupsClientGet<TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(
 params?: UserGroupsClientGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGroupsClientGet>>,
          TError,
          Awaited<ReturnType<typeof userGroupsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGroupsClientGet<TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(
 params?: UserGroupsClientGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserGroupsClientGet<TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(
 params?: UserGroupsClientGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserGroupsClientGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchUserGroupsClientGetQuery = async <TData = Awaited<ReturnType<typeof userGroupsClientGet>>, TError = ClientError>(
 queryClient: QueryClient, params?: UserGroupsClientGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGroupsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getUserGroupsClientGetQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsCustomPagesAssigned = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateCustomPageResponse>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsCustomPagesAssignedQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams,) => {
    return [
    `/admin/templates/${templateId}/custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsCustomPagesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsCustomPagesAssignedQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>> = ({ signal }) => templatesRelationsCustomPagesAssigned(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsCustomPagesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>>
export type TemplatesRelationsCustomPagesAssignedQueryError = unknown


export function useTemplatesRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsCustomPagesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsCustomPagesAssignedQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsCustomPagesAssignedQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsCustomPagesAssignedQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsCustomPagesAssign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateCustomPageResponse[]>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/custompages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsCustomPagesAssignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/templates/${templateId}/custompages`, numberString
    ] as const;
    }


export const getTemplatesRelationsCustomPagesAssignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsCustomPagesAssignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>> = ({ signal }) => templatesRelationsCustomPagesAssign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsCustomPagesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>>
export type TemplatesRelationsCustomPagesAssignQueryError = unknown


export function useTemplatesRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsCustomPagesAssignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsCustomPagesAssignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsCustomPagesAssignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsCustomPagesUnassign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/custompages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsCustomPagesUnassignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/templates/${templateId}/custompages`, numberString
    ] as const;
    }


export const getTemplatesRelationsCustomPagesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsCustomPagesUnassignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>> = ({ signal }) => templatesRelationsCustomPagesUnassign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsCustomPagesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>>
export type TemplatesRelationsCustomPagesUnassignQueryError = unknown


export function useTemplatesRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsCustomPagesUnassignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsCustomPagesUnassignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsCustomPagesUnassignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsCustomPagesAvailable = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPageDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/assignable-custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsCustomPagesAvailableQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams,) => {
    return [
    `/admin/templates/${templateId}/assignable-custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsCustomPagesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsCustomPagesAvailableQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>> = ({ signal }) => templatesRelationsCustomPagesAvailable(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsCustomPagesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>>
export type TemplatesRelationsCustomPagesAvailableQueryError = unknown


export function useTemplatesRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsCustomPagesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsCustomPagesAvailableQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsCustomPagesAvailableQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsCustomPagesAvailableQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsQueuesAssigned = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateQueueResponse>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsQueuesAssignedQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams,) => {
    return [
    `/admin/templates/${templateId}/queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsQueuesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsQueuesAssignedQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>> = ({ signal }) => templatesRelationsQueuesAssigned(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsQueuesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>>
export type TemplatesRelationsQueuesAssignedQueryError = ClientError


export function useTemplatesRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsQueuesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsQueuesAssignedQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsQueuesAssignedQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError = ClientError>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsQueuesAssignedQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsQueuesAssign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateQueueResponse[]>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/queues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsQueuesAssignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/templates/${templateId}/queues`, numberString
    ] as const;
    }


export const getTemplatesRelationsQueuesAssignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsQueuesAssignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>> = ({ signal }) => templatesRelationsQueuesAssign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsQueuesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>>
export type TemplatesRelationsQueuesAssignQueryError = unknown


export function useTemplatesRelationsQueuesAssign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAssign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAssign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsQueuesAssign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsQueuesAssignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsQueuesAssignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsQueuesAssignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsQueuesUnassign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/queues`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsQueuesUnassignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/templates/${templateId}/queues`, numberString
    ] as const;
    }


export const getTemplatesRelationsQueuesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsQueuesUnassignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>> = ({ signal }) => templatesRelationsQueuesUnassign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsQueuesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>>
export type TemplatesRelationsQueuesUnassignQueryError = unknown


export function useTemplatesRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsQueuesUnassignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsQueuesUnassignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsQueuesUnassignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsQueuesAvailable = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfQueueSummary>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/assignable-queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsQueuesAvailableQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams,) => {
    return [
    `/admin/templates/${templateId}/assignable-queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsQueuesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsQueuesAvailableQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>> = ({ signal }) => templatesRelationsQueuesAvailable(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsQueuesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>>
export type TemplatesRelationsQueuesAvailableQueryError = unknown


export function useTemplatesRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsQueuesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsQueuesAvailableQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsQueuesAvailableQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsQueuesAvailableQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsRolesAssigned = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateRoleResponse>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsRolesAssignedQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams,) => {
    return [
    `/admin/templates/${templateId}/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsRolesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsRolesAssignedQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>> = ({ signal }) => templatesRelationsRolesAssigned(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsRolesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>>
export type TemplatesRelationsRolesAssignedQueryError = unknown


export function useTemplatesRelationsRolesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsRolesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsRolesAssigned<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsRolesAssignedQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsRolesAssignedQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsRolesAssignedQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsRolesAssign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateRoleResponse[]>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsRolesAssignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/templates/${templateId}/roles`, numberString
    ] as const;
    }


export const getTemplatesRelationsRolesAssignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsRolesAssignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>> = ({ signal }) => templatesRelationsRolesAssign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsRolesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>>
export type TemplatesRelationsRolesAssignQueryError = unknown


export function useTemplatesRelationsRolesAssign<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAssign<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAssign<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsRolesAssign<TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsRolesAssignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsRolesAssignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsRolesAssignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsRolesUnassign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/roles`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsRolesUnassignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/templates/${templateId}/roles`, numberString
    ] as const;
    }


export const getTemplatesRelationsRolesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsRolesUnassignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>> = ({ signal }) => templatesRelationsRolesUnassign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsRolesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>>
export type TemplatesRelationsRolesUnassignQueryError = unknown


export function useTemplatesRelationsRolesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsRolesUnassign<TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsRolesUnassignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsRolesUnassignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsRolesUnassignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsRolesAvailable = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRoleSummary>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/assignable-roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsRolesAvailableQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams,) => {
    return [
    `/admin/templates/${templateId}/assignable-roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsRolesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsRolesAvailableQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>> = ({ signal }) => templatesRelationsRolesAvailable(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsRolesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>>
export type TemplatesRelationsRolesAvailableQueryError = unknown


export function useTemplatesRelationsRolesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsRolesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsRolesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsRolesAvailable<TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsRolesAvailableQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsRolesAvailableQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsRolesAvailableQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesList = (
    params?: TemplatesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateSummary>(
      {url: `/admin/templates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesListQueryKey = (params?: TemplatesListParams,) => {
    return [
    `/admin/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(params?: TemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesList>>> = ({ signal }) => templatesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof templatesList>>>
export type TemplatesListQueryError = ClientError


export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(
 params: undefined |  TemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesList>>,
          TError,
          Awaited<ReturnType<typeof templatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(
 params?: TemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesList>>,
          TError,
          Awaited<ReturnType<typeof templatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(
 params?: TemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesList<TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(
 params?: TemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesListQuery = async <TData = Awaited<ReturnType<typeof templatesList>>, TError = ClientError>(
 queryClient: QueryClient, params?: TemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesCreate = (
    createTemplateRequest: CreateTemplateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateSummary>(
      {url: `/admin/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTemplateRequest, signal
    },
      options);
    }




export const getTemplatesCreateQueryKey = (createTemplateRequest?: CreateTemplateRequest,) => {
    return [
    'POST', `/admin/templates`, createTemplateRequest
    ] as const;
    }


export const getTemplatesCreateQueryOptions = <TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(createTemplateRequest: CreateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesCreateQueryKey(createTemplateRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesCreate>>> = ({ signal }) => templatesCreate(createTemplateRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesCreate>>>
export type TemplatesCreateQueryError = ClientError


export function useTemplatesCreate<TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(
 createTemplateRequest: CreateTemplateRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesCreate>>,
          TError,
          Awaited<ReturnType<typeof templatesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesCreate<TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(
 createTemplateRequest: CreateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesCreate>>,
          TError,
          Awaited<ReturnType<typeof templatesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesCreate<TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(
 createTemplateRequest: CreateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesCreate<TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(
 createTemplateRequest: CreateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesCreateQueryOptions(createTemplateRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesCreateQuery = async <TData = Awaited<ReturnType<typeof templatesCreate>>, TError = ClientError>(
 queryClient: QueryClient, createTemplateRequest: CreateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesCreateQueryOptions(createTemplateRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesDetail = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateDetails>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesDetailQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}`
    ] as const;
    }


export const getTemplatesDetailQueryOptions = <TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesDetailQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesDetail>>> = ({ signal }) => templatesDetail(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesDetailQueryResult = NonNullable<Awaited<ReturnType<typeof templatesDetail>>>
export type TemplatesDetailQueryError = ClientError


export function useTemplatesDetail<TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesDetail>>,
          TError,
          Awaited<ReturnType<typeof templatesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesDetail<TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesDetail>>,
          TError,
          Awaited<ReturnType<typeof templatesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesDetail<TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesDetail<TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesDetailQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesDetailQuery = async <TData = Awaited<ReturnType<typeof templatesDetail>>, TError = ClientError>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesDetailQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesUpdate = (
    templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateSummary>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTemplateRequest, signal
    },
      options);
    }




export const getTemplatesUpdateQueryKey = (templateId: number | string | undefined | null,
    updateTemplateRequest?: UpdateTemplateRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}`, updateTemplateRequest
    ] as const;
    }


export const getTemplatesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesUpdateQueryKey(templateId,updateTemplateRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesUpdate>>> = ({ signal }) => templatesUpdate(templateId,updateTemplateRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesUpdate>>>
export type TemplatesUpdateQueryError = ClientError


export function useTemplatesUpdate<TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesUpdate<TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesUpdate<TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesUpdate<TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(
 templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesUpdateQueryOptions(templateId,updateTemplateRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesUpdate>>, TError = ClientError>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    updateTemplateRequest: UpdateTemplateRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesUpdateQueryOptions(templateId,updateTemplateRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesDelete = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesDeleteQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}`
    ] as const;
    }


export const getTemplatesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesDeleteQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesDelete>>> = ({ signal }) => templatesDelete(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof templatesDelete>>>
export type TemplatesDeleteQueryError = ClientError


export function useTemplatesDelete<TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesDelete>>,
          TError,
          Awaited<ReturnType<typeof templatesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesDelete<TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesDelete>>,
          TError,
          Awaited<ReturnType<typeof templatesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesDelete<TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesDelete<TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesDeleteQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesDeleteQuery = async <TData = Awaited<ReturnType<typeof templatesDelete>>, TError = ClientError>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesDeleteQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsContactLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/contact`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsContactLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/contact`
    ] as const;
    }


export const getTemplatesSettingsContactLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsContactLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsContactLoad>>> = ({ signal }) => templatesSettingsContactLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsContactLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsContactLoad>>>
export type TemplatesSettingsContactLoadQueryError = unknown


export function useTemplatesSettingsContactLoad<TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactLoad<TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactLoad<TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsContactLoad<TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsContactLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsContactLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsContactLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsContactUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/contact`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsContactUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest?: CreateOrUpdateContactSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/contact`, createOrUpdateContactSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsContactUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsContactUpdateQueryKey(templateId,createOrUpdateContactSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>> = ({ signal }) => templatesSettingsContactUpdate(templateId,createOrUpdateContactSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsContactUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>>
export type TemplatesSettingsContactUpdateQueryError = unknown


export function useTemplatesSettingsContactUpdate<TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactUpdate<TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactUpdate<TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsContactUpdate<TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsContactUpdateQueryOptions(templateId,createOrUpdateContactSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsContactUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsContactUpdateQueryOptions(templateId,createOrUpdateContactSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsContactReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/contact`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsContactResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/contact`
    ] as const;
    }


export const getTemplatesSettingsContactResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsContactResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsContactReset>>> = ({ signal }) => templatesSettingsContactReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsContactResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsContactReset>>>
export type TemplatesSettingsContactResetQueryError = unknown


export function useTemplatesSettingsContactReset<TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactReset<TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsContactReset<TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsContactReset<TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsContactResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsContactResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsContactResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsGeneralLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/general`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsGeneralLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/general`
    ] as const;
    }


export const getTemplatesSettingsGeneralLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsGeneralLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>> = ({ signal }) => templatesSettingsGeneralLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsGeneralLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>>
export type TemplatesSettingsGeneralLoadQueryError = unknown


export function useTemplatesSettingsGeneralLoad<TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralLoad<TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralLoad<TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsGeneralLoad<TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsGeneralLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsGeneralLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsGeneralLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsGeneralUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/general`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateGeneralSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsGeneralUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest?: CreateOrUpdateGeneralSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/general`, createOrUpdateGeneralSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsGeneralUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsGeneralUpdateQueryKey(templateId,createOrUpdateGeneralSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>> = ({ signal }) => templatesSettingsGeneralUpdate(templateId,createOrUpdateGeneralSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsGeneralUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>>
export type TemplatesSettingsGeneralUpdateQueryError = unknown


export function useTemplatesSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsGeneralUpdateQueryOptions(templateId,createOrUpdateGeneralSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsGeneralUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsGeneralUpdateQueryOptions(templateId,createOrUpdateGeneralSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsGeneralReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/general`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsGeneralResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/general`
    ] as const;
    }


export const getTemplatesSettingsGeneralResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsGeneralResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>> = ({ signal }) => templatesSettingsGeneralReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsGeneralResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>>
export type TemplatesSettingsGeneralResetQueryError = unknown


export function useTemplatesSettingsGeneralReset<TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralReset<TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsGeneralReset<TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsGeneralReset<TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsGeneralResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsGeneralResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsGeneralResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsLoginLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/login`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsLoginLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/login`
    ] as const;
    }


export const getTemplatesSettingsLoginLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsLoginLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>> = ({ signal }) => templatesSettingsLoginLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsLoginLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>>
export type TemplatesSettingsLoginLoadQueryError = unknown


export function useTemplatesSettingsLoginLoad<TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginLoad<TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginLoad<TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsLoginLoad<TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsLoginLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsLoginLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsLoginLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsLoginUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/login`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateLoginSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsLoginUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest?: CreateOrUpdateLoginSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/login`, createOrUpdateLoginSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsLoginUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsLoginUpdateQueryKey(templateId,createOrUpdateLoginSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>> = ({ signal }) => templatesSettingsLoginUpdate(templateId,createOrUpdateLoginSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsLoginUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>>
export type TemplatesSettingsLoginUpdateQueryError = unknown


export function useTemplatesSettingsLoginUpdate<TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginUpdate<TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginUpdate<TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsLoginUpdate<TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsLoginUpdateQueryOptions(templateId,createOrUpdateLoginSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsLoginUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsLoginUpdateQueryOptions(templateId,createOrUpdateLoginSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsLoginReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/login`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsLoginResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/login`
    ] as const;
    }


export const getTemplatesSettingsLoginResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsLoginResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsLoginReset>>> = ({ signal }) => templatesSettingsLoginReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsLoginResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsLoginReset>>>
export type TemplatesSettingsLoginResetQueryError = unknown


export function useTemplatesSettingsLoginReset<TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginReset<TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsLoginReset<TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsLoginReset<TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsLoginResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsLoginResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsLoginResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsPhoneLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/phone`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsPhoneLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/phone`
    ] as const;
    }


export const getTemplatesSettingsPhoneLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsPhoneLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>> = ({ signal }) => templatesSettingsPhoneLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsPhoneLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>>
export type TemplatesSettingsPhoneLoadQueryError = unknown


export function useTemplatesSettingsPhoneLoad<TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneLoad<TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneLoad<TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsPhoneLoad<TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsPhoneLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsPhoneLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsPhoneLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsPhoneUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/phone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePhoneSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsPhoneUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest?: CreateOrUpdatePhoneSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/phone`, createOrUpdatePhoneSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsPhoneUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsPhoneUpdateQueryKey(templateId,createOrUpdatePhoneSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>> = ({ signal }) => templatesSettingsPhoneUpdate(templateId,createOrUpdatePhoneSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsPhoneUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>>
export type TemplatesSettingsPhoneUpdateQueryError = unknown


export function useTemplatesSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsPhoneUpdateQueryOptions(templateId,createOrUpdatePhoneSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsPhoneUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsPhoneUpdateQueryOptions(templateId,createOrUpdatePhoneSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsPhoneReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/phone`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsPhoneResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/phone`
    ] as const;
    }


export const getTemplatesSettingsPhoneResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsPhoneResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>> = ({ signal }) => templatesSettingsPhoneReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsPhoneResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>>
export type TemplatesSettingsPhoneResetQueryError = unknown


export function useTemplatesSettingsPhoneReset<TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneReset<TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsPhoneReset<TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsPhoneReset<TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsPhoneResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsPhoneResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsPhoneResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsRecordingLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/recording`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsRecordingLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/recording`
    ] as const;
    }


export const getTemplatesSettingsRecordingLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsRecordingLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>> = ({ signal }) => templatesSettingsRecordingLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsRecordingLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>>
export type TemplatesSettingsRecordingLoadQueryError = unknown


export function useTemplatesSettingsRecordingLoad<TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingLoad<TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingLoad<TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsRecordingLoad<TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsRecordingLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsRecordingLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsRecordingLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsRecordingUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/recording`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRecordingSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsRecordingUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest?: CreateOrUpdateRecordingSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/recording`, createOrUpdateRecordingSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsRecordingUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsRecordingUpdateQueryKey(templateId,createOrUpdateRecordingSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>> = ({ signal }) => templatesSettingsRecordingUpdate(templateId,createOrUpdateRecordingSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsRecordingUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>>
export type TemplatesSettingsRecordingUpdateQueryError = unknown


export function useTemplatesSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsRecordingUpdateQueryOptions(templateId,createOrUpdateRecordingSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsRecordingUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsRecordingUpdateQueryOptions(templateId,createOrUpdateRecordingSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsRecordingReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/recording`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsRecordingResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/recording`
    ] as const;
    }


export const getTemplatesSettingsRecordingResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsRecordingResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>> = ({ signal }) => templatesSettingsRecordingReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsRecordingResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>>
export type TemplatesSettingsRecordingResetQueryError = unknown


export function useTemplatesSettingsRecordingReset<TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingReset<TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsRecordingReset<TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsRecordingReset<TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsRecordingResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsRecordingResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsRecordingResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsSetclipLoad = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/setclip`, method: 'GET', signal
    },
      options);
    }




export const getTemplatesSettingsSetclipLoadQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    `/admin/templates/${templateId}/settings/setclip`
    ] as const;
    }


export const getTemplatesSettingsSetclipLoadQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsSetclipLoadQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>> = ({ signal }) => templatesSettingsSetclipLoad(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsSetclipLoadQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>>
export type TemplatesSettingsSetclipLoadQueryError = unknown


export function useTemplatesSettingsSetclipLoad<TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipLoad<TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipLoad<TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsSetclipLoad<TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsSetclipLoadQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsSetclipLoadQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsSetclipLoadQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsSetclipUpdate = (
    templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/setclip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSetClipSettingsRequest, signal
    },
      options);
    }




export const getTemplatesSettingsSetclipUpdateQueryKey = (templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest?: CreateOrUpdateSetClipSettingsRequest,) => {
    return [
    'PUT', `/admin/templates/${templateId}/settings/setclip`, createOrUpdateSetClipSettingsRequest
    ] as const;
    }


export const getTemplatesSettingsSetclipUpdateQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsSetclipUpdateQueryKey(templateId,createOrUpdateSetClipSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>> = ({ signal }) => templatesSettingsSetclipUpdate(templateId,createOrUpdateSetClipSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsSetclipUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>>
export type TemplatesSettingsSetclipUpdateQueryError = unknown


export function useTemplatesSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(
 templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsSetclipUpdateQueryOptions(templateId,createOrUpdateSetClipSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsSetclipUpdateQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsSetclipUpdateQueryOptions(templateId,createOrUpdateSetClipSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesSettingsSetclipReset = (
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/settings/setclip`, method: 'DELETE', signal
    },
      options);
    }




export const getTemplatesSettingsSetclipResetQueryKey = (templateId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/templates/${templateId}/settings/setclip`
    ] as const;
    }


export const getTemplatesSettingsSetclipResetQueryOptions = <TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesSettingsSetclipResetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>> = ({ signal }) => templatesSettingsSetclipReset(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesSettingsSetclipResetQueryResult = NonNullable<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>>
export type TemplatesSettingsSetclipResetQueryError = unknown


export function useTemplatesSettingsSetclipReset<TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipReset<TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof templatesSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesSettingsSetclipReset<TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesSettingsSetclipReset<TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(
 templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesSettingsSetclipResetQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesSettingsSetclipResetQuery = async <TData = Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesSettingsSetclipResetQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsSkillsAssigned = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateSkillResponse>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsSkillsAssignedQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams,) => {
    return [
    `/admin/templates/${templateId}/skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsSkillsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsSkillsAssignedQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>> = ({ signal }) => templatesRelationsSkillsAssigned(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsSkillsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>>
export type TemplatesRelationsSkillsAssignedQueryError = unknown


export function useTemplatesRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsSkillsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsSkillsAssignedQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsSkillsAssignedQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsSkillsAssignedQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsSkillsAssign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateSkillResponse[]>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsSkillsAssignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/templates/${templateId}/skills`, numberString
    ] as const;
    }


export const getTemplatesRelationsSkillsAssignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsSkillsAssignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>> = ({ signal }) => templatesRelationsSkillsAssign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsSkillsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>>
export type TemplatesRelationsSkillsAssignQueryError = unknown


export function useTemplatesRelationsSkillsAssign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAssign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAssign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsSkillsAssign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsSkillsAssignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsSkillsAssignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsSkillsAssignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsSkillsUnassign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/skills`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsSkillsUnassignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/templates/${templateId}/skills`, numberString
    ] as const;
    }


export const getTemplatesRelationsSkillsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsSkillsUnassignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>> = ({ signal }) => templatesRelationsSkillsUnassign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsSkillsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>>
export type TemplatesRelationsSkillsUnassignQueryError = unknown


export function useTemplatesRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsSkillsUnassignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsSkillsUnassignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsSkillsUnassignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsSkillsAvailable = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillSummary>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/assignable-skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsSkillsAvailableQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams,) => {
    return [
    `/admin/templates/${templateId}/assignable-skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsSkillsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsSkillsAvailableQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>> = ({ signal }) => templatesRelationsSkillsAvailable(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsSkillsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>>
export type TemplatesRelationsSkillsAvailableQueryError = unknown


export function useTemplatesRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsSkillsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsSkillsAvailableQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsSkillsAvailableQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsSkillsAvailableQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsTeamsAssigned = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTemplateTeamResponse>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsTeamsAssignedQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams,) => {
    return [
    `/admin/templates/${templateId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsTeamsAssignedQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>> = ({ signal }) => templatesRelationsTeamsAssigned(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>>
export type TemplatesRelationsTeamsAssignedQueryError = unknown


export function useTemplatesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsTeamsAssignedQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsTeamsAssignedQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsTeamsAssign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TemplateTeamResponse[]>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsTeamsAssignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/templates/${templateId}/teams`, numberString
    ] as const;
    }


export const getTemplatesRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsTeamsAssignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>> = ({ signal }) => templatesRelationsTeamsAssign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>>
export type TemplatesRelationsTeamsAssignQueryError = unknown


export function useTemplatesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsTeamsAssignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsTeamsAssignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsTeamsUnassign = (
    templateId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTemplatesRelationsTeamsUnassignQueryKey = (templateId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/templates/${templateId}/teams`, numberString
    ] as const;
    }


export const getTemplatesRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsTeamsUnassignQueryKey(templateId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>> = ({ signal }) => templatesRelationsTeamsUnassign(templateId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>>
export type TemplatesRelationsTeamsUnassignQueryError = unknown


export function useTemplatesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(
 templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsTeamsUnassignQueryOptions(templateId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsTeamsUnassignQueryOptions(templateId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const templatesRelationsTeamsAvailable = (
    templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/templates/${encodeURIComponent(String(templateId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTemplatesRelationsTeamsAvailableQueryKey = (templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams,) => {
    return [
    `/admin/templates/${templateId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getTemplatesRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplatesRelationsTeamsAvailableQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>> = ({ signal }) => templatesRelationsTeamsAvailable(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplatesRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>>
export type TemplatesRelationsTeamsAvailableQueryError = unknown


export function useTemplatesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params: undefined |  TemplatesRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplatesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplatesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(
 templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplatesRelationsTeamsAvailableQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTemplatesRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, templateId: number | string | undefined | null,
    params?: TemplatesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templatesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTemplatesRelationsTeamsAvailableQueryOptions(templateId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsCustomPagesAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamCustomPageResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsCustomPagesAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsCustomPagesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsCustomPagesAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>> = ({ signal }) => teamsRelationsCustomPagesAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsCustomPagesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>>
export type TeamsRelationsCustomPagesAssignedQueryError = unknown


export function useTeamsRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsCustomPagesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsCustomPagesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsCustomPagesAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsCustomPagesAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsCustomPagesAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsCustomPagesAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamCustomPageResponse[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/custompages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsCustomPagesAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/custompages`, numberString
    ] as const;
    }


export const getTeamsRelationsCustomPagesAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsCustomPagesAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>> = ({ signal }) => teamsRelationsCustomPagesAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsCustomPagesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>>
export type TeamsRelationsCustomPagesAssignQueryError = unknown


export function useTeamsRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsCustomPagesAssign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsCustomPagesAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsCustomPagesAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsCustomPagesAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsCustomPagesUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/custompages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsCustomPagesUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/custompages`, numberString
    ] as const;
    }


export const getTeamsRelationsCustomPagesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsCustomPagesUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>> = ({ signal }) => teamsRelationsCustomPagesUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsCustomPagesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>>
export type TeamsRelationsCustomPagesUnassignQueryError = unknown


export function useTeamsRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsCustomPagesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsCustomPagesUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsCustomPagesUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsCustomPagesUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsCustomPagesAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPageDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsCustomPagesAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsCustomPagesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsCustomPagesAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>> = ({ signal }) => teamsRelationsCustomPagesAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsCustomPagesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>>
export type TeamsRelationsCustomPagesAvailableQueryError = unknown


export function useTeamsRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsCustomPagesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsCustomPagesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsCustomPagesAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsCustomPagesAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsCustomPagesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsCustomPagesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsCustomPagesAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsPauseReasonsAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamPauseReasonResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/pausereasons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsPauseReasonsAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/pausereasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsPauseReasonsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsPauseReasonsAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>> = ({ signal }) => teamsRelationsPauseReasonsAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsPauseReasonsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>>
export type TeamsRelationsPauseReasonsAssignedQueryError = ClientError


export function useTeamsRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsPauseReasonsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsPauseReasonsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsPauseReasonsAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsPauseReasonsAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsPauseReasonsAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsPauseReasonsAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamPauseReasonResponse[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/pausereasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsPauseReasonsAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/pausereasons`, numberString
    ] as const;
    }


export const getTeamsRelationsPauseReasonsAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsPauseReasonsAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>> = ({ signal }) => teamsRelationsPauseReasonsAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsPauseReasonsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>>
export type TeamsRelationsPauseReasonsAssignQueryError = unknown


export function useTeamsRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsPauseReasonsAssign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsPauseReasonsAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsPauseReasonsAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsPauseReasonsAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsPauseReasonsUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/pausereasons`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsPauseReasonsUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/pausereasons`, numberString
    ] as const;
    }


export const getTeamsRelationsPauseReasonsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsPauseReasonsUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>> = ({ signal }) => teamsRelationsPauseReasonsUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsPauseReasonsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>>
export type TeamsRelationsPauseReasonsUnassignQueryError = unknown


export function useTeamsRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsPauseReasonsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsPauseReasonsUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsPauseReasonsUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsPauseReasonsUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsPauseReasonsAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfPauseReasonSummary>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-pausereasons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsPauseReasonsAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-pausereasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsPauseReasonsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsPauseReasonsAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>> = ({ signal }) => teamsRelationsPauseReasonsAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsPauseReasonsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>>
export type TeamsRelationsPauseReasonsAvailableQueryError = ClientError


export function useTeamsRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsPauseReasonsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsPauseReasonsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsPauseReasonsAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsPauseReasonsAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError = ClientError>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsPauseReasonsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsPauseReasonsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsPauseReasonsAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsQueuesAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamQueueResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsQueuesAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsQueuesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsQueuesAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>> = ({ signal }) => teamsRelationsQueuesAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsQueuesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>>
export type TeamsRelationsQueuesAssignedQueryError = ClientError


export function useTeamsRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsQueuesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsQueuesAssigned<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsQueuesAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsQueuesAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError = ClientError>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsQueuesAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsQueuesAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamQueueResponse[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/queues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsQueuesAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/queues`, numberString
    ] as const;
    }


export const getTeamsRelationsQueuesAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsQueuesAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>> = ({ signal }) => teamsRelationsQueuesAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsQueuesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>>
export type TeamsRelationsQueuesAssignQueryError = unknown


export function useTeamsRelationsQueuesAssign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAssign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAssign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsQueuesAssign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsQueuesAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsQueuesAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsQueuesAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsQueuesUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/queues`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsQueuesUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/queues`, numberString
    ] as const;
    }


export const getTeamsRelationsQueuesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsQueuesUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>> = ({ signal }) => teamsRelationsQueuesUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsQueuesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>>
export type TeamsRelationsQueuesUnassignQueryError = unknown


export function useTeamsRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsQueuesUnassign<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsQueuesUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsQueuesUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsQueuesUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsQueuesAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfQueueSummary>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsQueuesAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsQueuesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsQueuesAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>> = ({ signal }) => teamsRelationsQueuesAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsQueuesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>>
export type TeamsRelationsQueuesAvailableQueryError = unknown


export function useTeamsRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsQueuesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsQueuesAvailable<TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsQueuesAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsQueuesAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsQueuesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsQueuesAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsQueuesUpdate = (
    teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamQueueResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/queues/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamQueueRequest, signal
    },
      options);
    }




export const getTeamsRelationsQueuesUpdateQueryKey = (teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest?: UpdateTeamQueueRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/queues/${mappingId}`, updateTeamQueueRequest
    ] as const;
    }


export const getTeamsRelationsQueuesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsQueuesUpdateQueryKey(teamId,mappingId,updateTeamQueueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>> = ({ signal }) => teamsRelationsQueuesUpdate(teamId,mappingId,updateTeamQueueRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsQueuesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>>
export type TeamsRelationsQueuesUpdateQueryError = unknown


export function useTeamsRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsQueuesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsQueuesUpdateQueryOptions(teamId,mappingId,updateTeamQueueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsQueuesUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateTeamQueueRequest: UpdateTeamQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsQueuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsQueuesUpdateQueryOptions(teamId,mappingId,updateTeamQueueRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsList = (
    params?: TeamsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsListQueryKey = (params?: TeamsListParams,) => {
    return [
    `/admin/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsListQueryOptions = <TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(params?: TeamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsList>>> = ({ signal }) => teamsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsListQueryResult = NonNullable<Awaited<ReturnType<typeof teamsList>>>
export type TeamsListQueryError = ClientError


export function useTeamsList<TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(
 params: undefined |  TeamsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsList>>,
          TError,
          Awaited<ReturnType<typeof teamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsList<TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(
 params?: TeamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsList>>,
          TError,
          Awaited<ReturnType<typeof teamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsList<TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(
 params?: TeamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsList<TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(
 params?: TeamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsListQuery = async <TData = Awaited<ReturnType<typeof teamsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: TeamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsCreate = (
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSummary>(
      {url: `/admin/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateTeamRequest, signal
    },
      options);
    }




export const getTeamsCreateQueryKey = (createOrUpdateTeamRequest?: CreateOrUpdateTeamRequest,) => {
    return [
    'POST', `/admin/teams`, createOrUpdateTeamRequest
    ] as const;
    }


export const getTeamsCreateQueryOptions = <TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsCreateQueryKey(createOrUpdateTeamRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsCreate>>> = ({ signal }) => teamsCreate(createOrUpdateTeamRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsCreate>>>
export type TeamsCreateQueryError = unknown


export function useTeamsCreate<TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(
 createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsCreate>>,
          TError,
          Awaited<ReturnType<typeof teamsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsCreate<TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(
 createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsCreate>>,
          TError,
          Awaited<ReturnType<typeof teamsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsCreate<TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(
 createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsCreate<TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(
 createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsCreateQueryOptions(createOrUpdateTeamRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsCreateQuery = async <TData = Awaited<ReturnType<typeof teamsCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsCreateQueryOptions(createOrUpdateTeamRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsDetail = (
    teamId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamDetails>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}`, method: 'GET', signal
    },
      options);
    }




export const getTeamsDetailQueryKey = (teamId: number | undefined | null,) => {
    return [
    `/admin/teams/${teamId}`
    ] as const;
    }


export const getTeamsDetailQueryOptions = <TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(teamId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsDetailQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsDetail>>> = ({ signal }) => teamsDetail(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsDetailQueryResult = NonNullable<Awaited<ReturnType<typeof teamsDetail>>>
export type TeamsDetailQueryError = ClientError


export function useTeamsDetail<TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(
 teamId: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsDetail>>,
          TError,
          Awaited<ReturnType<typeof teamsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsDetail<TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(
 teamId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsDetail>>,
          TError,
          Awaited<ReturnType<typeof teamsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsDetail<TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(
 teamId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsDetail<TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(
 teamId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsDetailQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsDetailQuery = async <TData = Awaited<ReturnType<typeof teamsDetail>>, TError = ClientError>(
 queryClient: QueryClient, teamId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsDetailQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSummary>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateTeamRequest, signal
    },
      options);
    }




export const getTeamsUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateTeamRequest?: CreateOrUpdateTeamRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}`, createOrUpdateTeamRequest
    ] as const;
    }


export const getTeamsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsUpdateQueryKey(teamId,createOrUpdateTeamRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsUpdate>>> = ({ signal }) => teamsUpdate(teamId,createOrUpdateTeamRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsUpdate>>>
export type TeamsUpdateQueryError = unknown


export function useTeamsUpdate<TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsUpdate<TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsUpdate<TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsUpdate<TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsUpdateQueryOptions(teamId,createOrUpdateTeamRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateTeamRequest: CreateOrUpdateTeamRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsUpdateQueryOptions(teamId,createOrUpdateTeamRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsDelete = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsDeleteQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}`
    ] as const;
    }


export const getTeamsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsDeleteQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsDelete>>> = ({ signal }) => teamsDelete(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof teamsDelete>>>
export type TeamsDeleteQueryError = unknown


export function useTeamsDelete<TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsDelete>>,
          TError,
          Awaited<ReturnType<typeof teamsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsDelete<TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsDelete>>,
          TError,
          Awaited<ReturnType<typeof teamsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsDelete<TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsDelete<TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsDeleteQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsDeleteQuery = async <TData = Awaited<ReturnType<typeof teamsDelete>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsDeleteQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillGroupsAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSkillGroupResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsSkillGroupsAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsSkillGroupsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillGroupsAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>> = ({ signal }) => teamsRelationsSkillGroupsAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillGroupsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>>
export type TeamsRelationsSkillGroupsAssignedQueryError = unknown


export function useTeamsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsSkillGroupsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillGroupsAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillGroupsAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillGroupsAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillGroupsAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSkillGroupResponse[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skillgroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsSkillGroupsAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/skillgroups`, numberString
    ] as const;
    }


export const getTeamsRelationsSkillGroupsAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillGroupsAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>> = ({ signal }) => teamsRelationsSkillGroupsAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillGroupsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>>
export type TeamsRelationsSkillGroupsAssignQueryError = unknown


export function useTeamsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillGroupsAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillGroupsAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillGroupsAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillGroupsUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skillgroups`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsSkillGroupsUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/skillgroups`, numberString
    ] as const;
    }


export const getTeamsRelationsSkillGroupsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillGroupsUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>> = ({ signal }) => teamsRelationsSkillGroupsUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillGroupsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>>
export type TeamsRelationsSkillGroupsUnassignQueryError = unknown


export function useTeamsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillGroupsUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillGroupsUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillGroupsUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillGroupsAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSummary>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsSkillGroupsAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsSkillGroupsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillGroupsAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>> = ({ signal }) => teamsRelationsSkillGroupsAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillGroupsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>>
export type TeamsRelationsSkillGroupsAvailableQueryError = unknown


export function useTeamsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsSkillGroupsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillGroupsAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillGroupsAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillGroupsAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillsAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSkillResponse>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsSkillsAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsSkillsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillsAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>> = ({ signal }) => teamsRelationsSkillsAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>>
export type TeamsRelationsSkillsAssignedQueryError = unknown


export function useTeamsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsSkillsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillsAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillsAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillsAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillsAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSkillResponse[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsSkillsAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/skills`, numberString
    ] as const;
    }


export const getTeamsRelationsSkillsAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillsAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>> = ({ signal }) => teamsRelationsSkillsAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>>
export type TeamsRelationsSkillsAssignQueryError = unknown


export function useTeamsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillsAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillsAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillsAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillsUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/skills`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsSkillsUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/skills`, numberString
    ] as const;
    }


export const getTeamsRelationsSkillsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillsUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>> = ({ signal }) => teamsRelationsSkillsUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>>
export type TeamsRelationsSkillsUnassignQueryError = unknown


export function useTeamsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillsUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillsUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillsUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsSkillsAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillSummary>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsSkillsAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsSkillsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsSkillsAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>> = ({ signal }) => teamsRelationsSkillsAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsSkillsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>>
export type TeamsRelationsSkillsAvailableQueryError = unknown


export function useTeamsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsSkillsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsSkillsAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsSkillsAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsSkillsAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsTemplatesUpdate = (
    teamId: number | string | undefined | null,
    templateId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/templates/${encodeURIComponent(String(templateId))}`, method: 'PUT', signal
    },
      options);
    }




export const getTeamsRelationsTemplatesUpdateQueryKey = (teamId: number | string | undefined | null,
    templateId: number | string | undefined | null,) => {
    return [
    'PUT', `/admin/teams/${teamId}/templates/${templateId}`
    ] as const;
    }


export const getTeamsRelationsTemplatesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsTemplatesUpdateQueryKey(teamId,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>> = ({ signal }) => teamsRelationsTemplatesUpdate(teamId,templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsTemplatesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>>
export type TeamsRelationsTemplatesUpdateQueryError = unknown


export function useTeamsRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsTemplatesUpdate<TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsTemplatesUpdateQueryOptions(teamId,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsTemplatesUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    templateId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsTemplatesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsTemplatesUpdateQueryOptions(teamId,templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsUsersAssigned = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamUserDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsUsersAssignedQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams,) => {
    return [
    `/admin/teams/${teamId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsUsersAssignedQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>> = ({ signal }) => teamsRelationsUsersAssigned(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>>
export type TeamsRelationsUsersAssignedQueryError = ClientError


export function useTeamsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsUsersAssignedQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError = ClientError>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsUsersAssignedQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsUsersAssign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto[]>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsUsersAssignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/teams/${teamId}/users`, numberString
    ] as const;
    }


export const getTeamsRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsUsersAssignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>> = ({ signal }) => teamsRelationsUsersAssign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>>
export type TeamsRelationsUsersAssignQueryError = unknown


export function useTeamsRelationsUsersAssign<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAssign<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAssign<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsUsersAssign<TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsUsersAssignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsUsersAssignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsUsersUnassign = (
    teamId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getTeamsRelationsUsersUnassignQueryKey = (teamId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/teams/${teamId}/users`, numberString
    ] as const;
    }


export const getTeamsRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsUsersUnassignQueryKey(teamId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>> = ({ signal }) => teamsRelationsUsersUnassign(teamId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>>
export type TeamsRelationsUsersUnassignQueryError = unknown


export function useTeamsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(
 teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsUsersUnassignQueryOptions(teamId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsUsersUnassignQueryOptions(teamId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsRelationsUsersAvailable = (
    teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTeamsRelationsUsersAvailableQueryKey = (teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams,) => {
    return [
    `/admin/teams/${teamId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsRelationsUsersAvailableQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>> = ({ signal }) => teamsRelationsUsersAvailable(teamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>>
export type TeamsRelationsUsersAvailableQueryError = unknown


export function useTeamsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params: undefined |  TeamsRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(
 teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsRelationsUsersAvailableQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    params?: TeamsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsRelationsUsersAvailableQueryOptions(teamId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsClientGet = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamUserDto[]>(
      {url: `/api/teams`, method: 'GET', signal
    },
      options);
    }




export const getTeamsClientGetQueryKey = () => {
    return [
    `/api/teams`
    ] as const;
    }


export const getTeamsClientGetQueryOptions = <TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsClientGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsClientGet>>> = ({ signal }) => teamsClientGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsClientGetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsClientGet>>>
export type TeamsClientGetQueryError = unknown


export function useTeamsClientGet<TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsClientGet>>,
          TError,
          Awaited<ReturnType<typeof teamsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsClientGet<TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsClientGet>>,
          TError,
          Awaited<ReturnType<typeof teamsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsClientGet<TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsClientGet<TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsClientGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsClientGetQuery = async <TData = Awaited<ReturnType<typeof teamsClientGet>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsClientGetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsContactLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/contact`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsContactLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/contact`
    ] as const;
    }


export const getTeamsSettingsContactLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsContactLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsContactLoad>>> = ({ signal }) => teamsSettingsContactLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsContactLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsContactLoad>>>
export type TeamsSettingsContactLoadQueryError = unknown


export function useTeamsSettingsContactLoad<TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactLoad<TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactLoad<TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsContactLoad<TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsContactLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsContactLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsContactLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsContactUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/contact`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsContactUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest?: CreateOrUpdateContactSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/contact`, createOrUpdateContactSettingsRequest
    ] as const;
    }


export const getTeamsSettingsContactUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsContactUpdateQueryKey(teamId,createOrUpdateContactSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>> = ({ signal }) => teamsSettingsContactUpdate(teamId,createOrUpdateContactSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsContactUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>>
export type TeamsSettingsContactUpdateQueryError = unknown


export function useTeamsSettingsContactUpdate<TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactUpdate<TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactUpdate<TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsContactUpdate<TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsContactUpdateQueryOptions(teamId,createOrUpdateContactSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsContactUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsContactUpdateQueryOptions(teamId,createOrUpdateContactSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsContactReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/contact`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsContactResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/contact`
    ] as const;
    }


export const getTeamsSettingsContactResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsContactResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsContactReset>>> = ({ signal }) => teamsSettingsContactReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsContactResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsContactReset>>>
export type TeamsSettingsContactResetQueryError = unknown


export function useTeamsSettingsContactReset<TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactReset<TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsContactReset<TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsContactReset<TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsContactResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsContactResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsContactResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsGeneralLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/general`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsGeneralLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/general`
    ] as const;
    }


export const getTeamsSettingsGeneralLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsGeneralLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>> = ({ signal }) => teamsSettingsGeneralLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsGeneralLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>>
export type TeamsSettingsGeneralLoadQueryError = unknown


export function useTeamsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsGeneralLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsGeneralLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsGeneralLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsGeneralUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/general`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateGeneralSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsGeneralUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest?: CreateOrUpdateGeneralSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/general`, createOrUpdateGeneralSettingsRequest
    ] as const;
    }


export const getTeamsSettingsGeneralUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsGeneralUpdateQueryKey(teamId,createOrUpdateGeneralSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>> = ({ signal }) => teamsSettingsGeneralUpdate(teamId,createOrUpdateGeneralSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsGeneralUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>>
export type TeamsSettingsGeneralUpdateQueryError = unknown


export function useTeamsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsGeneralUpdateQueryOptions(teamId,createOrUpdateGeneralSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsGeneralUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsGeneralUpdateQueryOptions(teamId,createOrUpdateGeneralSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsGeneralReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/general`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsGeneralResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/general`
    ] as const;
    }


export const getTeamsSettingsGeneralResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsGeneralResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>> = ({ signal }) => teamsSettingsGeneralReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsGeneralResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>>
export type TeamsSettingsGeneralResetQueryError = unknown


export function useTeamsSettingsGeneralReset<TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralReset<TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsGeneralReset<TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsGeneralReset<TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsGeneralResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsGeneralResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsGeneralResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsLoginLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/login`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsLoginLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/login`
    ] as const;
    }


export const getTeamsSettingsLoginLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsLoginLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>> = ({ signal }) => teamsSettingsLoginLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsLoginLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>>
export type TeamsSettingsLoginLoadQueryError = unknown


export function useTeamsSettingsLoginLoad<TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginLoad<TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginLoad<TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsLoginLoad<TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsLoginLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsLoginLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsLoginLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsLoginUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/login`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateLoginSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsLoginUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest?: CreateOrUpdateLoginSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/login`, createOrUpdateLoginSettingsRequest
    ] as const;
    }


export const getTeamsSettingsLoginUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsLoginUpdateQueryKey(teamId,createOrUpdateLoginSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>> = ({ signal }) => teamsSettingsLoginUpdate(teamId,createOrUpdateLoginSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsLoginUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>>
export type TeamsSettingsLoginUpdateQueryError = unknown


export function useTeamsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsLoginUpdateQueryOptions(teamId,createOrUpdateLoginSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsLoginUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsLoginUpdateQueryOptions(teamId,createOrUpdateLoginSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsLoginReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/login`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsLoginResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/login`
    ] as const;
    }


export const getTeamsSettingsLoginResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsLoginResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsLoginReset>>> = ({ signal }) => teamsSettingsLoginReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsLoginResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsLoginReset>>>
export type TeamsSettingsLoginResetQueryError = unknown


export function useTeamsSettingsLoginReset<TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginReset<TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsLoginReset<TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsLoginReset<TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsLoginResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsLoginResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsLoginResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsPhoneLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/phone`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsPhoneLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/phone`
    ] as const;
    }


export const getTeamsSettingsPhoneLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsPhoneLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>> = ({ signal }) => teamsSettingsPhoneLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsPhoneLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>>
export type TeamsSettingsPhoneLoadQueryError = unknown


export function useTeamsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsPhoneLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsPhoneLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsPhoneLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsPhoneUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/phone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePhoneSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsPhoneUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest?: CreateOrUpdatePhoneSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/phone`, createOrUpdatePhoneSettingsRequest
    ] as const;
    }


export const getTeamsSettingsPhoneUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsPhoneUpdateQueryKey(teamId,createOrUpdatePhoneSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>> = ({ signal }) => teamsSettingsPhoneUpdate(teamId,createOrUpdatePhoneSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsPhoneUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>>
export type TeamsSettingsPhoneUpdateQueryError = unknown


export function useTeamsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsPhoneUpdateQueryOptions(teamId,createOrUpdatePhoneSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsPhoneUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsPhoneUpdateQueryOptions(teamId,createOrUpdatePhoneSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsPhoneReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/phone`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsPhoneResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/phone`
    ] as const;
    }


export const getTeamsSettingsPhoneResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsPhoneResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>> = ({ signal }) => teamsSettingsPhoneReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsPhoneResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>>
export type TeamsSettingsPhoneResetQueryError = unknown


export function useTeamsSettingsPhoneReset<TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneReset<TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsPhoneReset<TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsPhoneReset<TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsPhoneResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsPhoneResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsPhoneResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsRecordingLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/recording`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsRecordingLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/recording`
    ] as const;
    }


export const getTeamsSettingsRecordingLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsRecordingLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>> = ({ signal }) => teamsSettingsRecordingLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsRecordingLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>>
export type TeamsSettingsRecordingLoadQueryError = unknown


export function useTeamsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsRecordingLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsRecordingLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsRecordingLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsRecordingUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/recording`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRecordingSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsRecordingUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest?: CreateOrUpdateRecordingSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/recording`, createOrUpdateRecordingSettingsRequest
    ] as const;
    }


export const getTeamsSettingsRecordingUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsRecordingUpdateQueryKey(teamId,createOrUpdateRecordingSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>> = ({ signal }) => teamsSettingsRecordingUpdate(teamId,createOrUpdateRecordingSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsRecordingUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>>
export type TeamsSettingsRecordingUpdateQueryError = unknown


export function useTeamsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsRecordingUpdateQueryOptions(teamId,createOrUpdateRecordingSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsRecordingUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsRecordingUpdateQueryOptions(teamId,createOrUpdateRecordingSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsRecordingReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/recording`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsRecordingResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/recording`
    ] as const;
    }


export const getTeamsSettingsRecordingResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsRecordingResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>> = ({ signal }) => teamsSettingsRecordingReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsRecordingResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>>
export type TeamsSettingsRecordingResetQueryError = unknown


export function useTeamsSettingsRecordingReset<TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingReset<TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsRecordingReset<TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsRecordingReset<TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsRecordingResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsRecordingResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsRecordingResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsSetclipLoad = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/setclip`, method: 'GET', signal
    },
      options);
    }




export const getTeamsSettingsSetclipLoadQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    `/admin/teams/${teamId}/settings/setclip`
    ] as const;
    }


export const getTeamsSettingsSetclipLoadQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsSetclipLoadQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>> = ({ signal }) => teamsSettingsSetclipLoad(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsSetclipLoadQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>>
export type TeamsSettingsSetclipLoadQueryError = unknown


export function useTeamsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsSetclipLoadQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsSetclipLoadQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsSetclipLoadQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsSetclipUpdate = (
    teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/setclip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSetClipSettingsRequest, signal
    },
      options);
    }




export const getTeamsSettingsSetclipUpdateQueryKey = (teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest?: CreateOrUpdateSetClipSettingsRequest,) => {
    return [
    'PUT', `/admin/teams/${teamId}/settings/setclip`, createOrUpdateSetClipSettingsRequest
    ] as const;
    }


export const getTeamsSettingsSetclipUpdateQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsSetclipUpdateQueryKey(teamId,createOrUpdateSetClipSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>> = ({ signal }) => teamsSettingsSetclipUpdate(teamId,createOrUpdateSetClipSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsSetclipUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>>
export type TeamsSettingsSetclipUpdateQueryError = unknown


export function useTeamsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(
 teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsSetclipUpdateQueryOptions(teamId,createOrUpdateSetClipSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsSetclipUpdateQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null,
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsSetclipUpdateQueryOptions(teamId,createOrUpdateSetClipSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const teamsSettingsSetclipReset = (
    teamId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/teams/${encodeURIComponent(String(teamId))}/settings/setclip`, method: 'DELETE', signal
    },
      options);
    }




export const getTeamsSettingsSetclipResetQueryKey = (teamId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/teams/${teamId}/settings/setclip`
    ] as const;
    }


export const getTeamsSettingsSetclipResetQueryOptions = <TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsSettingsSetclipResetQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>> = ({ signal }) => teamsSettingsSetclipReset(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsSettingsSetclipResetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>>
export type TeamsSettingsSetclipResetQueryError = unknown


export function useTeamsSettingsSetclipReset<TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipReset<TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof teamsSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsSettingsSetclipReset<TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamsSettingsSetclipReset<TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(
 teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsSettingsSetclipResetQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchTeamsSettingsSetclipResetQuery = async <TData = Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError = unknown>(
 queryClient: QueryClient, teamId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getTeamsSettingsSetclipResetQueryOptions(teamId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsList = (
    params?: SkillsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillSummary>(
      {url: `/admin/skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsListQueryKey = (params?: SkillsListParams,) => {
    return [
    `/admin/skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsListQueryOptions = <TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsList>>> = ({ signal }) => skillsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsList>>>
export type SkillsListQueryError = ClientError


export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(
 params: undefined |  SkillsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsListQuery = async <TData = Awaited<ReturnType<typeof skillsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsCreate = (
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillSummary>(
      {url: `/admin/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSkillRequest, signal
    },
      options);
    }




export const getSkillsCreateQueryKey = (createOrUpdateSkillRequest?: CreateOrUpdateSkillRequest,) => {
    return [
    'POST', `/admin/skills`, createOrUpdateSkillRequest
    ] as const;
    }


export const getSkillsCreateQueryOptions = <TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsCreateQueryKey(createOrUpdateSkillRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsCreate>>> = ({ signal }) => skillsCreate(createOrUpdateSkillRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof skillsCreate>>>
export type SkillsCreateQueryError = unknown


export function useSkillsCreate<TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(
 createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCreate>>,
          TError,
          Awaited<ReturnType<typeof skillsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCreate<TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(
 createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCreate>>,
          TError,
          Awaited<ReturnType<typeof skillsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCreate<TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(
 createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsCreate<TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(
 createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsCreateQueryOptions(createOrUpdateSkillRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsCreateQuery = async <TData = Awaited<ReturnType<typeof skillsCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsCreateQueryOptions(createOrUpdateSkillRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsDetail = (
    skillId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillDetails>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}`, method: 'GET', signal
    },
      options);
    }




export const getSkillsDetailQueryKey = (skillId: number | string | undefined | null,) => {
    return [
    `/admin/skills/${skillId}`
    ] as const;
    }


export const getSkillsDetailQueryOptions = <TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsDetailQueryKey(skillId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsDetail>>> = ({ signal }) => skillsDetail(skillId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsDetailQueryResult = NonNullable<Awaited<ReturnType<typeof skillsDetail>>>
export type SkillsDetailQueryError = ClientError


export function useSkillsDetail<TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(
 skillId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsDetail>>,
          TError,
          Awaited<ReturnType<typeof skillsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsDetail<TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsDetail>>,
          TError,
          Awaited<ReturnType<typeof skillsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsDetail<TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsDetail<TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsDetailQueryOptions(skillId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsDetailQuery = async <TData = Awaited<ReturnType<typeof skillsDetail>>, TError = ClientError>(
 queryClient: QueryClient, skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsDetailQueryOptions(skillId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsUpdate = (
    skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillSummary>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSkillRequest, signal
    },
      options);
    }




export const getSkillsUpdateQueryKey = (skillId: number | string | undefined | null,
    createOrUpdateSkillRequest?: CreateOrUpdateSkillRequest,) => {
    return [
    'PUT', `/admin/skills/${skillId}`, createOrUpdateSkillRequest
    ] as const;
    }


export const getSkillsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsUpdateQueryKey(skillId,createOrUpdateSkillRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsUpdate>>> = ({ signal }) => skillsUpdate(skillId,createOrUpdateSkillRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof skillsUpdate>>>
export type SkillsUpdateQueryError = unknown


export function useSkillsUpdate<TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(
 skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsUpdate<TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(
 skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsUpdate<TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(
 skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsUpdate<TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(
 skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsUpdateQueryOptions(skillId,createOrUpdateSkillRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsUpdateQuery = async <TData = Awaited<ReturnType<typeof skillsUpdate>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    createOrUpdateSkillRequest: CreateOrUpdateSkillRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsUpdateQueryOptions(skillId,createOrUpdateSkillRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsDelete = (
    skillId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getSkillsDeleteQueryKey = (skillId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/skills/${skillId}`
    ] as const;
    }


export const getSkillsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsDeleteQueryKey(skillId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsDelete>>> = ({ signal }) => skillsDelete(skillId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof skillsDelete>>>
export type SkillsDeleteQueryError = unknown


export function useSkillsDelete<TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(
 skillId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsDelete>>,
          TError,
          Awaited<ReturnType<typeof skillsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsDelete<TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsDelete>>,
          TError,
          Awaited<ReturnType<typeof skillsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsDelete<TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsDelete<TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(
 skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsDeleteQueryOptions(skillId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsDeleteQuery = async <TData = Awaited<ReturnType<typeof skillsDelete>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsDeleteQueryOptions(skillId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsSkillGroupsAssigned = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSkillDto>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsSkillGroupsAssignedQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams,) => {
    return [
    `/admin/skills/${skillId}/skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsSkillGroupsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsSkillGroupsAssignedQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>> = ({ signal }) => skillsRelationsSkillGroupsAssigned(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsSkillGroupsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>>
export type SkillsRelationsSkillGroupsAssignedQueryError = ClientError


export function useSkillsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsSkillGroupsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsSkillGroupsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsSkillGroupsAssignedQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsSkillGroupsAssignedQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsSkillGroupsAssignedQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsSkillGroupsAssign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillGroupSkillDto[]>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/skillgroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsSkillGroupsAssignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skills/${skillId}/skillgroups`, numberString
    ] as const;
    }


export const getSkillsRelationsSkillGroupsAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsSkillGroupsAssignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>> = ({ signal }) => skillsRelationsSkillGroupsAssign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsSkillGroupsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>>
export type SkillsRelationsSkillGroupsAssignQueryError = unknown


export function useSkillsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsSkillGroupsAssign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsSkillGroupsAssignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsSkillGroupsAssignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsSkillGroupsAssignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsSkillGroupsUnassign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/skillgroups`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsSkillGroupsUnassignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skills/${skillId}/skillgroups`, numberString
    ] as const;
    }


export const getSkillsRelationsSkillGroupsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsSkillGroupsUnassignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>> = ({ signal }) => skillsRelationsSkillGroupsUnassign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsSkillGroupsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>>
export type SkillsRelationsSkillGroupsUnassignQueryError = unknown


export function useSkillsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsSkillGroupsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsSkillGroupsUnassignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsSkillGroupsUnassignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsSkillGroupsUnassignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsSkillGroupsAvailable = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSummary>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/assignable-skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsSkillGroupsAvailableQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams,) => {
    return [
    `/admin/skills/${skillId}/assignable-skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsSkillGroupsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsSkillGroupsAvailableQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>> = ({ signal }) => skillsRelationsSkillGroupsAvailable(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsSkillGroupsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>>
export type SkillsRelationsSkillGroupsAvailableQueryError = unknown


export function useSkillsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsSkillGroupsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsSkillGroupsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsSkillGroupsAvailableQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsSkillGroupsAvailableQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsSkillGroupsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsSkillGroupsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsSkillGroupsAvailableQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsTeamsAssigned = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSkillResponse>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsTeamsAssignedQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams,) => {
    return [
    `/admin/skills/${skillId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsTeamsAssignedQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>> = ({ signal }) => skillsRelationsTeamsAssigned(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>>
export type SkillsRelationsTeamsAssignedQueryError = unknown


export function useSkillsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsTeamsAssignedQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsTeamsAssignedQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsTeamsAssign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSkillResponse[]>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsTeamsAssignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skills/${skillId}/teams`, numberString
    ] as const;
    }


export const getSkillsRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsTeamsAssignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>> = ({ signal }) => skillsRelationsTeamsAssign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>>
export type SkillsRelationsTeamsAssignQueryError = unknown


export function useSkillsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsTeamsAssignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsTeamsAssignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsTeamsUnassign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsTeamsUnassignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skills/${skillId}/teams`, numberString
    ] as const;
    }


export const getSkillsRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsTeamsUnassignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>> = ({ signal }) => skillsRelationsTeamsUnassign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>>
export type SkillsRelationsTeamsUnassignQueryError = unknown


export function useSkillsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsTeamsUnassignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsTeamsUnassignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsTeamsAvailable = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsTeamsAvailableQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams,) => {
    return [
    `/admin/skills/${skillId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsTeamsAvailableQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>> = ({ signal }) => skillsRelationsTeamsAvailable(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>>
export type SkillsRelationsTeamsAvailableQueryError = unknown


export function useSkillsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsTeamsAvailableQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsTeamsAvailableQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsUsersAvailable = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfExtendedUserDto>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsUsersAvailableQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams,) => {
    return [
    `/admin/skills/${skillId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsUsersAvailableQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>> = ({ signal }) => skillsRelationsUsersAvailable(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>>
export type SkillsRelationsUsersAvailableQueryError = ClientError


export function useSkillsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsUsersAvailableQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError = ClientError>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsUsersAvailableQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsUsersAssigned = (
    skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfExtendedUserDto>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillsRelationsUsersAssignedQueryKey = (skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams,) => {
    return [
    `/admin/skills/${skillId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsUsersAssignedQueryKey(skillId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>> = ({ signal }) => skillsRelationsUsersAssigned(skillId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>>
export type SkillsRelationsUsersAssignedQueryError = ClientError


export function useSkillsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params: undefined |  SkillsRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(
 skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsUsersAssignedQueryOptions(skillId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError = ClientError>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    params?: SkillsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsUsersAssignedQueryOptions(skillId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsUsersAssign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ExtendedUserDto[]>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsUsersAssignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skills/${skillId}/users`, numberString
    ] as const;
    }


export const getSkillsRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsUsersAssignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>> = ({ signal }) => skillsRelationsUsersAssign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>>
export type SkillsRelationsUsersAssignQueryError = unknown


export function useSkillsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsUsersAssignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsUsersAssignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillsRelationsUsersUnassign = (
    skillId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skills/${encodeURIComponent(String(skillId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillsRelationsUsersUnassignQueryKey = (skillId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skills/${skillId}/users`, numberString
    ] as const;
    }


export const getSkillsRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRelationsUsersUnassignQueryKey(skillId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>> = ({ signal }) => skillsRelationsUsersUnassign(skillId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>>
export type SkillsRelationsUsersUnassignQueryError = unknown


export function useSkillsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(
 skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRelationsUsersUnassignQueryOptions(skillId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillsRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillsRelationsUsersUnassignQueryOptions(skillId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsList = (
    params?: SkillGroupsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSummary>(
      {url: `/admin/skillgroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsListQueryKey = (params?: SkillGroupsListParams,) => {
    return [
    `/admin/skillgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(params?: SkillGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsList>>> = ({ signal }) => skillGroupsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsList>>>
export type SkillGroupsListQueryError = ClientError


export function useSkillGroupsList<TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(
 params: undefined |  SkillGroupsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsList>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsList<TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(
 params?: SkillGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsList>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsList<TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(
 params?: SkillGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsList<TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(
 params?: SkillGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsListQuery = async <TData = Awaited<ReturnType<typeof skillGroupsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: SkillGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsCreate = (
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillGroupSummary>(
      {url: `/admin/skillgroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSkillGroupRequest, signal
    },
      options);
    }




export const getSkillGroupsCreateQueryKey = (createOrUpdateSkillGroupRequest?: CreateOrUpdateSkillGroupRequest,) => {
    return [
    'POST', `/admin/skillgroups`, createOrUpdateSkillGroupRequest
    ] as const;
    }


export const getSkillGroupsCreateQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsCreateQueryKey(createOrUpdateSkillGroupRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsCreate>>> = ({ signal }) => skillGroupsCreate(createOrUpdateSkillGroupRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsCreate>>>
export type SkillGroupsCreateQueryError = unknown


export function useSkillGroupsCreate<TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(
 createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsCreate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsCreate<TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(
 createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsCreate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsCreate<TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(
 createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsCreate<TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(
 createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsCreateQueryOptions(createOrUpdateSkillGroupRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsCreateQuery = async <TData = Awaited<ReturnType<typeof skillGroupsCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsCreateQueryOptions(createOrUpdateSkillGroupRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsUpdate = (
    skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillGroupSummary>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSkillGroupRequest, signal
    },
      options);
    }




export const getSkillGroupsUpdateQueryKey = (skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest?: CreateOrUpdateSkillGroupRequest,) => {
    return [
    'PUT', `/admin/skillgroups/${skillGroupId}`, createOrUpdateSkillGroupRequest
    ] as const;
    }


export const getSkillGroupsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsUpdateQueryKey(skillGroupId,createOrUpdateSkillGroupRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsUpdate>>> = ({ signal }) => skillGroupsUpdate(skillGroupId,createOrUpdateSkillGroupRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsUpdate>>>
export type SkillGroupsUpdateQueryError = unknown


export function useSkillGroupsUpdate<TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsUpdate<TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsUpdate<TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsUpdate<TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsUpdateQueryOptions(skillGroupId,createOrUpdateSkillGroupRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsUpdateQuery = async <TData = Awaited<ReturnType<typeof skillGroupsUpdate>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    createOrUpdateSkillGroupRequest: CreateOrUpdateSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsUpdateQueryOptions(skillGroupId,createOrUpdateSkillGroupRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsDelete = (
    skillGroupId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getSkillGroupsDeleteQueryKey = (skillGroupId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/skillgroups/${skillGroupId}`
    ] as const;
    }


export const getSkillGroupsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(skillGroupId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsDeleteQueryKey(skillGroupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsDelete>>> = ({ signal }) => skillGroupsDelete(skillGroupId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsDelete>>>
export type SkillGroupsDeleteQueryError = unknown


export function useSkillGroupsDelete<TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(
 skillGroupId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsDelete>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsDelete<TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(
 skillGroupId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsDelete>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsDelete<TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(
 skillGroupId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsDelete<TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(
 skillGroupId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsDeleteQueryOptions(skillGroupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsDeleteQuery = async <TData = Awaited<ReturnType<typeof skillGroupsDelete>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsDeleteQueryOptions(skillGroupId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsSkillsAssigned = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillGroupSkillDto>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsSkillsAssignedQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsSkillsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsSkillsAssignedQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>> = ({ signal }) => skillGroupsRelationsSkillsAssigned(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsSkillsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>>
export type SkillGroupsRelationsSkillsAssignedQueryError = ClientError


export function useSkillGroupsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsSkillsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsSkillsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsSkillsAssignedQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsSkillsAssignedQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsSkillsAssignedQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsSkillsAssign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SkillGroupSkillDto[]>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsSkillsAssignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skillgroups/${skillGroupId}/skills`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsSkillsAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsSkillsAssignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>> = ({ signal }) => skillGroupsRelationsSkillsAssign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsSkillsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>>
export type SkillGroupsRelationsSkillsAssignQueryError = unknown


export function useSkillGroupsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsSkillsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsSkillsAssignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsSkillsAssignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsSkillsAssignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsSkillsUnassign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/skills`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsSkillsUnassignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skillgroups/${skillGroupId}/skills`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsSkillsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsSkillsUnassignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>> = ({ signal }) => skillGroupsRelationsSkillsUnassign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsSkillsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>>
export type SkillGroupsRelationsSkillsUnassignQueryError = unknown


export function useSkillGroupsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsSkillsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsSkillsUnassignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsSkillsUnassignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsSkillsUnassignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsSkillsAvailable = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfSkillSummary>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/assignable-skills`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsSkillsAvailableQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/assignable-skills`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsSkillsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsSkillsAvailableQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>> = ({ signal }) => skillGroupsRelationsSkillsAvailable(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsSkillsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>>
export type SkillGroupsRelationsSkillsAvailableQueryError = unknown


export function useSkillGroupsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsSkillsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsSkillsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsSkillsAvailableQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsSkillsAvailableQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsSkillsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsSkillsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsSkillsAvailableQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsTeamsAssigned = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSkillGroupResponse>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsTeamsAssignedQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsTeamsAssignedQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>> = ({ signal }) => skillGroupsRelationsTeamsAssigned(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>>
export type SkillGroupsRelationsTeamsAssignedQueryError = unknown


export function useSkillGroupsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsTeamsAssignedQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsTeamsAssignedQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsTeamsAssign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamSkillGroupResponse[]>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsTeamsAssignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skillgroups/${skillGroupId}/teams`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsTeamsAssignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>> = ({ signal }) => skillGroupsRelationsTeamsAssign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>>
export type SkillGroupsRelationsTeamsAssignQueryError = unknown


export function useSkillGroupsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsTeamsAssignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsTeamsAssignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsTeamsUnassign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsTeamsUnassignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skillgroups/${skillGroupId}/teams`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsTeamsUnassignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>> = ({ signal }) => skillGroupsRelationsTeamsUnassign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>>
export type SkillGroupsRelationsTeamsUnassignQueryError = unknown


export function useSkillGroupsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsTeamsUnassignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsTeamsUnassignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsTeamsAvailable = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsTeamsAvailableQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsTeamsAvailableQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>> = ({ signal }) => skillGroupsRelationsTeamsAvailable(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>>
export type SkillGroupsRelationsTeamsAvailableQueryError = unknown


export function useSkillGroupsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsTeamsAvailableQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsTeamsAvailableQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsUsersAvailable = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsUsersAvailableQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsUsersAvailableQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>> = ({ signal }) => skillGroupsRelationsUsersAvailable(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>>
export type SkillGroupsRelationsUsersAvailableQueryError = unknown


export function useSkillGroupsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsUsersAvailableQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsUsersAvailableQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsUsersAssigned = (
    skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserSkillGroupDto>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSkillGroupsRelationsUsersAssignedQueryKey = (skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams,) => {
    return [
    `/admin/skillgroups/${skillGroupId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillGroupsRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsUsersAssignedQueryKey(skillGroupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>> = ({ signal }) => skillGroupsRelationsUsersAssigned(skillGroupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>>
export type SkillGroupsRelationsUsersAssignedQueryError = unknown


export function useSkillGroupsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params: undefined |  SkillGroupsRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsUsersAssignedQueryOptions(skillGroupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    params?: SkillGroupsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsUsersAssignedQueryOptions(skillGroupId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsUsersAssign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillGroupDto[]>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsUsersAssignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/skillgroups/${skillGroupId}/users`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsUsersAssignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>> = ({ signal }) => skillGroupsRelationsUsersAssign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>>
export type SkillGroupsRelationsUsersAssignQueryError = unknown


export function useSkillGroupsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsUsersAssign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsUsersAssignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsUsersAssignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsUsersUnassign = (
    skillGroupId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getSkillGroupsRelationsUsersUnassignQueryKey = (skillGroupId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/skillgroups/${skillGroupId}/users`, numberString
    ] as const;
    }


export const getSkillGroupsRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsUsersUnassignQueryKey(skillGroupId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>> = ({ signal }) => skillGroupsRelationsUsersUnassign(skillGroupId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>>
export type SkillGroupsRelationsUsersUnassignQueryError = unknown


export function useSkillGroupsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsUsersUnassignQueryOptions(skillGroupId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsUsersUnassignQueryOptions(skillGroupId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const skillGroupsRelationsUsersUpdate = (
    skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSkillGroupDto>(
      {url: `/admin/skillgroups/${encodeURIComponent(String(skillGroupId))}/users/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserSkillGroupRequest, signal
    },
      options);
    }




export const getSkillGroupsRelationsUsersUpdateQueryKey = (skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest?: UpdateUserSkillGroupRequest,) => {
    return [
    'PUT', `/admin/skillgroups/${skillGroupId}/users/${mappingId}`, updateUserSkillGroupRequest
    ] as const;
    }


export const getSkillGroupsRelationsUsersUpdateQueryOptions = <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillGroupsRelationsUsersUpdateQueryKey(skillGroupId,mappingId,updateUserSkillGroupRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>> = ({ signal }) => skillGroupsRelationsUsersUpdate(skillGroupId,mappingId,updateUserSkillGroupRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: skillGroupId !== null && skillGroupId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillGroupsRelationsUsersUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>>
export type SkillGroupsRelationsUsersUpdateQueryError = unknown


export function useSkillGroupsRelationsUsersUpdate<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersUpdate<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>,
          TError,
          Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillGroupsRelationsUsersUpdate<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillGroupsRelationsUsersUpdate<TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(
 skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillGroupsRelationsUsersUpdateQueryOptions(skillGroupId,mappingId,updateUserSkillGroupRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSkillGroupsRelationsUsersUpdateQuery = async <TData = Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError = unknown>(
 queryClient: QueryClient, skillGroupId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateUserSkillGroupRequest: UpdateUserSkillGroupRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillGroupsRelationsUsersUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSkillGroupsRelationsUsersUpdateQueryOptions(skillGroupId,mappingId,updateUserSkillGroupRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsClientGetSetting = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SettingResponse>(
      {url: `/api/settings/setting`, method: 'GET', signal
    },
      options);
    }




export const getSettingsClientGetSettingQueryKey = () => {
    return [
    `/api/settings/setting`
    ] as const;
    }


export const getSettingsClientGetSettingQueryOptions = <TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsClientGetSettingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsClientGetSetting>>> = ({ signal }) => settingsClientGetSetting(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsClientGetSettingQueryResult = NonNullable<Awaited<ReturnType<typeof settingsClientGetSetting>>>
export type SettingsClientGetSettingQueryError = unknown


export function useSettingsClientGetSetting<TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsClientGetSetting>>,
          TError,
          Awaited<ReturnType<typeof settingsClientGetSetting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsClientGetSetting<TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsClientGetSetting>>,
          TError,
          Awaited<ReturnType<typeof settingsClientGetSetting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsClientGetSetting<TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsClientGetSetting<TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsClientGetSettingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsClientGetSettingQuery = async <TData = Awaited<ReturnType<typeof settingsClientGetSetting>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsClientGetSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsClientGetSettingQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsRelationsCustomPropertiesAvailable = (
    ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPropertySummary>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}/assignable-customproperties`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRuleSetsRelationsCustomPropertiesAvailableQueryKey = (ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams,) => {
    return [
    `/admin/rulesets/${ruleSetId}/assignable-customproperties`, ...(params ? [params] : [])
    ] as const;
    }


export const getRuleSetsRelationsCustomPropertiesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsRelationsCustomPropertiesAvailableQueryKey(ruleSetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>> = ({ signal }) => ruleSetsRelationsCustomPropertiesAvailable(ruleSetId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsRelationsCustomPropertiesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>>
export type RuleSetsRelationsCustomPropertiesAvailableQueryError = unknown


export function useRuleSetsRelationsCustomPropertiesAvailable<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    params: undefined |  RuleSetsRelationsCustomPropertiesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAvailable<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAvailable<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsRelationsCustomPropertiesAvailable<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAvailableQueryOptions(ruleSetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsRelationsCustomPropertiesAvailableQuery = async <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError = unknown>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAvailableQueryOptions(ruleSetId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsRelationsCustomPropertiesAssigned = (
    ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPropertyRuleSetDto>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}/customproperties`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRuleSetsRelationsCustomPropertiesAssignedQueryKey = (ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams,) => {
    return [
    `/admin/rulesets/${ruleSetId}/customproperties`, ...(params ? [params] : [])
    ] as const;
    }


export const getRuleSetsRelationsCustomPropertiesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsRelationsCustomPropertiesAssignedQueryKey(ruleSetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>> = ({ signal }) => ruleSetsRelationsCustomPropertiesAssigned(ruleSetId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsRelationsCustomPropertiesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>>
export type RuleSetsRelationsCustomPropertiesAssignedQueryError = ClientError


export function useRuleSetsRelationsCustomPropertiesAssigned<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(
 ruleSetId: number | string | undefined | null,
    params: undefined |  RuleSetsRelationsCustomPropertiesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAssigned<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAssigned<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsRelationsCustomPropertiesAssigned<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(
 ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAssignedQueryOptions(ruleSetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsRelationsCustomPropertiesAssignedQuery = async <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError = ClientError>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null,
    params?: RuleSetsRelationsCustomPropertiesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAssignedQueryOptions(ruleSetId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsRelationsCustomPropertiesAssign = (
    ruleSetId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyRuleSetDto[]>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}/customproperties`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRuleSetsRelationsCustomPropertiesAssignQueryKey = (ruleSetId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/rulesets/${ruleSetId}/customproperties`, numberString
    ] as const;
    }


export const getRuleSetsRelationsCustomPropertiesAssignQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsRelationsCustomPropertiesAssignQueryKey(ruleSetId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>> = ({ signal }) => ruleSetsRelationsCustomPropertiesAssign(ruleSetId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsRelationsCustomPropertiesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>>
export type RuleSetsRelationsCustomPropertiesAssignQueryError = unknown


export function useRuleSetsRelationsCustomPropertiesAssign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAssign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesAssign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsRelationsCustomPropertiesAssign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAssignQueryOptions(ruleSetId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsRelationsCustomPropertiesAssignQuery = async <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError = unknown>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsRelationsCustomPropertiesAssignQueryOptions(ruleSetId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsRelationsCustomPropertiesUnassign = (
    ruleSetId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}/customproperties`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRuleSetsRelationsCustomPropertiesUnassignQueryKey = (ruleSetId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/rulesets/${ruleSetId}/customproperties`, numberString
    ] as const;
    }


export const getRuleSetsRelationsCustomPropertiesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsRelationsCustomPropertiesUnassignQueryKey(ruleSetId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>> = ({ signal }) => ruleSetsRelationsCustomPropertiesUnassign(ruleSetId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsRelationsCustomPropertiesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>>
export type RuleSetsRelationsCustomPropertiesUnassignQueryError = unknown


export function useRuleSetsRelationsCustomPropertiesUnassign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesUnassign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsRelationsCustomPropertiesUnassign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsRelationsCustomPropertiesUnassign<TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsRelationsCustomPropertiesUnassignQueryOptions(ruleSetId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsRelationsCustomPropertiesUnassignQuery = async <TData = Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError = unknown>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsRelationsCustomPropertiesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsRelationsCustomPropertiesUnassignQueryOptions(ruleSetId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsList = (
    params?: RuleSetsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRuleSetSummary>(
      {url: `/admin/rulesets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRuleSetsListQueryKey = (params?: RuleSetsListParams,) => {
    return [
    `/admin/rulesets`, ...(params ? [params] : [])
    ] as const;
    }


export const getRuleSetsListQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(params?: RuleSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsList>>> = ({ signal }) => ruleSetsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsListQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsList>>>
export type RuleSetsListQueryError = ClientError


export function useRuleSetsList<TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(
 params: undefined |  RuleSetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsList>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsList<TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(
 params?: RuleSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsList>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsList<TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(
 params?: RuleSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsList<TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(
 params?: RuleSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsListQuery = async <TData = Awaited<ReturnType<typeof ruleSetsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: RuleSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsCreate = (
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RuleSetSummary>(
      {url: `/admin/rulesets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRuleSetRequest, signal
    },
      options);
    }




export const getRuleSetsCreateQueryKey = (createOrUpdateRuleSetRequest?: CreateOrUpdateRuleSetRequest,) => {
    return [
    'POST', `/admin/rulesets`, createOrUpdateRuleSetRequest
    ] as const;
    }


export const getRuleSetsCreateQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsCreateQueryKey(createOrUpdateRuleSetRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsCreate>>> = ({ signal }) => ruleSetsCreate(createOrUpdateRuleSetRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsCreate>>>
export type RuleSetsCreateQueryError = unknown


export function useRuleSetsCreate<TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(
 createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsCreate>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsCreate<TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(
 createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsCreate>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsCreate<TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(
 createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsCreate<TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(
 createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsCreateQueryOptions(createOrUpdateRuleSetRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsCreateQuery = async <TData = Awaited<ReturnType<typeof ruleSetsCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsCreateQueryOptions(createOrUpdateRuleSetRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsUpdate = (
    ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RuleSetSummary>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRuleSetRequest, signal
    },
      options);
    }




export const getRuleSetsUpdateQueryKey = (ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest?: CreateOrUpdateRuleSetRequest,) => {
    return [
    'PUT', `/admin/rulesets/${ruleSetId}`, createOrUpdateRuleSetRequest
    ] as const;
    }


export const getRuleSetsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsUpdateQueryKey(ruleSetId,createOrUpdateRuleSetRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsUpdate>>> = ({ signal }) => ruleSetsUpdate(ruleSetId,createOrUpdateRuleSetRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsUpdate>>>
export type RuleSetsUpdateQueryError = unknown


export function useRuleSetsUpdate<TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsUpdate>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsUpdate<TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsUpdate>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsUpdate<TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsUpdate<TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(
 ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsUpdateQueryOptions(ruleSetId,createOrUpdateRuleSetRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsUpdateQuery = async <TData = Awaited<ReturnType<typeof ruleSetsUpdate>>, TError = unknown>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null,
    createOrUpdateRuleSetRequest: CreateOrUpdateRuleSetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsUpdateQueryOptions(ruleSetId,createOrUpdateRuleSetRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const ruleSetsDelete = (
    ruleSetId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/rulesets/${encodeURIComponent(String(ruleSetId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRuleSetsDeleteQueryKey = (ruleSetId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/rulesets/${ruleSetId}`
    ] as const;
    }


export const getRuleSetsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(ruleSetId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRuleSetsDeleteQueryKey(ruleSetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ruleSetsDelete>>> = ({ signal }) => ruleSetsDelete(ruleSetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: ruleSetId !== null && ruleSetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RuleSetsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof ruleSetsDelete>>>
export type RuleSetsDeleteQueryError = unknown


export function useRuleSetsDelete<TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(
 ruleSetId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsDelete>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsDelete<TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(
 ruleSetId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ruleSetsDelete>>,
          TError,
          Awaited<ReturnType<typeof ruleSetsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuleSetsDelete<TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(
 ruleSetId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRuleSetsDelete<TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(
 ruleSetId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRuleSetsDeleteQueryOptions(ruleSetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRuleSetsDeleteQuery = async <TData = Awaited<ReturnType<typeof ruleSetsDelete>>, TError = unknown>(
 queryClient: QueryClient, ruleSetId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ruleSetsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRuleSetsDeleteQueryOptions(ruleSetId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsPermissionsAssigned = (
    roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRolePermissionDto>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/permissions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRolesRelationsPermissionsAssignedQueryKey = (roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams,) => {
    return [
    `/admin/roles/${roleId}/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getRolesRelationsPermissionsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsPermissionsAssignedQueryKey(roleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>> = ({ signal }) => rolesRelationsPermissionsAssigned(roleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsPermissionsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>>
export type RolesRelationsPermissionsAssignedQueryError = ClientError


export function useRolesRelationsPermissionsAssigned<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params: undefined |  RolesRelationsPermissionsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAssigned<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAssigned<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsPermissionsAssigned<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsPermissionsAssignedQueryOptions(roleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsPermissionsAssignedQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsPermissionsAssignedQueryOptions(roleId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsPermissionsAssign = (
    roleId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RolePermissionDto[]>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRolesRelationsPermissionsAssignQueryKey = (roleId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/roles/${roleId}/permissions`, numberString
    ] as const;
    }


export const getRolesRelationsPermissionsAssignQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsPermissionsAssignQueryKey(roleId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>> = ({ signal }) => rolesRelationsPermissionsAssign(roleId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsPermissionsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>>
export type RolesRelationsPermissionsAssignQueryError = unknown


export function useRolesRelationsPermissionsAssign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAssign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAssign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsPermissionsAssign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsPermissionsAssignQueryOptions(roleId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsPermissionsAssignQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsPermissionsAssignQueryOptions(roleId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsPermissionsUnassign = (
    roleId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/permissions`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRolesRelationsPermissionsUnassignQueryKey = (roleId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/roles/${roleId}/permissions`, numberString
    ] as const;
    }


export const getRolesRelationsPermissionsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsPermissionsUnassignQueryKey(roleId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>> = ({ signal }) => rolesRelationsPermissionsUnassign(roleId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsPermissionsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>>
export type RolesRelationsPermissionsUnassignQueryError = unknown


export function useRolesRelationsPermissionsUnassign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsUnassign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsUnassign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsPermissionsUnassign<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsPermissionsUnassignQueryOptions(roleId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsPermissionsUnassignQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsPermissionsUnassignQueryOptions(roleId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsPermissionsAvailable = (
    roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfPermissionSummary>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/assignable-permissions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRolesRelationsPermissionsAvailableQueryKey = (roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams,) => {
    return [
    `/admin/roles/${roleId}/assignable-permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getRolesRelationsPermissionsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsPermissionsAvailableQueryKey(roleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>> = ({ signal }) => rolesRelationsPermissionsAvailable(roleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsPermissionsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>>
export type RolesRelationsPermissionsAvailableQueryError = ClientError


export function useRolesRelationsPermissionsAvailable<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params: undefined |  RolesRelationsPermissionsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAvailable<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsPermissionsAvailable<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsPermissionsAvailable<TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsPermissionsAvailableQueryOptions(roleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsPermissionsAvailableQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError = ClientError>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    params?: RolesRelationsPermissionsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsPermissionsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsPermissionsAvailableQueryOptions(roleId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesList = (
    params?: RolesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRoleSummary>(
      {url: `/admin/roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRolesListQueryKey = (params?: RolesListParams,) => {
    return [
    `/admin/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getRolesListQueryOptions = <TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(params?: RolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesList>>> = ({ signal }) => rolesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesListQueryResult = NonNullable<Awaited<ReturnType<typeof rolesList>>>
export type RolesListQueryError = ClientError


export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(
 params: undefined |  RolesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(
 params?: RolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(
 params?: RolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(
 params?: RolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesListQuery = async <TData = Awaited<ReturnType<typeof rolesList>>, TError = ClientError>(
 queryClient: QueryClient, params?: RolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesCreate = (
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSummary>(
      {url: `/admin/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRoleRequest, signal
    },
      options);
    }




export const getRolesCreateQueryKey = (createOrUpdateRoleRequest?: CreateOrUpdateRoleRequest,) => {
    return [
    'POST', `/admin/roles`, createOrUpdateRoleRequest
    ] as const;
    }


export const getRolesCreateQueryOptions = <TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesCreateQueryKey(createOrUpdateRoleRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesCreate>>> = ({ signal }) => rolesCreate(createOrUpdateRoleRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof rolesCreate>>>
export type RolesCreateQueryError = unknown


export function useRolesCreate<TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(
 createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesCreate>>,
          TError,
          Awaited<ReturnType<typeof rolesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesCreate<TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(
 createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesCreate>>,
          TError,
          Awaited<ReturnType<typeof rolesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesCreate<TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(
 createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesCreate<TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(
 createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesCreateQueryOptions(createOrUpdateRoleRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesCreateQuery = async <TData = Awaited<ReturnType<typeof rolesCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesCreateQueryOptions(createOrUpdateRoleRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesDetail = (
    roleId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSummary>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}`, method: 'GET', signal
    },
      options);
    }




export const getRolesDetailQueryKey = (roleId: number | undefined | null,) => {
    return [
    `/admin/roles/${roleId}`
    ] as const;
    }


export const getRolesDetailQueryOptions = <TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(roleId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesDetailQueryKey(roleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesDetail>>> = ({ signal }) => rolesDetail(roleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesDetailQueryResult = NonNullable<Awaited<ReturnType<typeof rolesDetail>>>
export type RolesDetailQueryError = ClientError


export function useRolesDetail<TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(
 roleId: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesDetail>>,
          TError,
          Awaited<ReturnType<typeof rolesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesDetail<TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(
 roleId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesDetail>>,
          TError,
          Awaited<ReturnType<typeof rolesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesDetail<TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(
 roleId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesDetail<TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(
 roleId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesDetailQueryOptions(roleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesDetailQuery = async <TData = Awaited<ReturnType<typeof rolesDetail>>, TError = ClientError>(
 queryClient: QueryClient, roleId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesDetailQueryOptions(roleId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesUpdate = (
    roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSummary>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRoleRequest, signal
    },
      options);
    }




export const getRolesUpdateQueryKey = (roleId: number | string | undefined | null,
    createOrUpdateRoleRequest?: CreateOrUpdateRoleRequest,) => {
    return [
    'PUT', `/admin/roles/${roleId}`, createOrUpdateRoleRequest
    ] as const;
    }


export const getRolesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesUpdateQueryKey(roleId,createOrUpdateRoleRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesUpdate>>> = ({ signal }) => rolesUpdate(roleId,createOrUpdateRoleRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof rolesUpdate>>>
export type RolesUpdateQueryError = unknown


export function useRolesUpdate<TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(
 roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesUpdate>>,
          TError,
          Awaited<ReturnType<typeof rolesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesUpdate<TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(
 roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesUpdate>>,
          TError,
          Awaited<ReturnType<typeof rolesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesUpdate<TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(
 roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesUpdate<TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(
 roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesUpdateQueryOptions(roleId,createOrUpdateRoleRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesUpdateQuery = async <TData = Awaited<ReturnType<typeof rolesUpdate>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    createOrUpdateRoleRequest: CreateOrUpdateRoleRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesUpdateQueryOptions(roleId,createOrUpdateRoleRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesDelete = (
    roleId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRolesDeleteQueryKey = (roleId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/roles/${roleId}`
    ] as const;
    }


export const getRolesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(roleId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesDeleteQueryKey(roleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesDelete>>> = ({ signal }) => rolesDelete(roleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof rolesDelete>>>
export type RolesDeleteQueryError = unknown


export function useRolesDelete<TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(
 roleId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesDelete>>,
          TError,
          Awaited<ReturnType<typeof rolesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesDelete<TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(
 roleId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesDelete>>,
          TError,
          Awaited<ReturnType<typeof rolesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesDelete<TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(
 roleId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesDelete<TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(
 roleId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesDeleteQueryOptions(roleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesDeleteQuery = async <TData = Awaited<ReturnType<typeof rolesDelete>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesDeleteQueryOptions(roleId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsUsersAssigned = (
    roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserRoleDto>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRolesRelationsUsersAssignedQueryKey = (roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams,) => {
    return [
    `/admin/roles/${roleId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getRolesRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsUsersAssignedQueryKey(roleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>> = ({ signal }) => rolesRelationsUsersAssigned(roleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>>
export type RolesRelationsUsersAssignedQueryError = ClientError


export function useRolesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params: undefined |  RolesRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsUsersAssignedQueryOptions(roleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError = ClientError>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsUsersAssignedQueryOptions(roleId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsUsersAssign = (
    roleId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserRoleDto[]>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRolesRelationsUsersAssignQueryKey = (roleId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/roles/${roleId}/users`, numberString
    ] as const;
    }


export const getRolesRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsUsersAssignQueryKey(roleId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>> = ({ signal }) => rolesRelationsUsersAssign(roleId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>>
export type RolesRelationsUsersAssignQueryError = unknown


export function useRolesRelationsUsersAssign<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAssign<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAssign<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsUsersAssign<TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsUsersAssignQueryOptions(roleId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsUsersAssignQueryOptions(roleId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsUsersUnassign = (
    roleId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getRolesRelationsUsersUnassignQueryKey = (roleId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/roles/${roleId}/users`, numberString
    ] as const;
    }


export const getRolesRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsUsersUnassignQueryKey(roleId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>> = ({ signal }) => rolesRelationsUsersUnassign(roleId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>>
export type RolesRelationsUsersUnassignQueryError = unknown


export function useRolesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(
 roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsUsersUnassignQueryOptions(roleId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsUsersUnassignQueryOptions(roleId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const rolesRelationsUsersAvailable = (
    roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/roles/${encodeURIComponent(String(roleId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRolesRelationsUsersAvailableQueryKey = (roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams,) => {
    return [
    `/admin/roles/${roleId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getRolesRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRelationsUsersAvailableQueryKey(roleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>> = ({ signal }) => rolesRelationsUsersAvailable(roleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>>
export type RolesRelationsUsersAvailableQueryError = unknown


export function useRolesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(
 roleId: number | string | undefined | null,
    params: undefined |  RolesRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(
 roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRelationsUsersAvailableQueryOptions(roleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchRolesRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError = unknown>(
 queryClient: QueryClient, roleId: number | string | undefined | null,
    params?: RolesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getRolesRelationsUsersAvailableQueryOptions(roleId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsContactCodeTreesAssigned = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeTreeQueue>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/contactcodetrees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsContactCodeTreesAssignedQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams,) => {
    return [
    `/admin/queues/${queueId}/contactcodetrees`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsContactCodeTreesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsContactCodeTreesAssignedQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>> = ({ signal }) => queuesRelationsContactCodeTreesAssigned(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsContactCodeTreesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>>
export type QueuesRelationsContactCodeTreesAssignedQueryError = unknown


export function useQueuesRelationsContactCodeTreesAssigned<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsContactCodeTreesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAssigned<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAssigned<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsContactCodeTreesAssigned<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsContactCodeTreesAssignedQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsContactCodeTreesAssignedQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsContactCodeTreesAssignedQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsContactCodeTreesAssign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeQueue[]>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/contactcodetrees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsContactCodeTreesAssignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/queues/${queueId}/contactcodetrees`, numberString
    ] as const;
    }


export const getQueuesRelationsContactCodeTreesAssignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsContactCodeTreesAssignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>> = ({ signal }) => queuesRelationsContactCodeTreesAssign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsContactCodeTreesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>>
export type QueuesRelationsContactCodeTreesAssignQueryError = unknown


export function useQueuesRelationsContactCodeTreesAssign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAssign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAssign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsContactCodeTreesAssign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsContactCodeTreesAssignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsContactCodeTreesAssignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsContactCodeTreesAssignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsContactCodeTreesUnassign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/contactcodetrees`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsContactCodeTreesUnassignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/queues/${queueId}/contactcodetrees`, numberString
    ] as const;
    }


export const getQueuesRelationsContactCodeTreesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsContactCodeTreesUnassignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>> = ({ signal }) => queuesRelationsContactCodeTreesUnassign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsContactCodeTreesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>>
export type QueuesRelationsContactCodeTreesUnassignQueryError = unknown


export function useQueuesRelationsContactCodeTreesUnassign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesUnassign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesUnassign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsContactCodeTreesUnassign<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsContactCodeTreesUnassignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsContactCodeTreesUnassignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsContactCodeTreesUnassignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsContactCodeTreesAvailable = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeTreeSummary>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/assignable-contactcodetrees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsContactCodeTreesAvailableQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams,) => {
    return [
    `/admin/queues/${queueId}/assignable-contactcodetrees`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsContactCodeTreesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsContactCodeTreesAvailableQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>> = ({ signal }) => queuesRelationsContactCodeTreesAvailable(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsContactCodeTreesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>>
export type QueuesRelationsContactCodeTreesAvailableQueryError = unknown


export function useQueuesRelationsContactCodeTreesAvailable<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsContactCodeTreesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAvailable<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesAvailable<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsContactCodeTreesAvailable<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsContactCodeTreesAvailableQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsContactCodeTreesAvailableQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsContactCodeTreesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsContactCodeTreesAvailableQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsContactCodeTreesUpdate = (
    queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeQueue>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/contactcodetrees/${encodeURIComponent(String(mappingId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContactCodeTreeQueueRequest, signal
    },
      options);
    }




export const getQueuesRelationsContactCodeTreesUpdateQueryKey = (queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest?: UpdateContactCodeTreeQueueRequest,) => {
    return [
    'PUT', `/admin/queues/${queueId}/contactcodetrees/${mappingId}`, updateContactCodeTreeQueueRequest
    ] as const;
    }


export const getQueuesRelationsContactCodeTreesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsContactCodeTreesUpdateQueryKey(queueId,mappingId,updateContactCodeTreeQueueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>> = ({ signal }) => queuesRelationsContactCodeTreesUpdate(queueId,mappingId,updateContactCodeTreeQueueRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined && mappingId !== null && mappingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsContactCodeTreesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>>
export type QueuesRelationsContactCodeTreesUpdateQueryError = unknown


export function useQueuesRelationsContactCodeTreesUpdate<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesUpdate<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsContactCodeTreesUpdate<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsContactCodeTreesUpdate<TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsContactCodeTreesUpdateQueryOptions(queueId,mappingId,updateContactCodeTreeQueueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsContactCodeTreesUpdateQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    mappingId: number | string | undefined | null,
    updateContactCodeTreeQueueRequest: UpdateContactCodeTreeQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsContactCodeTreesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsContactCodeTreesUpdateQueryOptions(queueId,mappingId,updateContactCodeTreeQueueRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesList = (
    params?: QueuesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfQueueSummary>(
      {url: `/admin/queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesListQueryKey = (params?: QueuesListParams,) => {
    return [
    `/admin/queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesListQueryOptions = <TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(params?: QueuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesList>>> = ({ signal }) => queuesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesListQueryResult = NonNullable<Awaited<ReturnType<typeof queuesList>>>
export type QueuesListQueryError = ClientError


export function useQueuesList<TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(
 params: undefined |  QueuesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesList>>,
          TError,
          Awaited<ReturnType<typeof queuesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesList<TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(
 params?: QueuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesList>>,
          TError,
          Awaited<ReturnType<typeof queuesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesList<TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(
 params?: QueuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesList<TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(
 params?: QueuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesListQuery = async <TData = Awaited<ReturnType<typeof queuesList>>, TError = ClientError>(
 queryClient: QueryClient, params?: QueuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesCreate = (
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<QueueSummary>(
      {url: `/admin/queues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateQueueRequest, signal
    },
      options);
    }




export const getQueuesCreateQueryKey = (createOrUpdateQueueRequest?: CreateOrUpdateQueueRequest,) => {
    return [
    'POST', `/admin/queues`, createOrUpdateQueueRequest
    ] as const;
    }


export const getQueuesCreateQueryOptions = <TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesCreateQueryKey(createOrUpdateQueueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesCreate>>> = ({ signal }) => queuesCreate(createOrUpdateQueueRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof queuesCreate>>>
export type QueuesCreateQueryError = unknown


export function useQueuesCreate<TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(
 createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesCreate>>,
          TError,
          Awaited<ReturnType<typeof queuesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesCreate<TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(
 createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesCreate>>,
          TError,
          Awaited<ReturnType<typeof queuesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesCreate<TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(
 createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesCreate<TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(
 createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesCreateQueryOptions(createOrUpdateQueueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesCreateQuery = async <TData = Awaited<ReturnType<typeof queuesCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesCreateQueryOptions(createOrUpdateQueueRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesDetail = (
    queueId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<QueueDetails>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}`, method: 'GET', signal
    },
      options);
    }




export const getQueuesDetailQueryKey = (queueId: number | undefined | null,) => {
    return [
    `/admin/queues/${queueId}`
    ] as const;
    }


export const getQueuesDetailQueryOptions = <TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(queueId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesDetailQueryKey(queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesDetail>>> = ({ signal }) => queuesDetail(queueId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesDetailQueryResult = NonNullable<Awaited<ReturnType<typeof queuesDetail>>>
export type QueuesDetailQueryError = ClientError


export function useQueuesDetail<TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(
 queueId: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesDetail>>,
          TError,
          Awaited<ReturnType<typeof queuesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesDetail<TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(
 queueId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesDetail>>,
          TError,
          Awaited<ReturnType<typeof queuesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesDetail<TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(
 queueId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesDetail<TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(
 queueId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesDetailQueryOptions(queueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesDetailQuery = async <TData = Awaited<ReturnType<typeof queuesDetail>>, TError = ClientError>(
 queryClient: QueryClient, queueId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesDetailQueryOptions(queueId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesUpdate = (
    queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<QueueSummary>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateQueueRequest, signal
    },
      options);
    }




export const getQueuesUpdateQueryKey = (queueId: number | string | undefined | null,
    createOrUpdateQueueRequest?: CreateOrUpdateQueueRequest,) => {
    return [
    'PUT', `/admin/queues/${queueId}`, createOrUpdateQueueRequest
    ] as const;
    }


export const getQueuesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesUpdateQueryKey(queueId,createOrUpdateQueueRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesUpdate>>> = ({ signal }) => queuesUpdate(queueId,createOrUpdateQueueRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof queuesUpdate>>>
export type QueuesUpdateQueryError = unknown


export function useQueuesUpdate<TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof queuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesUpdate<TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesUpdate>>,
          TError,
          Awaited<ReturnType<typeof queuesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesUpdate<TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesUpdate<TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(
 queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesUpdateQueryOptions(queueId,createOrUpdateQueueRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesUpdateQuery = async <TData = Awaited<ReturnType<typeof queuesUpdate>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    createOrUpdateQueueRequest: CreateOrUpdateQueueRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesUpdateQueryOptions(queueId,createOrUpdateQueueRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesDelete = (
    queueId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getQueuesDeleteQueryKey = (queueId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/queues/${queueId}`
    ] as const;
    }


export const getQueuesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesDeleteQueryKey(queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesDelete>>> = ({ signal }) => queuesDelete(queueId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof queuesDelete>>>
export type QueuesDeleteQueryError = unknown


export function useQueuesDelete<TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(
 queueId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesDelete>>,
          TError,
          Awaited<ReturnType<typeof queuesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesDelete<TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesDelete>>,
          TError,
          Awaited<ReturnType<typeof queuesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesDelete<TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesDelete<TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesDeleteQueryOptions(queueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesDeleteQuery = async <TData = Awaited<ReturnType<typeof queuesDelete>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesDeleteQueryOptions(queueId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsTeamsAssigned = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamQueueResponse>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsTeamsAssignedQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams,) => {
    return [
    `/admin/queues/${queueId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsTeamsAssignedQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>> = ({ signal }) => queuesRelationsTeamsAssigned(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>>
export type QueuesRelationsTeamsAssignedQueryError = ClientError


export function useQueuesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsTeamsAssignedQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsTeamsAssignedQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsTeamsAssign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateTeamQueueResponse[]>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsTeamsAssignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/queues/${queueId}/teams`, numberString
    ] as const;
    }


export const getQueuesRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsTeamsAssignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>> = ({ signal }) => queuesRelationsTeamsAssign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>>
export type QueuesRelationsTeamsAssignQueryError = unknown


export function useQueuesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsTeamsAssignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsTeamsAssignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsTeamsUnassign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsTeamsUnassignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/queues/${queueId}/teams`, numberString
    ] as const;
    }


export const getQueuesRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsTeamsUnassignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>> = ({ signal }) => queuesRelationsTeamsUnassign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>>
export type QueuesRelationsTeamsUnassignQueryError = unknown


export function useQueuesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsTeamsUnassignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsTeamsUnassignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsTeamsAvailable = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsTeamsAvailableQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams,) => {
    return [
    `/admin/queues/${queueId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsTeamsAvailableQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>> = ({ signal }) => queuesRelationsTeamsAvailable(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>>
export type QueuesRelationsTeamsAvailableQueryError = unknown


export function useQueuesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsTeamsAvailableQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsTeamsAvailableQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsUsersAssigned = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserQueueDto>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsUsersAssignedQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams,) => {
    return [
    `/admin/queues/${queueId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsUsersAssignedQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>> = ({ signal }) => queuesRelationsUsersAssigned(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>>
export type QueuesRelationsUsersAssignedQueryError = ClientError


export function useQueuesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsUsersAssignedQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError = ClientError>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsUsersAssignedQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsUsersAssign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto[]>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsUsersAssignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/queues/${queueId}/users`, numberString
    ] as const;
    }


export const getQueuesRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsUsersAssignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>> = ({ signal }) => queuesRelationsUsersAssign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>>
export type QueuesRelationsUsersAssignQueryError = unknown


export function useQueuesRelationsUsersAssign<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAssign<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAssign<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsUsersAssign<TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsUsersAssignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsUsersAssignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsUsersUnassign = (
    queueId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getQueuesRelationsUsersUnassignQueryKey = (queueId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/queues/${queueId}/users`, numberString
    ] as const;
    }


export const getQueuesRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsUsersUnassignQueryKey(queueId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>> = ({ signal }) => queuesRelationsUsersUnassign(queueId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>>
export type QueuesRelationsUsersUnassignQueryError = unknown


export function useQueuesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(
 queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsUsersUnassignQueryOptions(queueId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsUsersUnassignQueryOptions(queueId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesRelationsUsersAvailable = (
    queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/queues/${encodeURIComponent(String(queueId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getQueuesRelationsUsersAvailableQueryKey = (queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams,) => {
    return [
    `/admin/queues/${queueId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getQueuesRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesRelationsUsersAvailableQueryKey(queueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>> = ({ signal }) => queuesRelationsUsersAvailable(queueId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>>
export type QueuesRelationsUsersAvailableQueryError = unknown


export function useQueuesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params: undefined |  QueuesRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(
 queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesRelationsUsersAvailableQueryOptions(queueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError = unknown>(
 queryClient: QueryClient, queueId: number | string | undefined | null,
    params?: QueuesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesRelationsUsersAvailableQueryOptions(queueId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesClientGet = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto[]>(
      {url: `/api/queues`, method: 'GET', signal
    },
      options);
    }




export const getQueuesClientGetQueryKey = () => {
    return [
    `/api/queues`
    ] as const;
    }


export const getQueuesClientGetQueryOptions = <TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesClientGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesClientGet>>> = ({ signal }) => queuesClientGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesClientGetQueryResult = NonNullable<Awaited<ReturnType<typeof queuesClientGet>>>
export type QueuesClientGetQueryError = ClientError


export function useQueuesClientGet<TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientGet>>,
          TError,
          Awaited<ReturnType<typeof queuesClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientGet<TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientGet>>,
          TError,
          Awaited<ReturnType<typeof queuesClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientGet<TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesClientGet<TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesClientGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesClientGetQuery = async <TData = Awaited<ReturnType<typeof queuesClientGet>>, TError = ClientError>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesClientGetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesClientPutQueueIdRegistration = (
    queueId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto>(
      {url: `/api/queues/${encodeURIComponent(String(queueId))}/registration`, method: 'PUT', signal
    },
      options);
    }




export const getQueuesClientPutQueueIdRegistrationQueryKey = (queueId: number | string | undefined | null,) => {
    return [
    'PUT', `/api/queues/${queueId}/registration`
    ] as const;
    }


export const getQueuesClientPutQueueIdRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesClientPutQueueIdRegistrationQueryKey(queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>> = ({ signal }) => queuesClientPutQueueIdRegistration(queueId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesClientPutQueueIdRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>>
export type QueuesClientPutQueueIdRegistrationQueryError = ClientError


export function useQueuesClientPutQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>,
          TError,
          Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientPutQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>,
          TError,
          Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientPutQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesClientPutQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesClientPutQueueIdRegistrationQueryOptions(queueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesClientPutQueueIdRegistrationQuery = async <TData = Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError = ClientError>(
 queryClient: QueryClient, queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientPutQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesClientPutQueueIdRegistrationQueryOptions(queueId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const queuesClientDeleteQueueIdRegistration = (
    queueId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserQueueDto>(
      {url: `/api/queues/${encodeURIComponent(String(queueId))}/registration`, method: 'DELETE', signal
    },
      options);
    }




export const getQueuesClientDeleteQueueIdRegistrationQueryKey = (queueId: number | string | undefined | null,) => {
    return [
    'DELETE', `/api/queues/${queueId}/registration`
    ] as const;
    }


export const getQueuesClientDeleteQueueIdRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueuesClientDeleteQueueIdRegistrationQueryKey(queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>> = ({ signal }) => queuesClientDeleteQueueIdRegistration(queueId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: queueId !== null && queueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueuesClientDeleteQueueIdRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>>
export type QueuesClientDeleteQueueIdRegistrationQueryError = ClientError


export function useQueuesClientDeleteQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>,
          TError,
          Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientDeleteQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>,
          TError,
          Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueuesClientDeleteQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useQueuesClientDeleteQueueIdRegistration<TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(
 queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueuesClientDeleteQueueIdRegistrationQueryOptions(queueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchQueuesClientDeleteQueueIdRegistrationQuery = async <TData = Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError = ClientError>(
 queryClient: QueryClient, queueId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queuesClientDeleteQueueIdRegistration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getQueuesClientDeleteQueueIdRegistrationQueryOptions(queueId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const permissionsRelationsRolesAssigned = (
    permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRolePermissionDto>(
      {url: `/admin/permissions/${encodeURIComponent(String(permissionId))}/roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPermissionsRelationsRolesAssignedQueryKey = (permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams,) => {
    return [
    `/admin/permissions/${permissionId}/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getPermissionsRelationsRolesAssignedQueryOptions = <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsRelationsRolesAssignedQueryKey(permissionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>> = ({ signal }) => permissionsRelationsRolesAssigned(permissionId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: permissionId !== null && permissionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsRelationsRolesAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>>
export type PermissionsRelationsRolesAssignedQueryError = unknown


export function usePermissionsRelationsRolesAssigned<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params: undefined |  PermissionsRelationsRolesAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAssigned<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAssigned<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsRelationsRolesAssigned<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsRelationsRolesAssignedQueryOptions(permissionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPermissionsRelationsRolesAssignedQuery = async <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError = unknown>(
 queryClient: QueryClient, permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPermissionsRelationsRolesAssignedQueryOptions(permissionId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const permissionsRelationsRolesAssign = (
    permissionId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RolePermissionDto[]>(
      {url: `/admin/permissions/${encodeURIComponent(String(permissionId))}/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPermissionsRelationsRolesAssignQueryKey = (permissionId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/permissions/${permissionId}/roles`, numberString
    ] as const;
    }


export const getPermissionsRelationsRolesAssignQueryOptions = <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsRelationsRolesAssignQueryKey(permissionId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>> = ({ signal }) => permissionsRelationsRolesAssign(permissionId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: permissionId !== null && permissionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsRelationsRolesAssignQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>>
export type PermissionsRelationsRolesAssignQueryError = unknown


export function usePermissionsRelationsRolesAssign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAssign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAssign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsRelationsRolesAssign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsRelationsRolesAssignQueryOptions(permissionId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPermissionsRelationsRolesAssignQuery = async <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError = unknown>(
 queryClient: QueryClient, permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPermissionsRelationsRolesAssignQueryOptions(permissionId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const permissionsRelationsRolesUnassign = (
    permissionId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/permissions/${encodeURIComponent(String(permissionId))}/roles`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPermissionsRelationsRolesUnassignQueryKey = (permissionId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/permissions/${permissionId}/roles`, numberString
    ] as const;
    }


export const getPermissionsRelationsRolesUnassignQueryOptions = <TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsRelationsRolesUnassignQueryKey(permissionId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>> = ({ signal }) => permissionsRelationsRolesUnassign(permissionId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: permissionId !== null && permissionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsRelationsRolesUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>>
export type PermissionsRelationsRolesUnassignQueryError = unknown


export function usePermissionsRelationsRolesUnassign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesUnassign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesUnassign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsRelationsRolesUnassign<TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsRelationsRolesUnassignQueryOptions(permissionId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPermissionsRelationsRolesUnassignQuery = async <TData = Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError = unknown>(
 queryClient: QueryClient, permissionId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPermissionsRelationsRolesUnassignQueryOptions(permissionId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const permissionsRelationsRolesAvailable = (
    permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRoleSummary>(
      {url: `/admin/permissions/${encodeURIComponent(String(permissionId))}/assignable-roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPermissionsRelationsRolesAvailableQueryKey = (permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams,) => {
    return [
    `/admin/permissions/${permissionId}/assignable-roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getPermissionsRelationsRolesAvailableQueryOptions = <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsRelationsRolesAvailableQueryKey(permissionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>> = ({ signal }) => permissionsRelationsRolesAvailable(permissionId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: permissionId !== null && permissionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsRelationsRolesAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>>
export type PermissionsRelationsRolesAvailableQueryError = unknown


export function usePermissionsRelationsRolesAvailable<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params: undefined |  PermissionsRelationsRolesAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAvailable<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>,
          TError,
          Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsRelationsRolesAvailable<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsRelationsRolesAvailable<TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(
 permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsRelationsRolesAvailableQueryOptions(permissionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPermissionsRelationsRolesAvailableQuery = async <TData = Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError = unknown>(
 queryClient: QueryClient, permissionId: number | string | undefined | null,
    params?: PermissionsRelationsRolesAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsRelationsRolesAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPermissionsRelationsRolesAvailableQueryOptions(permissionId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const permissionsList = (
    params?: PermissionsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfPermissionSummary>(
      {url: `/admin/permissions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPermissionsListQueryKey = (params?: PermissionsListParams,) => {
    return [
    `/admin/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getPermissionsListQueryOptions = <TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(params?: PermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsList>>> = ({ signal }) => permissionsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsList>>>
export type PermissionsListQueryError = ClientError


export function usePermissionsList<TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(
 params: undefined |  PermissionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsList>>,
          TError,
          Awaited<ReturnType<typeof permissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsList<TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(
 params?: PermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsList>>,
          TError,
          Awaited<ReturnType<typeof permissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsList<TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(
 params?: PermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsList<TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(
 params?: PermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPermissionsListQuery = async <TData = Awaited<ReturnType<typeof permissionsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: PermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPermissionsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsList = (
    params?: PauseReasonsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfPauseReasonSummary>(
      {url: `/admin/pausereasons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPauseReasonsListQueryKey = (params?: PauseReasonsListParams,) => {
    return [
    `/admin/pausereasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getPauseReasonsListQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(params?: PauseReasonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsList>>> = ({ signal }) => pauseReasonsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsListQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsList>>>
export type PauseReasonsListQueryError = ClientError


export function usePauseReasonsList<TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(
 params: undefined |  PauseReasonsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsList>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsList<TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(
 params?: PauseReasonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsList>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsList<TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(
 params?: PauseReasonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsList<TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(
 params?: PauseReasonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsListQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsList>>, TError = ClientError>(
 queryClient: QueryClient, params?: PauseReasonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsCreate = (
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PauseReasonSummary>(
      {url: `/admin/pausereasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePauseReasonRequest, signal
    },
      options);
    }




export const getPauseReasonsCreateQueryKey = (createOrUpdatePauseReasonRequest?: CreateOrUpdatePauseReasonRequest,) => {
    return [
    'POST', `/admin/pausereasons`, createOrUpdatePauseReasonRequest
    ] as const;
    }


export const getPauseReasonsCreateQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsCreateQueryKey(createOrUpdatePauseReasonRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsCreate>>> = ({ signal }) => pauseReasonsCreate(createOrUpdatePauseReasonRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsCreate>>>
export type PauseReasonsCreateQueryError = unknown


export function usePauseReasonsCreate<TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(
 createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsCreate>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsCreate<TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(
 createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsCreate>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsCreate<TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(
 createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsCreate<TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(
 createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsCreateQueryOptions(createOrUpdatePauseReasonRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsCreateQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsCreateQueryOptions(createOrUpdatePauseReasonRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsDetail = (
    pauseReasonId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PauseReasonDetails>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}`, method: 'GET', signal
    },
      options);
    }




export const getPauseReasonsDetailQueryKey = (pauseReasonId: number | undefined | null,) => {
    return [
    `/admin/pausereasons/${pauseReasonId}`
    ] as const;
    }


export const getPauseReasonsDetailQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(pauseReasonId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsDetailQueryKey(pauseReasonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsDetail>>> = ({ signal }) => pauseReasonsDetail(pauseReasonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsDetailQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsDetail>>>
export type PauseReasonsDetailQueryError = ClientError


export function usePauseReasonsDetail<TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(
 pauseReasonId: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsDetail>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsDetail<TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(
 pauseReasonId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsDetail>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsDetail<TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(
 pauseReasonId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsDetail<TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(
 pauseReasonId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsDetailQueryOptions(pauseReasonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsDetailQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsDetail>>, TError = ClientError>(
 queryClient: QueryClient, pauseReasonId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsDetailQueryOptions(pauseReasonId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsUpdate = (
    pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PauseReasonSummary>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePauseReasonRequest, signal
    },
      options);
    }




export const getPauseReasonsUpdateQueryKey = (pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest?: CreateOrUpdatePauseReasonRequest,) => {
    return [
    'PUT', `/admin/pausereasons/${pauseReasonId}`, createOrUpdatePauseReasonRequest
    ] as const;
    }


export const getPauseReasonsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsUpdateQueryKey(pauseReasonId,createOrUpdatePauseReasonRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsUpdate>>> = ({ signal }) => pauseReasonsUpdate(pauseReasonId,createOrUpdatePauseReasonRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsUpdate>>>
export type PauseReasonsUpdateQueryError = unknown


export function usePauseReasonsUpdate<TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsUpdate>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsUpdate<TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsUpdate>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsUpdate<TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsUpdate<TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsUpdateQueryOptions(pauseReasonId,createOrUpdatePauseReasonRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsUpdateQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    createOrUpdatePauseReasonRequest: CreateOrUpdatePauseReasonRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsUpdateQueryOptions(pauseReasonId,createOrUpdatePauseReasonRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsDelete = (
    pauseReasonId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getPauseReasonsDeleteQueryKey = (pauseReasonId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/pausereasons/${pauseReasonId}`
    ] as const;
    }


export const getPauseReasonsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(pauseReasonId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsDeleteQueryKey(pauseReasonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsDelete>>> = ({ signal }) => pauseReasonsDelete(pauseReasonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsDelete>>>
export type PauseReasonsDeleteQueryError = unknown


export function usePauseReasonsDelete<TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsDelete>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsDelete<TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsDelete>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsDelete<TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsDelete<TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsDeleteQueryOptions(pauseReasonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsDeleteQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsDelete>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsDeleteQueryOptions(pauseReasonId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsTeamsAssigned = (
    pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamPauseReasonResponse>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPauseReasonsRelationsTeamsAssignedQueryKey = (pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams,) => {
    return [
    `/admin/pausereasons/${pauseReasonId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getPauseReasonsRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsTeamsAssignedQueryKey(pauseReasonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>> = ({ signal }) => pauseReasonsRelationsTeamsAssigned(pauseReasonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>>
export type PauseReasonsRelationsTeamsAssignedQueryError = ClientError


export function usePauseReasonsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params: undefined |  PauseReasonsRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsTeamsAssignedQueryOptions(pauseReasonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsTeamsAssignedQueryOptions(pauseReasonId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsTeamsAssign = (
    pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamPauseReasonResponse[]>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPauseReasonsRelationsTeamsAssignQueryKey = (pauseReasonId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/pausereasons/${pauseReasonId}/teams`, numberString
    ] as const;
    }


export const getPauseReasonsRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsTeamsAssignQueryKey(pauseReasonId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>> = ({ signal }) => pauseReasonsRelationsTeamsAssign(pauseReasonId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>>
export type PauseReasonsRelationsTeamsAssignQueryError = unknown


export function usePauseReasonsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsTeamsAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsTeamsAssignQueryOptions(pauseReasonId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsTeamsAssignQueryOptions(pauseReasonId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsTeamsUnassign = (
    pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPauseReasonsRelationsTeamsUnassignQueryKey = (pauseReasonId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/pausereasons/${pauseReasonId}/teams`, numberString
    ] as const;
    }


export const getPauseReasonsRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsTeamsUnassignQueryKey(pauseReasonId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>> = ({ signal }) => pauseReasonsRelationsTeamsUnassign(pauseReasonId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>>
export type PauseReasonsRelationsTeamsUnassignQueryError = unknown


export function usePauseReasonsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsTeamsUnassignQueryOptions(pauseReasonId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsTeamsUnassignQueryOptions(pauseReasonId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsTeamsAvailable = (
    pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPauseReasonsRelationsTeamsAvailableQueryKey = (pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams,) => {
    return [
    `/admin/pausereasons/${pauseReasonId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getPauseReasonsRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsTeamsAvailableQueryKey(pauseReasonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>> = ({ signal }) => pauseReasonsRelationsTeamsAvailable(pauseReasonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>>
export type PauseReasonsRelationsTeamsAvailableQueryError = ClientError


export function usePauseReasonsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params: undefined |  PauseReasonsRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsTeamsAvailableQueryOptions(pauseReasonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError = ClientError>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsTeamsAvailableQueryOptions(pauseReasonId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsUsersAssigned = (
    pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserPauseReasonDto>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPauseReasonsRelationsUsersAssignedQueryKey = (pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams,) => {
    return [
    `/admin/pausereasons/${pauseReasonId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getPauseReasonsRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsUsersAssignedQueryKey(pauseReasonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>> = ({ signal }) => pauseReasonsRelationsUsersAssigned(pauseReasonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>>
export type PauseReasonsRelationsUsersAssignedQueryError = ClientError


export function usePauseReasonsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params: undefined |  PauseReasonsRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsUsersAssigned<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsUsersAssignedQueryOptions(pauseReasonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError = ClientError>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsUsersAssignedQueryOptions(pauseReasonId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsUsersAssign = (
    pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserPauseReasonDto[]>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPauseReasonsRelationsUsersAssignQueryKey = (pauseReasonId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/pausereasons/${pauseReasonId}/users`, numberString
    ] as const;
    }


export const getPauseReasonsRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsUsersAssignQueryKey(pauseReasonId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>> = ({ signal }) => pauseReasonsRelationsUsersAssign(pauseReasonId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>>
export type PauseReasonsRelationsUsersAssignQueryError = unknown


export function usePauseReasonsRelationsUsersAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsUsersAssign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsUsersAssignQueryOptions(pauseReasonId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsUsersAssignQueryOptions(pauseReasonId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsUsersUnassign = (
    pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getPauseReasonsRelationsUsersUnassignQueryKey = (pauseReasonId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/pausereasons/${pauseReasonId}/users`, numberString
    ] as const;
    }


export const getPauseReasonsRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsUsersUnassignQueryKey(pauseReasonId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>> = ({ signal }) => pauseReasonsRelationsUsersUnassign(pauseReasonId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>>
export type PauseReasonsRelationsUsersUnassignQueryError = unknown


export function usePauseReasonsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsUsersUnassign<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(
 pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsUsersUnassignQueryOptions(pauseReasonId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsUsersUnassignQueryOptions(pauseReasonId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsRelationsUsersAvailable = (
    pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/pausereasons/${encodeURIComponent(String(pauseReasonId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPauseReasonsRelationsUsersAvailableQueryKey = (pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams,) => {
    return [
    `/admin/pausereasons/${pauseReasonId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getPauseReasonsRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsRelationsUsersAvailableQueryKey(pauseReasonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>> = ({ signal }) => pauseReasonsRelationsUsersAvailable(pauseReasonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pauseReasonId !== null && pauseReasonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>>
export type PauseReasonsRelationsUsersAvailableQueryError = ClientError


export function usePauseReasonsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params: undefined |  PauseReasonsRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsRelationsUsersAvailable<TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(
 pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsRelationsUsersAvailableQueryOptions(pauseReasonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError = ClientError>(
 queryClient: QueryClient, pauseReasonId: number | string | undefined | null,
    params?: PauseReasonsRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsRelationsUsersAvailableQueryOptions(pauseReasonId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const pauseReasonsClientGet = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PauseReasonDto[]>(
      {url: `/api/pausereasons`, method: 'GET', signal
    },
      options);
    }




export const getPauseReasonsClientGetQueryKey = () => {
    return [
    `/api/pausereasons`
    ] as const;
    }


export const getPauseReasonsClientGetQueryOptions = <TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPauseReasonsClientGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pauseReasonsClientGet>>> = ({ signal }) => pauseReasonsClientGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PauseReasonsClientGetQueryResult = NonNullable<Awaited<ReturnType<typeof pauseReasonsClientGet>>>
export type PauseReasonsClientGetQueryError = ClientError


export function usePauseReasonsClientGet<TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsClientGet>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsClientGet<TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pauseReasonsClientGet>>,
          TError,
          Awaited<ReturnType<typeof pauseReasonsClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePauseReasonsClientGet<TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePauseReasonsClientGet<TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPauseReasonsClientGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPauseReasonsClientGetQuery = async <TData = Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError = ClientError>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pauseReasonsClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPauseReasonsClientGetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getMeBackstage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserPermissionResponse[]>(
      {url: `/me/backstage`, method: 'GET', signal
    },
      options);
    }




export const getGetMeBackstageQueryKey = () => {
    return [
    `/me/backstage`
    ] as const;
    }


export const getGetMeBackstageQueryOptions = <TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeBackstageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeBackstage>>> = ({ signal }) => getMeBackstage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeBackstageQueryResult = NonNullable<Awaited<ReturnType<typeof getMeBackstage>>>
export type GetMeBackstageQueryError = ClientError


export function useGetMeBackstage<TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeBackstage>>,
          TError,
          Awaited<ReturnType<typeof getMeBackstage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeBackstage<TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeBackstage>>,
          TError,
          Awaited<ReturnType<typeof getMeBackstage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeBackstage<TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeBackstage<TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeBackstageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetMeBackstageQuery = async <TData = Awaited<ReturnType<typeof getMeBackstage>>, TError = ClientError>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBackstage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMeBackstageQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getMeStage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserPermissionResponse[]>(
      {url: `/me/stage`, method: 'GET', signal
    },
      options);
    }




export const getGetMeStageQueryKey = () => {
    return [
    `/me/stage`
    ] as const;
    }


export const getGetMeStageQueryOptions = <TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeStageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeStage>>> = ({ signal }) => getMeStage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeStageQueryResult = NonNullable<Awaited<ReturnType<typeof getMeStage>>>
export type GetMeStageQueryError = ClientError


export function useGetMeStage<TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeStage>>,
          TError,
          Awaited<ReturnType<typeof getMeStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeStage<TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeStage>>,
          TError,
          Awaited<ReturnType<typeof getMeStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeStage<TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeStage<TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeStageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetMeStageQuery = async <TData = Awaited<ReturnType<typeof getMeStage>>, TError = ClientError>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMeStageQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsContactLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/settings/contact`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsContactLoadQueryKey = () => {
    return [
    `/admin/settings/contact`
    ] as const;
    }


export const getSettingsSettingsContactLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsContactLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsContactLoad>>> = ({ signal }) => settingsSettingsContactLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsContactLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsContactLoad>>>
export type SettingsSettingsContactLoadQueryError = unknown


export function useSettingsSettingsContactLoad<TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactLoad<TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactLoad<TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsContactLoad<TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsContactLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsContactLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsContactLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsContactUpdate = (
    createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/settings/contact`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsContactUpdateQueryKey = (createOrUpdateContactSettingsRequest?: CreateOrUpdateContactSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/contact`, createOrUpdateContactSettingsRequest
    ] as const;
    }


export const getSettingsSettingsContactUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsContactUpdateQueryKey(createOrUpdateContactSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>> = ({ signal }) => settingsSettingsContactUpdate(createOrUpdateContactSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsContactUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>>
export type SettingsSettingsContactUpdateQueryError = unknown


export function useSettingsSettingsContactUpdate<TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(
 createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactUpdate<TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(
 createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactUpdate<TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(
 createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsContactUpdate<TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(
 createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsContactUpdateQueryOptions(createOrUpdateContactSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsContactUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateContactSettingsRequest: CreateOrUpdateContactSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsContactUpdateQueryOptions(createOrUpdateContactSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsContactReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactSettingsDto>(
      {url: `/admin/settings/contact`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsContactResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/contact`
    ] as const;
    }


export const getSettingsSettingsContactResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsContactResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsContactReset>>> = ({ signal }) => settingsSettingsContactReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsContactResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsContactReset>>>
export type SettingsSettingsContactResetQueryError = unknown


export function useSettingsSettingsContactReset<TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactReset<TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsContactReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsContactReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsContactReset<TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsContactReset<TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsContactResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsContactResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsContactReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsContactResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsGeneralLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/settings/general`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsGeneralLoadQueryKey = () => {
    return [
    `/admin/settings/general`
    ] as const;
    }


export const getSettingsSettingsGeneralLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsGeneralLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>> = ({ signal }) => settingsSettingsGeneralLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsGeneralLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>>
export type SettingsSettingsGeneralLoadQueryError = unknown


export function useSettingsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsGeneralLoad<TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsGeneralLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsGeneralLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsGeneralLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsGeneralUpdate = (
    createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/settings/general`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateGeneralSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsGeneralUpdateQueryKey = (createOrUpdateGeneralSettingsRequest?: CreateOrUpdateGeneralSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/general`, createOrUpdateGeneralSettingsRequest
    ] as const;
    }


export const getSettingsSettingsGeneralUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsGeneralUpdateQueryKey(createOrUpdateGeneralSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>> = ({ signal }) => settingsSettingsGeneralUpdate(createOrUpdateGeneralSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsGeneralUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>>
export type SettingsSettingsGeneralUpdateQueryError = unknown


export function useSettingsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(
 createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(
 createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(
 createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsGeneralUpdate<TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(
 createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsGeneralUpdateQueryOptions(createOrUpdateGeneralSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsGeneralUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateGeneralSettingsRequest: CreateOrUpdateGeneralSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsGeneralUpdateQueryOptions(createOrUpdateGeneralSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsGeneralReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneralSettingsDto>(
      {url: `/admin/settings/general`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsGeneralResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/general`
    ] as const;
    }


export const getSettingsSettingsGeneralResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsGeneralResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>> = ({ signal }) => settingsSettingsGeneralReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsGeneralResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>>
export type SettingsSettingsGeneralResetQueryError = unknown


export function useSettingsSettingsGeneralReset<TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralReset<TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsGeneralReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsGeneralReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsGeneralReset<TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsGeneralReset<TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsGeneralResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsGeneralResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsGeneralReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsGeneralResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsLoginLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/settings/login`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsLoginLoadQueryKey = () => {
    return [
    `/admin/settings/login`
    ] as const;
    }


export const getSettingsSettingsLoginLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsLoginLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>> = ({ signal }) => settingsSettingsLoginLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsLoginLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>>
export type SettingsSettingsLoginLoadQueryError = unknown


export function useSettingsSettingsLoginLoad<TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginLoad<TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginLoad<TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsLoginLoad<TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsLoginLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsLoginLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsLoginLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsLoginUpdate = (
    createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/settings/login`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateLoginSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsLoginUpdateQueryKey = (createOrUpdateLoginSettingsRequest?: CreateOrUpdateLoginSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/login`, createOrUpdateLoginSettingsRequest
    ] as const;
    }


export const getSettingsSettingsLoginUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsLoginUpdateQueryKey(createOrUpdateLoginSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>> = ({ signal }) => settingsSettingsLoginUpdate(createOrUpdateLoginSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsLoginUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>>
export type SettingsSettingsLoginUpdateQueryError = unknown


export function useSettingsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(
 createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(
 createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(
 createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsLoginUpdate<TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(
 createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsLoginUpdateQueryOptions(createOrUpdateLoginSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsLoginUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateLoginSettingsRequest: CreateOrUpdateLoginSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsLoginUpdateQueryOptions(createOrUpdateLoginSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsLoginReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginSettingsDto>(
      {url: `/admin/settings/login`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsLoginResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/login`
    ] as const;
    }


export const getSettingsSettingsLoginResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsLoginResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsLoginReset>>> = ({ signal }) => settingsSettingsLoginReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsLoginResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsLoginReset>>>
export type SettingsSettingsLoginResetQueryError = unknown


export function useSettingsSettingsLoginReset<TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginReset<TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsLoginReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsLoginReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsLoginReset<TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsLoginReset<TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsLoginResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsLoginResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsLoginReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsLoginResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsPhoneLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/settings/phone`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsPhoneLoadQueryKey = () => {
    return [
    `/admin/settings/phone`
    ] as const;
    }


export const getSettingsSettingsPhoneLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsPhoneLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>> = ({ signal }) => settingsSettingsPhoneLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsPhoneLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>>
export type SettingsSettingsPhoneLoadQueryError = unknown


export function useSettingsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsPhoneLoad<TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsPhoneLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsPhoneLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsPhoneLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsPhoneUpdate = (
    createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/settings/phone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdatePhoneSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsPhoneUpdateQueryKey = (createOrUpdatePhoneSettingsRequest?: CreateOrUpdatePhoneSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/phone`, createOrUpdatePhoneSettingsRequest
    ] as const;
    }


export const getSettingsSettingsPhoneUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsPhoneUpdateQueryKey(createOrUpdatePhoneSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>> = ({ signal }) => settingsSettingsPhoneUpdate(createOrUpdatePhoneSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsPhoneUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>>
export type SettingsSettingsPhoneUpdateQueryError = unknown


export function useSettingsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(
 createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(
 createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(
 createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsPhoneUpdate<TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(
 createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsPhoneUpdateQueryOptions(createOrUpdatePhoneSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsPhoneUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdatePhoneSettingsRequest: CreateOrUpdatePhoneSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsPhoneUpdateQueryOptions(createOrUpdatePhoneSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsPhoneReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhoneSettingsDto>(
      {url: `/admin/settings/phone`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsPhoneResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/phone`
    ] as const;
    }


export const getSettingsSettingsPhoneResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsPhoneResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>> = ({ signal }) => settingsSettingsPhoneReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsPhoneResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>>
export type SettingsSettingsPhoneResetQueryError = unknown


export function useSettingsSettingsPhoneReset<TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneReset<TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsPhoneReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsPhoneReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsPhoneReset<TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsPhoneReset<TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsPhoneResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsPhoneResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsPhoneReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsPhoneResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsRecordingLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/settings/recording`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsRecordingLoadQueryKey = () => {
    return [
    `/admin/settings/recording`
    ] as const;
    }


export const getSettingsSettingsRecordingLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsRecordingLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>> = ({ signal }) => settingsSettingsRecordingLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsRecordingLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>>
export type SettingsSettingsRecordingLoadQueryError = unknown


export function useSettingsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsRecordingLoad<TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsRecordingLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsRecordingLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsRecordingLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsRecordingUpdate = (
    createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/settings/recording`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateRecordingSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsRecordingUpdateQueryKey = (createOrUpdateRecordingSettingsRequest?: CreateOrUpdateRecordingSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/recording`, createOrUpdateRecordingSettingsRequest
    ] as const;
    }


export const getSettingsSettingsRecordingUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsRecordingUpdateQueryKey(createOrUpdateRecordingSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>> = ({ signal }) => settingsSettingsRecordingUpdate(createOrUpdateRecordingSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsRecordingUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>>
export type SettingsSettingsRecordingUpdateQueryError = unknown


export function useSettingsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(
 createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(
 createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(
 createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsRecordingUpdate<TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(
 createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsRecordingUpdateQueryOptions(createOrUpdateRecordingSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsRecordingUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateRecordingSettingsRequest: CreateOrUpdateRecordingSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsRecordingUpdateQueryOptions(createOrUpdateRecordingSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsRecordingReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecordingSettingsDto>(
      {url: `/admin/settings/recording`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsRecordingResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/recording`
    ] as const;
    }


export const getSettingsSettingsRecordingResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsRecordingResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>> = ({ signal }) => settingsSettingsRecordingReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsRecordingResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>>
export type SettingsSettingsRecordingResetQueryError = unknown


export function useSettingsSettingsRecordingReset<TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingReset<TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsRecordingReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsRecordingReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsRecordingReset<TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsRecordingReset<TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsRecordingResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsRecordingResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsRecordingReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsRecordingResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsSetclipLoad = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/settings/setclip`, method: 'GET', signal
    },
      options);
    }




export const getSettingsSettingsSetclipLoadQueryKey = () => {
    return [
    `/admin/settings/setclip`
    ] as const;
    }


export const getSettingsSettingsSetclipLoadQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsSetclipLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>> = ({ signal }) => settingsSettingsSetclipLoad(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsSetclipLoadQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>>
export type SettingsSettingsSetclipLoadQueryError = unknown


export function useSettingsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsSetclipLoad<TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsSetclipLoadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsSetclipLoadQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipLoad>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsSetclipLoadQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsSetclipUpdate = (
    createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/settings/setclip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateSetClipSettingsRequest, signal
    },
      options);
    }




export const getSettingsSettingsSetclipUpdateQueryKey = (createOrUpdateSetClipSettingsRequest?: CreateOrUpdateSetClipSettingsRequest,) => {
    return [
    'PUT', `/admin/settings/setclip`, createOrUpdateSetClipSettingsRequest
    ] as const;
    }


export const getSettingsSettingsSetclipUpdateQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsSetclipUpdateQueryKey(createOrUpdateSetClipSettingsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>> = ({ signal }) => settingsSettingsSetclipUpdate(createOrUpdateSetClipSettingsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsSetclipUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>>
export type SettingsSettingsSetclipUpdateQueryError = unknown


export function useSettingsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(
 createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(
 createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(
 createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsSetclipUpdate<TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(
 createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsSetclipUpdateQueryOptions(createOrUpdateSetClipSettingsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsSetclipUpdateQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateSetClipSettingsRequest: CreateOrUpdateSetClipSettingsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsSetclipUpdateQueryOptions(createOrUpdateSetClipSettingsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const settingsSettingsSetclipReset = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetClipSettingsDto>(
      {url: `/admin/settings/setclip`, method: 'DELETE', signal
    },
      options);
    }




export const getSettingsSettingsSetclipResetQueryKey = () => {
    return [
    'DELETE', `/admin/settings/setclip`
    ] as const;
    }


export const getSettingsSettingsSetclipResetQueryOptions = <TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsSettingsSetclipResetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>> = ({ signal }) => settingsSettingsSetclipReset(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SettingsSettingsSetclipResetQueryResult = NonNullable<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>>
export type SettingsSettingsSetclipResetQueryError = unknown


export function useSettingsSettingsSetclipReset<TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipReset<TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof settingsSettingsSetclipReset>>,
          TError,
          Awaited<ReturnType<typeof settingsSettingsSetclipReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSettingsSettingsSetclipReset<TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSettingsSettingsSetclipReset<TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsSettingsSetclipResetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchSettingsSettingsSetclipResetQuery = async <TData = Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsSettingsSetclipReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getSettingsSettingsSetclipResetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesList = (
    params?: CustomPropertiesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPropertySummary>(
      {url: `/admin/customproperties`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPropertiesListQueryKey = (params?: CustomPropertiesListParams,) => {
    return [
    `/admin/customproperties`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPropertiesListQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(params?: CustomPropertiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesList>>> = ({ signal }) => customPropertiesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesListQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesList>>>
export type CustomPropertiesListQueryError = unknown


export function useCustomPropertiesList<TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(
 params: undefined |  CustomPropertiesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesList>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesList<TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(
 params?: CustomPropertiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesList>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesList<TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(
 params?: CustomPropertiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesList<TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(
 params?: CustomPropertiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesListQuery = async <TData = Awaited<ReturnType<typeof customPropertiesList>>, TError = unknown>(
 queryClient: QueryClient, params?: CustomPropertiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesCreate = (
    createCustomPropertyRequest: CreateCustomPropertyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyDto>(
      {url: `/admin/customproperties`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomPropertyRequest, signal
    },
      options);
    }




export const getCustomPropertiesCreateQueryKey = (createCustomPropertyRequest?: CreateCustomPropertyRequest,) => {
    return [
    'POST', `/admin/customproperties`, createCustomPropertyRequest
    ] as const;
    }


export const getCustomPropertiesCreateQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(createCustomPropertyRequest: CreateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesCreateQueryKey(createCustomPropertyRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesCreate>>> = ({ signal }) => customPropertiesCreate(createCustomPropertyRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesCreate>>>
export type CustomPropertiesCreateQueryError = unknown


export function useCustomPropertiesCreate<TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(
 createCustomPropertyRequest: CreateCustomPropertyRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesCreate>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesCreate<TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(
 createCustomPropertyRequest: CreateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesCreate>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesCreate<TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(
 createCustomPropertyRequest: CreateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesCreate<TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(
 createCustomPropertyRequest: CreateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesCreateQueryOptions(createCustomPropertyRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesCreateQuery = async <TData = Awaited<ReturnType<typeof customPropertiesCreate>>, TError = unknown>(
 queryClient: QueryClient, createCustomPropertyRequest: CreateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesCreateQueryOptions(createCustomPropertyRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesDetail = (
    customPropertyId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyDetails>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}`, method: 'GET', signal
    },
      options);
    }




export const getCustomPropertiesDetailQueryKey = (customPropertyId: number | string | undefined | null,) => {
    return [
    `/admin/customproperties/${customPropertyId}`
    ] as const;
    }


export const getCustomPropertiesDetailQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesDetailQueryKey(customPropertyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesDetail>>> = ({ signal }) => customPropertiesDetail(customPropertyId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesDetailQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesDetail>>>
export type CustomPropertiesDetailQueryError = unknown


export function useCustomPropertiesDetail<TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesDetail>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesDetail<TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesDetail>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesDetail<TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesDetail<TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesDetailQueryOptions(customPropertyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesDetailQuery = async <TData = Awaited<ReturnType<typeof customPropertiesDetail>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesDetailQueryOptions(customPropertyId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesUpdate = (
    customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyDto>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomPropertyRequest, signal
    },
      options);
    }




export const getCustomPropertiesUpdateQueryKey = (customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest?: UpdateCustomPropertyRequest,) => {
    return [
    'PUT', `/admin/customproperties/${customPropertyId}`, updateCustomPropertyRequest
    ] as const;
    }


export const getCustomPropertiesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesUpdateQueryKey(customPropertyId,updateCustomPropertyRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesUpdate>>> = ({ signal }) => customPropertiesUpdate(customPropertyId,updateCustomPropertyRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesUpdate>>>
export type CustomPropertiesUpdateQueryError = unknown


export function useCustomPropertiesUpdate<TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesUpdate>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesUpdate<TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesUpdate>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesUpdate<TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesUpdate<TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesUpdateQueryOptions(customPropertyId,updateCustomPropertyRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesUpdateQuery = async <TData = Awaited<ReturnType<typeof customPropertiesUpdate>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null,
    updateCustomPropertyRequest: UpdateCustomPropertyRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesUpdateQueryOptions(customPropertyId,updateCustomPropertyRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesDelete = (
    customPropertyId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getCustomPropertiesDeleteQueryKey = (customPropertyId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/customproperties/${customPropertyId}`
    ] as const;
    }


export const getCustomPropertiesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesDeleteQueryKey(customPropertyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesDelete>>> = ({ signal }) => customPropertiesDelete(customPropertyId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesDelete>>>
export type CustomPropertiesDeleteQueryError = unknown


export function useCustomPropertiesDelete<TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesDelete>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesDelete<TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesDelete>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesDelete<TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesDelete<TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(
 customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesDeleteQueryOptions(customPropertyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesDeleteQuery = async <TData = Awaited<ReturnType<typeof customPropertiesDelete>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesDeleteQueryOptions(customPropertyId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesRelationsRuleSetsAvailable = (
    customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfRuleSetSummary>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}/assignable-rulesets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPropertiesRelationsRuleSetsAvailableQueryKey = (customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams,) => {
    return [
    `/admin/customproperties/${customPropertyId}/assignable-rulesets`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPropertiesRelationsRuleSetsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesRelationsRuleSetsAvailableQueryKey(customPropertyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>> = ({ signal }) => customPropertiesRelationsRuleSetsAvailable(customPropertyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesRelationsRuleSetsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>>
export type CustomPropertiesRelationsRuleSetsAvailableQueryError = unknown


export function useCustomPropertiesRelationsRuleSetsAvailable<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    params: undefined |  CustomPropertiesRelationsRuleSetsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAvailable<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAvailable<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesRelationsRuleSetsAvailable<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAvailableQueryOptions(customPropertyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesRelationsRuleSetsAvailableQuery = async <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAvailableQueryOptions(customPropertyId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesRelationsRuleSetsAssigned = (
    customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPropertyRuleSetDto>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}/rulesets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPropertiesRelationsRuleSetsAssignedQueryKey = (customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams,) => {
    return [
    `/admin/customproperties/${customPropertyId}/rulesets`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPropertiesRelationsRuleSetsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesRelationsRuleSetsAssignedQueryKey(customPropertyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>> = ({ signal }) => customPropertiesRelationsRuleSetsAssigned(customPropertyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesRelationsRuleSetsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>>
export type CustomPropertiesRelationsRuleSetsAssignedQueryError = ClientError


export function useCustomPropertiesRelationsRuleSetsAssigned<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(
 customPropertyId: number | string | undefined | null,
    params: undefined |  CustomPropertiesRelationsRuleSetsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAssigned<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAssigned<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesRelationsRuleSetsAssigned<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(
 customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAssignedQueryOptions(customPropertyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesRelationsRuleSetsAssignedQuery = async <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError = ClientError>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null,
    params?: CustomPropertiesRelationsRuleSetsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAssignedQueryOptions(customPropertyId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesRelationsRuleSetsAssign = (
    customPropertyId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyRuleSetDto[]>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}/rulesets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPropertiesRelationsRuleSetsAssignQueryKey = (customPropertyId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/customproperties/${customPropertyId}/rulesets`, numberString
    ] as const;
    }


export const getCustomPropertiesRelationsRuleSetsAssignQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesRelationsRuleSetsAssignQueryKey(customPropertyId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>> = ({ signal }) => customPropertiesRelationsRuleSetsAssign(customPropertyId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesRelationsRuleSetsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>>
export type CustomPropertiesRelationsRuleSetsAssignQueryError = unknown


export function useCustomPropertiesRelationsRuleSetsAssign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAssign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsAssign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesRelationsRuleSetsAssign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAssignQueryOptions(customPropertyId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesRelationsRuleSetsAssignQuery = async <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesRelationsRuleSetsAssignQueryOptions(customPropertyId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesRelationsRuleSetsUnassign = (
    customPropertyId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/customproperties/${encodeURIComponent(String(customPropertyId))}/rulesets`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPropertiesRelationsRuleSetsUnassignQueryKey = (customPropertyId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/customproperties/${customPropertyId}/rulesets`, numberString
    ] as const;
    }


export const getCustomPropertiesRelationsRuleSetsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesRelationsRuleSetsUnassignQueryKey(customPropertyId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>> = ({ signal }) => customPropertiesRelationsRuleSetsUnassign(customPropertyId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPropertyId !== null && customPropertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesRelationsRuleSetsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>>
export type CustomPropertiesRelationsRuleSetsUnassignQueryError = unknown


export function useCustomPropertiesRelationsRuleSetsUnassign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsUnassign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesRelationsRuleSetsUnassign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesRelationsRuleSetsUnassign<TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(
 customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesRelationsRuleSetsUnassignQueryOptions(customPropertyId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesRelationsRuleSetsUnassignQuery = async <TData = Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError = unknown>(
 queryClient: QueryClient, customPropertyId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesRelationsRuleSetsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesRelationsRuleSetsUnassignQueryOptions(customPropertyId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesClientGet = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyDto[]>(
      {url: `/api/customproperties`, method: 'GET', signal
    },
      options);
    }




export const getCustomPropertiesClientGetQueryKey = () => {
    return [
    `/api/customproperties`
    ] as const;
    }


export const getCustomPropertiesClientGetQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesClientGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesClientGet>>> = ({ signal }) => customPropertiesClientGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesClientGetQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesClientGet>>>
export type CustomPropertiesClientGetQueryError = unknown


export function useCustomPropertiesClientGet<TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesClientGet>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesClientGet<TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesClientGet>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesClientGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesClientGet<TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesClientGet<TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesClientGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesClientGetQuery = async <TData = Awaited<ReturnType<typeof customPropertiesClientGet>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesClientGetQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPropertiesClientPost = (
    createCustomPropertiesRequest: CreateCustomPropertiesRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPropertyDto[]>(
      {url: `/api/customproperties`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomPropertiesRequest, signal
    },
      options);
    }




export const getCustomPropertiesClientPostQueryKey = (createCustomPropertiesRequest?: CreateCustomPropertiesRequest,) => {
    return [
    'POST', `/api/customproperties`, createCustomPropertiesRequest
    ] as const;
    }


export const getCustomPropertiesClientPostQueryOptions = <TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(createCustomPropertiesRequest: CreateCustomPropertiesRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPropertiesClientPostQueryKey(createCustomPropertiesRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPropertiesClientPost>>> = ({ signal }) => customPropertiesClientPost(createCustomPropertiesRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPropertiesClientPostQueryResult = NonNullable<Awaited<ReturnType<typeof customPropertiesClientPost>>>
export type CustomPropertiesClientPostQueryError = unknown


export function useCustomPropertiesClientPost<TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(
 createCustomPropertiesRequest: CreateCustomPropertiesRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesClientPost>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesClientPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesClientPost<TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(
 createCustomPropertiesRequest: CreateCustomPropertiesRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPropertiesClientPost>>,
          TError,
          Awaited<ReturnType<typeof customPropertiesClientPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPropertiesClientPost<TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(
 createCustomPropertiesRequest: CreateCustomPropertiesRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPropertiesClientPost<TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(
 createCustomPropertiesRequest: CreateCustomPropertiesRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPropertiesClientPostQueryOptions(createCustomPropertiesRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPropertiesClientPostQuery = async <TData = Awaited<ReturnType<typeof customPropertiesClientPost>>, TError = unknown>(
 queryClient: QueryClient, createCustomPropertiesRequest: CreateCustomPropertiesRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPropertiesClientPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPropertiesClientPostQueryOptions(createCustomPropertiesRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesList = (
    params?: CustomPagesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfCustomPageDto>(
      {url: `/admin/custompages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPagesListQueryKey = (params?: CustomPagesListParams,) => {
    return [
    `/admin/custompages`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPagesListQueryOptions = <TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(params?: CustomPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesList>>> = ({ signal }) => customPagesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesListQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesList>>>
export type CustomPagesListQueryError = unknown


export function useCustomPagesList<TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(
 params: undefined |  CustomPagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesList>>,
          TError,
          Awaited<ReturnType<typeof customPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesList<TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(
 params?: CustomPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesList>>,
          TError,
          Awaited<ReturnType<typeof customPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesList<TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(
 params?: CustomPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesList<TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(
 params?: CustomPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesListQuery = async <TData = Awaited<ReturnType<typeof customPagesList>>, TError = unknown>(
 queryClient: QueryClient, params?: CustomPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesCreate = (
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPageDto>(
      {url: `/admin/custompages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateCustomPageRequest, signal
    },
      options);
    }




export const getCustomPagesCreateQueryKey = (createOrUpdateCustomPageRequest?: CreateOrUpdateCustomPageRequest,) => {
    return [
    'POST', `/admin/custompages`, createOrUpdateCustomPageRequest
    ] as const;
    }


export const getCustomPagesCreateQueryOptions = <TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesCreateQueryKey(createOrUpdateCustomPageRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesCreate>>> = ({ signal }) => customPagesCreate(createOrUpdateCustomPageRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesCreate>>>
export type CustomPagesCreateQueryError = unknown


export function useCustomPagesCreate<TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(
 createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesCreate>>,
          TError,
          Awaited<ReturnType<typeof customPagesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesCreate<TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(
 createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesCreate>>,
          TError,
          Awaited<ReturnType<typeof customPagesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesCreate<TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(
 createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesCreate<TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(
 createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesCreateQueryOptions(createOrUpdateCustomPageRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesCreateQuery = async <TData = Awaited<ReturnType<typeof customPagesCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesCreateQueryOptions(createOrUpdateCustomPageRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesUpdate = (
    customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CustomPageDto>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateCustomPageRequest, signal
    },
      options);
    }




export const getCustomPagesUpdateQueryKey = (customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest?: CreateOrUpdateCustomPageRequest,) => {
    return [
    'PUT', `/admin/custompages/${customPageId}`, createOrUpdateCustomPageRequest
    ] as const;
    }


export const getCustomPagesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesUpdateQueryKey(customPageId,createOrUpdateCustomPageRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesUpdate>>> = ({ signal }) => customPagesUpdate(customPageId,createOrUpdateCustomPageRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesUpdate>>>
export type CustomPagesUpdateQueryError = unknown


export function useCustomPagesUpdate<TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesUpdate>>,
          TError,
          Awaited<ReturnType<typeof customPagesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesUpdate<TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesUpdate>>,
          TError,
          Awaited<ReturnType<typeof customPagesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesUpdate<TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesUpdate<TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesUpdateQueryOptions(customPageId,createOrUpdateCustomPageRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesUpdateQuery = async <TData = Awaited<ReturnType<typeof customPagesUpdate>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    createOrUpdateCustomPageRequest: CreateOrUpdateCustomPageRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesUpdateQueryOptions(customPageId,createOrUpdateCustomPageRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesDelete = (
    customPageId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getCustomPagesDeleteQueryKey = (customPageId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/custompages/${customPageId}`
    ] as const;
    }


export const getCustomPagesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(customPageId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesDeleteQueryKey(customPageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesDelete>>> = ({ signal }) => customPagesDelete(customPageId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesDelete>>>
export type CustomPagesDeleteQueryError = unknown


export function useCustomPagesDelete<TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(
 customPageId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesDelete>>,
          TError,
          Awaited<ReturnType<typeof customPagesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesDelete<TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(
 customPageId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesDelete>>,
          TError,
          Awaited<ReturnType<typeof customPagesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesDelete<TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(
 customPageId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesDelete<TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(
 customPageId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesDeleteQueryOptions(customPageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesDeleteQuery = async <TData = Awaited<ReturnType<typeof customPagesDelete>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesDeleteQueryOptions(customPageId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsTeamsAssigned = (
    customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamCustomPageResponse>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPagesRelationsTeamsAssignedQueryKey = (customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams,) => {
    return [
    `/admin/custompages/${customPageId}/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPagesRelationsTeamsAssignedQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsTeamsAssignedQueryKey(customPageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>> = ({ signal }) => customPagesRelationsTeamsAssigned(customPageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsTeamsAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>>
export type CustomPagesRelationsTeamsAssignedQueryError = unknown


export function useCustomPagesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params: undefined |  CustomPagesRelationsTeamsAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsTeamsAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsTeamsAssignedQueryOptions(customPageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsTeamsAssignedQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsTeamsAssignedQueryOptions(customPageId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsTeamsAssign = (
    customPageId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TeamCustomPageResponse[]>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPagesRelationsTeamsAssignQueryKey = (customPageId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/custompages/${customPageId}/teams`, numberString
    ] as const;
    }


export const getCustomPagesRelationsTeamsAssignQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsTeamsAssignQueryKey(customPageId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>> = ({ signal }) => customPagesRelationsTeamsAssign(customPageId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsTeamsAssignQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>>
export type CustomPagesRelationsTeamsAssignQueryError = unknown


export function useCustomPagesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsTeamsAssign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsTeamsAssignQueryOptions(customPageId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsTeamsAssignQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsTeamsAssignQueryOptions(customPageId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsTeamsUnassign = (
    customPageId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/teams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPagesRelationsTeamsUnassignQueryKey = (customPageId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/custompages/${customPageId}/teams`, numberString
    ] as const;
    }


export const getCustomPagesRelationsTeamsUnassignQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsTeamsUnassignQueryKey(customPageId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>> = ({ signal }) => customPagesRelationsTeamsUnassign(customPageId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsTeamsUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>>
export type CustomPagesRelationsTeamsUnassignQueryError = unknown


export function useCustomPagesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsTeamsUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsTeamsUnassignQueryOptions(customPageId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsTeamsUnassignQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsTeamsUnassignQueryOptions(customPageId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsTeamsAvailable = (
    customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfTeamSummary>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/assignable-teams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPagesRelationsTeamsAvailableQueryKey = (customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams,) => {
    return [
    `/admin/custompages/${customPageId}/assignable-teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPagesRelationsTeamsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsTeamsAvailableQueryKey(customPageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>> = ({ signal }) => customPagesRelationsTeamsAvailable(customPageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsTeamsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>>
export type CustomPagesRelationsTeamsAvailableQueryError = unknown


export function useCustomPagesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params: undefined |  CustomPagesRelationsTeamsAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsTeamsAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsTeamsAvailableQueryOptions(customPageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsTeamsAvailableQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsTeamsAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsTeamsAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsTeamsAvailableQueryOptions(customPageId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsUsersAssigned = (
    customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserCustomPageDto>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPagesRelationsUsersAssignedQueryKey = (customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams,) => {
    return [
    `/admin/custompages/${customPageId}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPagesRelationsUsersAssignedQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsUsersAssignedQueryKey(customPageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>> = ({ signal }) => customPagesRelationsUsersAssigned(customPageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsUsersAssignedQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>>
export type CustomPagesRelationsUsersAssignedQueryError = unknown


export function useCustomPagesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params: undefined |  CustomPagesRelationsUsersAssignedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsUsersAssigned<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsUsersAssignedQueryOptions(customPageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsUsersAssignedQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAssignedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssigned>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsUsersAssignedQueryOptions(customPageId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsUsersAssign = (
    customPageId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserCustomPageDto[]>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPagesRelationsUsersAssignQueryKey = (customPageId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'POST', `/admin/custompages/${customPageId}/users`, numberString
    ] as const;
    }


export const getCustomPagesRelationsUsersAssignQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsUsersAssignQueryKey(customPageId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>> = ({ signal }) => customPagesRelationsUsersAssign(customPageId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsUsersAssignQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>>
export type CustomPagesRelationsUsersAssignQueryError = unknown


export function useCustomPagesRelationsUsersAssign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAssign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAssign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsUsersAssign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsUsersAssignQueryOptions(customPageId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsUsersAssignQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAssign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsUsersAssignQueryOptions(customPageId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsUsersUnassign = (
    customPageId: number | string | undefined | null,
    numberString: (number | string)[],
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: numberString, signal
    },
      options);
    }




export const getCustomPagesRelationsUsersUnassignQueryKey = (customPageId: number | string | undefined | null,
    numberString?: (number | string)[],) => {
    return [
    'DELETE', `/admin/custompages/${customPageId}/users`, numberString
    ] as const;
    }


export const getCustomPagesRelationsUsersUnassignQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsUsersUnassignQueryKey(customPageId,numberString);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>> = ({ signal }) => customPagesRelationsUsersUnassign(customPageId,numberString, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsUsersUnassignQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>>
export type CustomPagesRelationsUsersUnassignQueryError = unknown


export function useCustomPagesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsUsersUnassign<TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsUsersUnassignQueryOptions(customPageId,numberString,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsUsersUnassignQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    numberString: (number | string)[], options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersUnassign>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsUsersUnassignQueryOptions(customPageId,numberString,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const customPagesRelationsUsersAvailable = (
    customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfUserDto>(
      {url: `/admin/custompages/${encodeURIComponent(String(customPageId))}/assignable-users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCustomPagesRelationsUsersAvailableQueryKey = (customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams,) => {
    return [
    `/admin/custompages/${customPageId}/assignable-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getCustomPagesRelationsUsersAvailableQueryOptions = <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomPagesRelationsUsersAvailableQueryKey(customPageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>> = ({ signal }) => customPagesRelationsUsersAvailable(customPageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customPageId !== null && customPageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomPagesRelationsUsersAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>>
export type CustomPagesRelationsUsersAvailableQueryError = unknown


export function useCustomPagesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params: undefined |  CustomPagesRelationsUsersAvailableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>,
          TError,
          Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomPagesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomPagesRelationsUsersAvailable<TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(
 customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomPagesRelationsUsersAvailableQueryOptions(customPageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchCustomPagesRelationsUsersAvailableQuery = async <TData = Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError = unknown>(
 queryClient: QueryClient, customPageId: number | string | undefined | null,
    params?: CustomPagesRelationsUsersAvailableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customPagesRelationsUsersAvailable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getCustomPagesRelationsUsersAvailableQueryOptions(customPageId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getAdminContactCodesContactCodeIdAssignableContactcodetrees = (
    contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeTreeSummary>(
      {url: `/admin/contactcodes/${encodeURIComponent(String(contactCodeId))}/assignable-contactcodetrees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryKey = (contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams,) => {
    return [
    `/admin/contactcodes/${contactCodeId}/assignable-contactcodetrees`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryKey(contactCodeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>> = ({ signal }) => getAdminContactCodesContactCodeIdAssignableContactcodetrees(contactCodeId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeId !== null && contactCodeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>>
export type GetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryError = unknown


export function useGetAdminContactCodesContactCodeIdAssignableContactcodetrees<TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    params: undefined |  GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodesContactCodeIdAssignableContactcodetrees<TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodesContactCodeIdAssignableContactcodetrees<TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminContactCodesContactCodeIdAssignableContactcodetrees<TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryOptions(contactCodeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetAdminContactCodesContactCodeIdAssignableContactcodetreesQuery = async <TData = Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError = unknown>(
 queryClient: QueryClient, contactCodeId: number | string | undefined | null,
    params?: GetAdminContactCodesContactCodeIdAssignableContactcodetreesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodesContactCodeIdAssignableContactcodetrees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminContactCodesContactCodeIdAssignableContactcodetreesQueryOptions(contactCodeId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const contactCodesList = (
    params?: ContactCodesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeResponse>(
      {url: `/admin/contactcodes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getContactCodesListQueryKey = (params?: ContactCodesListParams,) => {
    return [
    `/admin/contactcodes`, ...(params ? [params] : [])
    ] as const;
    }


export const getContactCodesListQueryOptions = <TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(params?: ContactCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactCodesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactCodesList>>> = ({ signal }) => contactCodesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof contactCodesList>>>
export type ContactCodesListQueryError = unknown


export function useContactCodesList<TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(
 params: undefined |  ContactCodesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodesList>>,
          TError,
          Awaited<ReturnType<typeof contactCodesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodesList<TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(
 params?: ContactCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodesList>>,
          TError,
          Awaited<ReturnType<typeof contactCodesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodesList<TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(
 params?: ContactCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactCodesList<TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(
 params?: ContactCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactCodesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchContactCodesListQuery = async <TData = Awaited<ReturnType<typeof contactCodesList>>, TError = unknown>(
 queryClient: QueryClient, params?: ContactCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getContactCodesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const contactCodesCreate = (
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeResponse>(
      {url: `/admin/contactcodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactCodeRequest, signal
    },
      options);
    }




export const getContactCodesCreateQueryKey = (createOrUpdateContactCodeRequest?: CreateOrUpdateContactCodeRequest,) => {
    return [
    'POST', `/admin/contactcodes`, createOrUpdateContactCodeRequest
    ] as const;
    }


export const getContactCodesCreateQueryOptions = <TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactCodesCreateQueryKey(createOrUpdateContactCodeRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactCodesCreate>>> = ({ signal }) => contactCodesCreate(createOrUpdateContactCodeRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactCodesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof contactCodesCreate>>>
export type ContactCodesCreateQueryError = unknown


export function useContactCodesCreate<TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(
 createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodesCreate>>,
          TError,
          Awaited<ReturnType<typeof contactCodesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodesCreate<TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(
 createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodesCreate>>,
          TError,
          Awaited<ReturnType<typeof contactCodesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodesCreate<TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(
 createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactCodesCreate<TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(
 createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactCodesCreateQueryOptions(createOrUpdateContactCodeRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchContactCodesCreateQuery = async <TData = Awaited<ReturnType<typeof contactCodesCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getContactCodesCreateQueryOptions(createOrUpdateContactCodeRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminContactCodesContactCodeId = (
    contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeResponse>(
      {url: `/admin/contactcodes/${encodeURIComponent(String(contactCodeId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactCodeRequest, signal
    },
      options);
    }




export const getPutAdminContactCodesContactCodeIdQueryKey = (contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest?: CreateOrUpdateContactCodeRequest,) => {
    return [
    'PUT', `/admin/contactcodes/${contactCodeId}`, createOrUpdateContactCodeRequest
    ] as const;
    }


export const getPutAdminContactCodesContactCodeIdQueryOptions = <TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminContactCodesContactCodeIdQueryKey(contactCodeId,createOrUpdateContactCodeRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>> = ({ signal }) => putAdminContactCodesContactCodeId(contactCodeId,createOrUpdateContactCodeRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeId !== null && contactCodeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminContactCodesContactCodeIdQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>>
export type PutAdminContactCodesContactCodeIdQueryError = unknown


export function usePutAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminContactCodesContactCodeIdQueryOptions(contactCodeId,createOrUpdateContactCodeRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminContactCodesContactCodeIdQuery = async <TData = Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError = unknown>(
 queryClient: QueryClient, contactCodeId: number | string | undefined | null,
    createOrUpdateContactCodeRequest: CreateOrUpdateContactCodeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminContactCodesContactCodeIdQueryOptions(contactCodeId,createOrUpdateContactCodeRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const deleteAdminContactCodesContactCodeId = (
    contactCodeId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/contactcodes/${encodeURIComponent(String(contactCodeId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminContactCodesContactCodeIdQueryKey = (contactCodeId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/contactcodes/${contactCodeId}`
    ] as const;
    }


export const getDeleteAdminContactCodesContactCodeIdQueryOptions = <TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(contactCodeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteAdminContactCodesContactCodeIdQueryKey(contactCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>> = ({ signal }) => deleteAdminContactCodesContactCodeId(contactCodeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeId !== null && contactCodeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteAdminContactCodesContactCodeIdQueryResult = NonNullable<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>>
export type DeleteAdminContactCodesContactCodeIdQueryError = unknown


export function useDeleteAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDeleteAdminContactCodesContactCodeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(
 contactCodeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteAdminContactCodesContactCodeIdQueryOptions(contactCodeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchDeleteAdminContactCodesContactCodeIdQuery = async <TData = Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError = unknown>(
 queryClient: QueryClient, contactCodeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodesContactCodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getDeleteAdminContactCodesContactCodeIdQueryOptions(contactCodeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes = (
    contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeResponse>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/assignable-contactcodes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryKey = (contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams,) => {
    return [
    `/admin/contactcodetrees/${contactCodeTreeId}/assignable-contactcodes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryKey(contactCodeTreeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>> = ({ signal }) => getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes(contactCodeTreeId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>>
export type GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryError = unknown


export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params: undefined |  GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryOptions(contactCodeTreeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQuery = async <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableContactcodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdAssignableContactcodesQueryOptions(contactCodeTreeId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getAdminContactCodeTreesContactCodeTreeIdQueues = (
    contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeTreeQueue>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminContactCodeTreesContactCodeTreeIdQueuesQueryKey = (contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams,) => {
    return [
    `/admin/contactcodetrees/${contactCodeTreeId}/queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminContactCodeTreesContactCodeTreeIdQueuesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactCodeTreesContactCodeTreeIdQueuesQueryKey(contactCodeTreeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>> = ({ signal }) => getAdminContactCodeTreesContactCodeTreeIdQueues(contactCodeTreeId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContactCodeTreesContactCodeTreeIdQueuesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>>
export type GetAdminContactCodeTreesContactCodeTreeIdQueuesQueryError = unknown


export function useGetAdminContactCodeTreesContactCodeTreeIdQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params: undefined |  GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminContactCodeTreesContactCodeTreeIdQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdQueuesQueryOptions(contactCodeTreeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetAdminContactCodeTreesContactCodeTreeIdQueuesQuery = async <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdQueuesQueryOptions(contactCodeTreeId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getAdminContactCodeTreesContactCodeTreeIdAssignableQueues = (
    contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfQueueSummary>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/assignable-queues`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryKey = (contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams,) => {
    return [
    `/admin/contactcodetrees/${contactCodeTreeId}/assignable-queues`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryKey(contactCodeTreeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>> = ({ signal }) => getAdminContactCodeTreesContactCodeTreeIdAssignableQueues(contactCodeTreeId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>>
export type GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryError = unknown


export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params: undefined |  GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminContactCodeTreesContactCodeTreeIdAssignableQueues<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryOptions(contactCodeTreeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQuery = async <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null,
    params?: GetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdAssignableQueues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdAssignableQueuesQueryOptions(contactCodeTreeId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const contactCodeTreesList = (
    params?: ContactCodeTreesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfContactCodeTreeSummary>(
      {url: `/admin/contactcodetrees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getContactCodeTreesListQueryKey = (params?: ContactCodeTreesListParams,) => {
    return [
    `/admin/contactcodetrees`, ...(params ? [params] : [])
    ] as const;
    }


export const getContactCodeTreesListQueryOptions = <TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(params?: ContactCodeTreesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactCodeTreesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactCodeTreesList>>> = ({ signal }) => contactCodeTreesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactCodeTreesListQueryResult = NonNullable<Awaited<ReturnType<typeof contactCodeTreesList>>>
export type ContactCodeTreesListQueryError = unknown


export function useContactCodeTreesList<TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(
 params: undefined |  ContactCodeTreesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodeTreesList>>,
          TError,
          Awaited<ReturnType<typeof contactCodeTreesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodeTreesList<TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(
 params?: ContactCodeTreesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodeTreesList>>,
          TError,
          Awaited<ReturnType<typeof contactCodeTreesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodeTreesList<TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(
 params?: ContactCodeTreesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactCodeTreesList<TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(
 params?: ContactCodeTreesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactCodeTreesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchContactCodeTreesListQuery = async <TData = Awaited<ReturnType<typeof contactCodeTreesList>>, TError = unknown>(
 queryClient: QueryClient, params?: ContactCodeTreesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getContactCodeTreesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const contactCodeTreesCreate = (
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeSummary>(
      {url: `/admin/contactcodetrees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactCodeTreeRequest, signal
    },
      options);
    }




export const getContactCodeTreesCreateQueryKey = (createOrUpdateContactCodeTreeRequest?: CreateOrUpdateContactCodeTreeRequest,) => {
    return [
    'POST', `/admin/contactcodetrees`, createOrUpdateContactCodeTreeRequest
    ] as const;
    }


export const getContactCodeTreesCreateQueryOptions = <TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactCodeTreesCreateQueryKey(createOrUpdateContactCodeTreeRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactCodeTreesCreate>>> = ({ signal }) => contactCodeTreesCreate(createOrUpdateContactCodeTreeRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactCodeTreesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof contactCodeTreesCreate>>>
export type ContactCodeTreesCreateQueryError = unknown


export function useContactCodeTreesCreate<TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(
 createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodeTreesCreate>>,
          TError,
          Awaited<ReturnType<typeof contactCodeTreesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodeTreesCreate<TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(
 createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactCodeTreesCreate>>,
          TError,
          Awaited<ReturnType<typeof contactCodeTreesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactCodeTreesCreate<TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(
 createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactCodeTreesCreate<TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(
 createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactCodeTreesCreateQueryOptions(createOrUpdateContactCodeTreeRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchContactCodeTreesCreateQuery = async <TData = Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError = unknown>(
 queryClient: QueryClient, createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactCodeTreesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getContactCodeTreesCreateQueryOptions(createOrUpdateContactCodeTreeRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminContactCodeTreesContactCodeTreeId = (
    contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeSummary>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateContactCodeTreeRequest, signal
    },
      options);
    }




export const getPutAdminContactCodeTreesContactCodeTreeIdQueryKey = (contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest?: CreateOrUpdateContactCodeTreeRequest,) => {
    return [
    'PUT', `/admin/contactcodetrees/${contactCodeTreeId}`, createOrUpdateContactCodeTreeRequest
    ] as const;
    }


export const getPutAdminContactCodeTreesContactCodeTreeIdQueryOptions = <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminContactCodeTreesContactCodeTreeIdQueryKey(contactCodeTreeId,createOrUpdateContactCodeTreeRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>> = ({ signal }) => putAdminContactCodeTreesContactCodeTreeId(contactCodeTreeId,createOrUpdateContactCodeTreeRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminContactCodeTreesContactCodeTreeIdQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>>
export type PutAdminContactCodeTreesContactCodeTreeIdQueryError = unknown


export function usePutAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdQueryOptions(contactCodeTreeId,createOrUpdateContactCodeTreeRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminContactCodeTreesContactCodeTreeIdQuery = async <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null,
    createOrUpdateContactCodeTreeRequest: CreateOrUpdateContactCodeTreeRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdQueryOptions(contactCodeTreeId,createOrUpdateContactCodeTreeRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const deleteAdminContactCodeTreesContactCodeTreeId = (
    contactCodeTreeId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminContactCodeTreesContactCodeTreeIdQueryKey = (contactCodeTreeId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/contactcodetrees/${contactCodeTreeId}`
    ] as const;
    }


export const getDeleteAdminContactCodeTreesContactCodeTreeIdQueryOptions = <TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteAdminContactCodeTreesContactCodeTreeIdQueryKey(contactCodeTreeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>> = ({ signal }) => deleteAdminContactCodeTreesContactCodeTreeId(contactCodeTreeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteAdminContactCodeTreesContactCodeTreeIdQueryResult = NonNullable<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>>
export type DeleteAdminContactCodeTreesContactCodeTreeIdQueryError = unknown


export function useDeleteAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDeleteAdminContactCodeTreesContactCodeTreeId<TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteAdminContactCodeTreesContactCodeTreeIdQueryOptions(contactCodeTreeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchDeleteAdminContactCodeTreesContactCodeTreeIdQuery = async <TData = Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminContactCodeTreesContactCodeTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getDeleteAdminContactCodeTreesContactCodeTreeIdQueryOptions(contactCodeTreeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminContactCodeTreesContactCodeTreeIdItems = (
    contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeSummary>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/items`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContactCodeTreeWithChildrenRequest, signal
    },
      options);
    }




export const getPutAdminContactCodeTreesContactCodeTreeIdItemsQueryKey = (contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest?: UpdateContactCodeTreeWithChildrenRequest,) => {
    return [
    'PUT', `/admin/contactcodetrees/${contactCodeTreeId}/items`, updateContactCodeTreeWithChildrenRequest
    ] as const;
    }


export const getPutAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions = <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminContactCodeTreesContactCodeTreeIdItemsQueryKey(contactCodeTreeId,updateContactCodeTreeWithChildrenRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>> = ({ signal }) => putAdminContactCodeTreesContactCodeTreeIdItems(contactCodeTreeId,updateContactCodeTreeWithChildrenRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminContactCodeTreesContactCodeTreeIdItemsQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>>
export type PutAdminContactCodeTreesContactCodeTreeIdItemsQueryError = unknown


export function usePutAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions(contactCodeTreeId,updateContactCodeTreeWithChildrenRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminContactCodeTreesContactCodeTreeIdItemsQuery = async <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null,
    updateContactCodeTreeWithChildrenRequest: UpdateContactCodeTreeWithChildrenRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions(contactCodeTreeId,updateContactCodeTreeWithChildrenRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const getAdminContactCodeTreesContactCodeTreeIdItems = (
    contactCodeTreeId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeRoot>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/items`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminContactCodeTreesContactCodeTreeIdItemsQueryKey = (contactCodeTreeId: number | string | undefined | null,) => {
    return [
    `/admin/contactcodetrees/${contactCodeTreeId}/items`
    ] as const;
    }


export const getGetAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactCodeTreesContactCodeTreeIdItemsQueryKey(contactCodeTreeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>> = ({ signal }) => getAdminContactCodeTreesContactCodeTreeIdItems(contactCodeTreeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContactCodeTreesContactCodeTreeIdItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>>
export type GetAdminContactCodeTreesContactCodeTreeIdItemsQueryError = unknown


export function useGetAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>,
          TError,
          Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminContactCodeTreesContactCodeTreeIdItems<TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions(contactCodeTreeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchGetAdminContactCodeTreesContactCodeTreeIdItemsQuery = async <TData = Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContactCodeTreesContactCodeTreeIdItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminContactCodeTreesContactCodeTreeIdItemsQueryOptions(contactCodeTreeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminContactCodeTreesContactCodeTreeIdDefault = (
    contactCodeTreeId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ContactCodeTreeSummary>(
      {url: `/admin/contactcodetrees/${encodeURIComponent(String(contactCodeTreeId))}/default`, method: 'PUT', signal
    },
      options);
    }




export const getPutAdminContactCodeTreesContactCodeTreeIdDefaultQueryKey = (contactCodeTreeId: number | string | undefined | null,) => {
    return [
    'PUT', `/admin/contactcodetrees/${contactCodeTreeId}/default`
    ] as const;
    }


export const getPutAdminContactCodeTreesContactCodeTreeIdDefaultQueryOptions = <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminContactCodeTreesContactCodeTreeIdDefaultQueryKey(contactCodeTreeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>> = ({ signal }) => putAdminContactCodeTreesContactCodeTreeIdDefault(contactCodeTreeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: contactCodeTreeId !== null && contactCodeTreeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminContactCodeTreesContactCodeTreeIdDefaultQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>>
export type PutAdminContactCodeTreesContactCodeTreeIdDefaultQueryError = unknown


export function usePutAdminContactCodeTreesContactCodeTreeIdDefault<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeIdDefault<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>,
          TError,
          Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminContactCodeTreesContactCodeTreeIdDefault<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminContactCodeTreesContactCodeTreeIdDefault<TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(
 contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdDefaultQueryOptions(contactCodeTreeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminContactCodeTreesContactCodeTreeIdDefaultQuery = async <TData = Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError = unknown>(
 queryClient: QueryClient, contactCodeTreeId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminContactCodeTreesContactCodeTreeIdDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminContactCodeTreesContactCodeTreeIdDefaultQueryOptions(contactCodeTreeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const colorDefinitionsList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ColorDefinitionDto[]>(
      {url: `/admin/colordefinitions`, method: 'GET', signal
    },
      options);
    }




export const getColorDefinitionsListQueryKey = () => {
    return [
    `/admin/colordefinitions`
    ] as const;
    }


export const getColorDefinitionsListQueryOptions = <TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getColorDefinitionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof colorDefinitionsList>>> = ({ signal }) => colorDefinitionsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ColorDefinitionsListQueryResult = NonNullable<Awaited<ReturnType<typeof colorDefinitionsList>>>
export type ColorDefinitionsListQueryError = unknown


export function useColorDefinitionsList<TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof colorDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof colorDefinitionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useColorDefinitionsList<TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof colorDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof colorDefinitionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useColorDefinitionsList<TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useColorDefinitionsList<TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getColorDefinitionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchColorDefinitionsListQuery = async <TData = Awaited<ReturnType<typeof colorDefinitionsList>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof colorDefinitionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getColorDefinitionsListQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const putAdminColorDefinitions = (
    updateColorDefinitionsRequest: UpdateColorDefinitionsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ColorDefinitionDto[]>(
      {url: `/admin/colordefinitions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateColorDefinitionsRequest, signal
    },
      options);
    }




export const getPutAdminColorDefinitionsQueryKey = (updateColorDefinitionsRequest?: UpdateColorDefinitionsRequest,) => {
    return [
    'PUT', `/admin/colordefinitions`, updateColorDefinitionsRequest
    ] as const;
    }


export const getPutAdminColorDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPutAdminColorDefinitionsQueryKey(updateColorDefinitionsRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof putAdminColorDefinitions>>> = ({ signal }) => putAdminColorDefinitions(updateColorDefinitionsRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PutAdminColorDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof putAdminColorDefinitions>>>
export type PutAdminColorDefinitionsQueryError = unknown


export function usePutAdminColorDefinitions<TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(
 updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminColorDefinitions>>,
          TError,
          Awaited<ReturnType<typeof putAdminColorDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminColorDefinitions<TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(
 updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putAdminColorDefinitions>>,
          TError,
          Awaited<ReturnType<typeof putAdminColorDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePutAdminColorDefinitions<TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(
 updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePutAdminColorDefinitions<TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(
 updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPutAdminColorDefinitionsQueryOptions(updateColorDefinitionsRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchPutAdminColorDefinitionsQuery = async <TData = Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError = unknown>(
 queryClient: QueryClient, updateColorDefinitionsRequest: UpdateColorDefinitionsRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof putAdminColorDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getPutAdminColorDefinitionsQueryOptions(updateColorDefinitionsRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const absencesList = (
    params?: AbsencesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfAbsenceDetails>(
      {url: `/admin/absences`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAbsencesListQueryKey = (params?: AbsencesListParams,) => {
    return [
    `/admin/absences`, ...(params ? [params] : [])
    ] as const;
    }


export const getAbsencesListQueryOptions = <TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(params?: AbsencesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsencesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof absencesList>>> = ({ signal }) => absencesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AbsencesListQueryResult = NonNullable<Awaited<ReturnType<typeof absencesList>>>
export type AbsencesListQueryError = unknown


export function useAbsencesList<TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(
 params: undefined |  AbsencesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesList>>,
          TError,
          Awaited<ReturnType<typeof absencesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesList<TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(
 params?: AbsencesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesList>>,
          TError,
          Awaited<ReturnType<typeof absencesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesList<TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(
 params?: AbsencesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAbsencesList<TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(
 params?: AbsencesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAbsencesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchAbsencesListQuery = async <TData = Awaited<ReturnType<typeof absencesList>>, TError = unknown>(
 queryClient: QueryClient, params?: AbsencesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getAbsencesListQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const absencesCreate = (
    createAbsenceRequest: CreateAbsenceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfAbsenceDetails>(
      {url: `/admin/absences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAbsenceRequest, signal
    },
      options);
    }




export const getAbsencesCreateQueryKey = (createAbsenceRequest?: CreateAbsenceRequest,) => {
    return [
    'POST', `/admin/absences`, createAbsenceRequest
    ] as const;
    }


export const getAbsencesCreateQueryOptions = <TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(createAbsenceRequest: CreateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsencesCreateQueryKey(createAbsenceRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof absencesCreate>>> = ({ signal }) => absencesCreate(createAbsenceRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AbsencesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof absencesCreate>>>
export type AbsencesCreateQueryError = unknown


export function useAbsencesCreate<TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(
 createAbsenceRequest: CreateAbsenceRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesCreate>>,
          TError,
          Awaited<ReturnType<typeof absencesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesCreate<TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(
 createAbsenceRequest: CreateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesCreate>>,
          TError,
          Awaited<ReturnType<typeof absencesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesCreate<TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(
 createAbsenceRequest: CreateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAbsencesCreate<TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(
 createAbsenceRequest: CreateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAbsencesCreateQueryOptions(createAbsenceRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchAbsencesCreateQuery = async <TData = Awaited<ReturnType<typeof absencesCreate>>, TError = unknown>(
 queryClient: QueryClient, createAbsenceRequest: CreateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesCreate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getAbsencesCreateQueryOptions(createAbsenceRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const absencesUpdate = (
    absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PagedResultOfAbsenceDetails>(
      {url: `/admin/absences/${encodeURIComponent(String(absencesId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAbsenceRequest, signal
    },
      options);
    }




export const getAbsencesUpdateQueryKey = (absencesId: number | string | undefined | null,
    updateAbsenceRequest?: UpdateAbsenceRequest,) => {
    return [
    'PUT', `/admin/absences/${absencesId}`, updateAbsenceRequest
    ] as const;
    }


export const getAbsencesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsencesUpdateQueryKey(absencesId,updateAbsenceRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof absencesUpdate>>> = ({ signal }) => absencesUpdate(absencesId,updateAbsenceRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: absencesId !== null && absencesId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AbsencesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof absencesUpdate>>>
export type AbsencesUpdateQueryError = unknown


export function useAbsencesUpdate<TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(
 absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesUpdate>>,
          TError,
          Awaited<ReturnType<typeof absencesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesUpdate<TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(
 absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesUpdate>>,
          TError,
          Awaited<ReturnType<typeof absencesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesUpdate<TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(
 absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAbsencesUpdate<TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(
 absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAbsencesUpdateQueryOptions(absencesId,updateAbsenceRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchAbsencesUpdateQuery = async <TData = Awaited<ReturnType<typeof absencesUpdate>>, TError = unknown>(
 queryClient: QueryClient, absencesId: number | string | undefined | null,
    updateAbsenceRequest: UpdateAbsenceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesUpdate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getAbsencesUpdateQueryOptions(absencesId,updateAbsenceRequest,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const absencesDelete = (
    absencesId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/absences/${encodeURIComponent(String(absencesId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getAbsencesDeleteQueryKey = (absencesId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/absences/${absencesId}`
    ] as const;
    }


export const getAbsencesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(absencesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsencesDeleteQueryKey(absencesId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof absencesDelete>>> = ({ signal }) => absencesDelete(absencesId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: absencesId !== null && absencesId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AbsencesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof absencesDelete>>>
export type AbsencesDeleteQueryError = unknown


export function useAbsencesDelete<TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(
 absencesId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesDelete>>,
          TError,
          Awaited<ReturnType<typeof absencesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesDelete<TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(
 absencesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absencesDelete>>,
          TError,
          Awaited<ReturnType<typeof absencesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAbsencesDelete<TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(
 absencesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAbsencesDelete<TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(
 absencesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAbsencesDeleteQueryOptions(absencesId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchAbsencesDeleteQuery = async <TData = Awaited<ReturnType<typeof absencesDelete>>, TError = unknown>(
 queryClient: QueryClient, absencesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absencesDelete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getAbsencesDeleteQueryOptions(absencesId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






export const deleteAdminAbsencesSeriesAbsenceSeriesId = (
    absenceSeriesId: number | string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/absences/series/${encodeURIComponent(String(absenceSeriesId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminAbsencesSeriesAbsenceSeriesIdQueryKey = (absenceSeriesId: number | string | undefined | null,) => {
    return [
    'DELETE', `/admin/absences/series/${absenceSeriesId}`
    ] as const;
    }


export const getDeleteAdminAbsencesSeriesAbsenceSeriesIdQueryOptions = <TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(absenceSeriesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteAdminAbsencesSeriesAbsenceSeriesIdQueryKey(absenceSeriesId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>> = ({ signal }) => deleteAdminAbsencesSeriesAbsenceSeriesId(absenceSeriesId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: absenceSeriesId !== null && absenceSeriesId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteAdminAbsencesSeriesAbsenceSeriesIdQueryResult = NonNullable<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>>
export type DeleteAdminAbsencesSeriesAbsenceSeriesIdQueryError = unknown


export function useDeleteAdminAbsencesSeriesAbsenceSeriesId<TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(
 absenceSeriesId: number | string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminAbsencesSeriesAbsenceSeriesId<TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(
 absenceSeriesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>,
          TError,
          Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteAdminAbsencesSeriesAbsenceSeriesId<TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(
 absenceSeriesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDeleteAdminAbsencesSeriesAbsenceSeriesId<TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(
 absenceSeriesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteAdminAbsencesSeriesAbsenceSeriesIdQueryOptions(absenceSeriesId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const prefetchDeleteAdminAbsencesSeriesAbsenceSeriesIdQuery = async <TData = Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError = unknown>(
 queryClient: QueryClient, absenceSeriesId: number | string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteAdminAbsencesSeriesAbsenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getDeleteAdminAbsencesSeriesAbsenceSeriesIdQueryOptions(absenceSeriesId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}
